
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("b1LyM", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8074ae20237824cf$export$2e2bcd8739ae039; });

var $f53LC = parcelRequire("f53LC");

var $kk9vf = parcelRequire("kk9vf");

var $eB84S = parcelRequire("eB84S");

var $x4tot = parcelRequire("x4tot");
function $8074ae20237824cf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8074ae20237824cf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8074ae20237824cf$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8074ae20237824cf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8074ae20237824cf$var$isThemeColorMode = function isThemeColorMode(colorMode) {
    return (0, $eB84S.themeColorModes).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};
var $8074ae20237824cf$var$getGlobalTheme = function getGlobalTheme() {
    if (typeof document === 'undefined') return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $kk9vf.COLOR_MODE_ATTRIBUTE)) || '';
    var theme = element.getAttribute((0, $kk9vf.THEME_DATA_ATTRIBUTE)) || '';
    return $8074ae20237824cf$var$_objectSpread($8074ae20237824cf$var$_objectSpread({}, (0, $x4tot.themeStringToObject)(theme)), $8074ae20237824cf$var$isThemeColorMode(colorMode) && {
        colorMode: colorMode
    });
};
var $8074ae20237824cf$export$2e2bcd8739ae039 = $8074ae20237824cf$var$getGlobalTheme;

});
parcelRegister("eB84S", function(module, exports) {
$parcel$export(module.exports, "themeColorModes", function () { return $aa0ac975ab47c970$export$83993de8eb66733; });
/**
 * Theme modes: The general purpose of a theme.
 * This attr is used to apply the appropriate system-preference option
 * It may also be used as a selector for mode-specific overrides such as light/dark images.
 * The idea is there may exist many color themes, but every theme must either fit into light or dark.
 */ var $aa0ac975ab47c970$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];

});

parcelRegister("x4tot", function(module, exports) {
$parcel$export(module.exports, "themeStringToObject", function () { return $06368d71ea073595$export$f19b488f7c0547ee; });

var $2qaZZ = parcelRequire("2qaZZ");

var $GaGfW = parcelRequire("GaGfW");

var $6ZteM = parcelRequire("6ZteM");

var $cITI0 = parcelRequire("cITI0");
var $06368d71ea073595$var$customThemeOptions = 'UNSAFE_themeOptions';
var $06368d71ea073595$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(' ')// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, $2qaZZ.default)(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === 'colorMode' && (0, $GaGfW.isColorMode)(id)) themeObject[kind] = id;
        if ((0, $cITI0.isThemeKind)(kind) && (0, $6ZteM.isThemeIds)(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $06368d71ea073595$var$customThemeOptions) try {
            themeObject[$06368d71ea073595$var$customThemeOptions] = JSON.parse(id);
        } catch (_unused) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};

});
parcelRegister("GaGfW", function(module, exports) {
$parcel$export(module.exports, "isColorMode", function () { return $07ec354b0ac1b790$export$4a14e169b1de4ee7; });
var $07ec354b0ac1b790$export$4a14e169b1de4ee7 = function isColorMode(modeId) {
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};

});

parcelRegister("6ZteM", function(module, exports) {
$parcel$export(module.exports, "isThemeIds", function () { return $516f1e7e9b09422e$export$ea35b8958c39dd07; });

var $5Ugwr = parcelRequire("5Ugwr");
var $516f1e7e9b09422e$export$ea35b8958c39dd07 = function isThemeIds(themeId) {
    return (0, $5Ugwr.themeIds).find(function(id) {
        return id === themeId;
    }) !== undefined;
};

});
parcelRegister("5Ugwr", function(module, exports) {
$parcel$export(module.exports, "themeIds", function () { return $44ceffb433ef2b45$export$7d43e72a58e3283f; });
/**
 * Theme ids: The value that will be mounted to the DOM as a data attr
 * For example: `data-theme="light:light dark:dark spacing:spacing"
 *
 * These ids must be kebab case
 */ var $44ceffb433ef2b45$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'spacing',
    'shape',
    'typography',
    'motion'
];

});


parcelRegister("cITI0", function(module, exports) {
$parcel$export(module.exports, "isThemeKind", function () { return $9434ceb29aa8c231$export$958fa026be3a263e; });
var $9434ceb29aa8c231$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape',
    'motion'
];
var $9434ceb29aa8c231$export$958fa026be3a263e = function isThemeKind(themeKind) {
    return $9434ceb29aa8c231$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};

});



parcelRegister("eIrG8", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ab6aa524d9461fc8$export$2e2bcd8739ae039; });
/* inline.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $5kYca = parcelRequire("5kYca");

var $8erHf = parcelRequire("8erHf");

var $1166l = parcelRequire("1166l");
var $ab6aa524d9461fc8$var$_excluded = [
    "as",
    "alignInline",
    "alignBlock",
    "shouldWrap",
    "spread",
    "grow",
    "space",
    "rowSpace",
    "separator",
    "xcss",
    "testId",
    "role",
    "children"
];
var $ab6aa524d9461fc8$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
var $ab6aa524d9461fc8$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        className: (0, $5kYca.default)([
            $ab6aa524d9461fc8$var$styles.separator
        ])
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $ab6aa524d9461fc8$var$Inline = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children, ariaAttributes = (0, $gnQ3X.default)(_ref2, $ab6aa524d9461fc8$var$_excluded);
    var separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ $1oC0p.createElement($ab6aa524d9461fc8$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $1oC0p.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return /*#__PURE__*/ $1oC0p.createElement((0, $1oC0p.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    return /*#__PURE__*/ $1oC0p.createElement((0, $1166l.default), (0, $c9bqK.default)({}, ariaAttributes, {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: (0, $8erHf.cx)(grow === 'hug' && $ab6aa524d9461fc8$var$styles.hug, grow === 'fill' && $ab6aa524d9461fc8$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }), children);
}));
$ab6aa524d9461fc8$var$Inline.displayName = 'Inline';
var $ab6aa524d9461fc8$export$2e2bcd8739ae039 = $ab6aa524d9461fc8$var$Inline;

});
parcelRegister("5kYca", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3e2d838bc51e96a8$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $3e2d838bc51e96a8$var$ATOMIC_GROUP_LENGTH = 5;
function $3e2d838bc51e96a8$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $3e2d838bc51e96a8$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});

parcelRegister("8erHf", function(module, exports) {
$parcel$export(module.exports, "cx", function () { return $5fe51d82d4537364$export$a274e22fb40f762e; });
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ parcelRequire("1oC0p");


var $18HP1 = parcelRequire("18HP1");
var $5fe51d82d4537364$var$strictApi = (0, $18HP1.createStrictAPI)();
var $5fe51d82d4537364$export$dbf350e5966cf602 = $5fe51d82d4537364$var$strictApi.css;
var $5fe51d82d4537364$export$eb1ecd84a24ee424 = $5fe51d82d4537364$var$strictApi.cssMap;
$5fe51d82d4537364$var$strictApi.cssMap;
var $5fe51d82d4537364$export$a274e22fb40f762e = $5fe51d82d4537364$var$strictApi.cx;
var $5fe51d82d4537364$var$XCSSProp = $5fe51d82d4537364$var$strictApi.XCSSProp; // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means apps only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 

});
parcelRegister("18HP1", function(module, exports) {
$parcel$export(module.exports, "createStrictAPI", function () { return $0d4887e9bbd887e2$export$39716b4af53f4ad; });

var $1mmoU = parcelRequire("1mmoU");

var $fS7ur = parcelRequire("fS7ur");
function $0d4887e9bbd887e2$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $1mmoU.createStrictSetupError)();
        },
        cssMap () {
            throw (0, $1mmoU.createStrictSetupError)();
        },
        cx: $fS7ur.cx,
        XCSSProp () {
            throw (0, $1mmoU.createStrictSetupError)();
        }
    };
}

});
parcelRegister("1mmoU", function(module, exports) {
$parcel$export(module.exports, "createStrictSetupError", function () { return $0fd938d6ab14ccf8$export$c4df1cb0c2b4d77c; });
const $0fd938d6ab14ccf8$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $0fd938d6ab14ccf8$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

});

parcelRegister("fS7ur", function(module, exports) {
$parcel$export(module.exports, "cx", function () { return $b8e1b58479a1dd7f$export$a274e22fb40f762e; });

var $ecC5v = parcelRequire("ecC5v");
const $b8e1b58479a1dd7f$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $ecC5v.default)(actualStyles);
};

});
parcelRegister("ecC5v", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a56fbb1f1af39755$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $a56fbb1f1af39755$var$ATOMIC_GROUP_LENGTH = 5;
function $a56fbb1f1af39755$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $a56fbb1f1af39755$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});




parcelRegister("1166l", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0bda9e0fd0ca94b7$export$2e2bcd8739ae039; });
/* flex.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $5kYca = parcelRequire("5kYca");
var $0bda9e0fd0ca94b7$var$_excluded = [
    "as",
    "role",
    "alignItems",
    "justifyContent",
    "gap",
    "columnGap",
    "rowGap",
    "children",
    "testId",
    "direction",
    "wrap",
    "xcss"
];
var $0bda9e0fd0ca94b7$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
var $0bda9e0fd0ca94b7$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
var $0bda9e0fd0ca94b7$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
var $0bda9e0fd0ca94b7$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
var $0bda9e0fd0ca94b7$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
var $0bda9e0fd0ca94b7$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
var $0bda9e0fd0ca94b7$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $0bda9e0fd0ca94b7$var$Flex = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, ariaAttributes = (0, $gnQ3X.default)(_ref, $0bda9e0fd0ca94b7$var$_excluded);
    return /*#__PURE__*/ $1oC0p.createElement(Component, (0, $c9bqK.default)({}, ariaAttributes, {
        role: role,
        className: (0, $5kYca.default)([
            $0bda9e0fd0ca94b7$var$styles.root,
            gap && $0bda9e0fd0ca94b7$var$columnGapMap[gap],
            columnGap && $0bda9e0fd0ca94b7$var$columnGapMap[columnGap],
            gap && $0bda9e0fd0ca94b7$var$rowGapMap[gap],
            rowGap && $0bda9e0fd0ca94b7$var$rowGapMap[rowGap],
            alignItems && $0bda9e0fd0ca94b7$var$alignItemsMap[alignItems],
            direction && $0bda9e0fd0ca94b7$var$flexDirectionMap[direction],
            justifyContent && $0bda9e0fd0ca94b7$var$justifyContentMap[justifyContent],
            wrap && $0bda9e0fd0ca94b7$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }), children);
}));
$0bda9e0fd0ca94b7$var$Flex.displayName = 'Flex';
var $0bda9e0fd0ca94b7$export$2e2bcd8739ae039 = $0bda9e0fd0ca94b7$var$Flex;

});


parcelRegister("8LHZg", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6624d57691018653$export$2e2bcd8739ae039; });
/* stack.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");


var $8erHf = parcelRequire("8erHf");

var $1166l = parcelRequire("1166l");
var $6624d57691018653$var$_excluded = [
    "as",
    "alignInline",
    "alignBlock",
    "spread",
    "grow",
    "space",
    "children",
    "testId",
    "xcss",
    "role"
];
var $6624d57691018653$var$styles = {
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $6624d57691018653$var$Stack = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? 'stretch' : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role, ariaAttributes = (0, $gnQ3X.default)(_ref, $6624d57691018653$var$_excluded);
    return /*#__PURE__*/ $1oC0p.createElement((0, $1166l.default), (0, $c9bqK.default)({}, ariaAttributes, {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: spread || alignBlock,
        xcss: (0, $8erHf.cx)(grow === 'hug' && $6624d57691018653$var$styles.hug, grow === 'fill' && $6624d57691018653$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }), children);
}));
$6624d57691018653$var$Stack.displayName = 'Stack';
var $6624d57691018653$export$2e2bcd8739ae039 = $6624d57691018653$var$Stack;

});

parcelRegister("eRtiE", function(module, exports) {
$parcel$export(module.exports, "Products", function () { return $ad1cbe41ef1adcea$export$92e44ea1079b9ec6; });
var $ad1cbe41ef1adcea$export$92e44ea1079b9ec6 = {
    JIRA: 'jira',
    CONFLUENCE: 'confluence',
    JIRA_PRODUCT_DISCOVERY: 'jira-product-discovery',
    JIRA_SERVICE_MANAGEMENT: 'jira-service-management',
    BITBUCKET: 'bitbucket'
};

});

parcelRegister("8wHjQ", function(module, exports) {
$parcel$export(module.exports, "Background", function () { return $6352ea28593a180b$export$668799e4797757a8; });
/* background.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $1oC0p = parcelRequire("1oC0p");

var $8LHZg = parcelRequire("8LHZg");
var $6352ea28593a180b$var$styles = {
    background: "_bfhkvuon _4t3i1osq"
};
var $6352ea28593a180b$export$668799e4797757a8 = function Background(_ref) {
    var children = _ref.children, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $8LHZg.default), {
        xcss: $6352ea28593a180b$var$styles.background,
        testId: testId
    }, children);
};

});

parcelRegister("dqpnA", function(module, exports) {
$parcel$export(module.exports, "TopNav", function () { return $9c6163ea9aae6457$export$41d0d88a6b0e456f; });
/* top-nav.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $f53LC = parcelRequire("f53LC");


var $1oC0p = parcelRequire("1oC0p");

var $hmHYY = parcelRequire("hmHYY");

var $1KdrI = parcelRequire("1KdrI");

var $3Qdh0 = parcelRequire("3Qdh0");

var $26Uhh = parcelRequire("26Uhh");

var $hRvtK = parcelRequire("hRvtK");

var $dAHaV = parcelRequire("dAHaV");

var $cHzJP = parcelRequire("cHzJP");

var $6A2DX = parcelRequire("6A2DX");

var $iPbQS = parcelRequire("iPbQS");
var $eIrG8 = parcelRequire("eIrG8");

var $eRtiE = parcelRequire("eRtiE");

var $80D8g = parcelRequire("80D8g");
var $9c6163ea9aae6457$var$styles = {
    wrapper: "_18zrv47k _n7zlia51 _1tkeckbl _1bsb1osq",
    search: "_195goahv _1bsb1osq",
    searchBar: "_2rko1qi0 _19itia51 _18zru2gc _4t3izwfg _1bsb1osq _p12fcv93 _1ul91178",
    createButton: "_2rko1qi0 _4t3izwfg _1bsbys9h _bfhk1dy8",
    createButtonText: "_2rko1qi0 _4t3ii2wt _1bsb1ady",
    chatButton: "_2rko1qi0 _19itia51 _4t3izwfg _1bsbcae7",
    chatButtonText: "_2rko1qi0 _4t3ii2wt _1bsbzwfg"
};
var $9c6163ea9aae6457$var$ProductLogos = (0, $f53LC.default)((0, $f53LC.default)((0, $f53LC.default)((0, $f53LC.default)((0, $f53LC.default)({}, (0, $eRtiE.Products).JIRA, (0, $6A2DX.JiraLogo)), (0, $eRtiE.Products).CONFLUENCE, (0, $6A2DX.ConfluenceLogo)), (0, $eRtiE.Products).JIRA_PRODUCT_DISCOVERY, (0, $6A2DX.JiraProductDiscoveryLogo)), (0, $eRtiE.Products).JIRA_SERVICE_MANAGEMENT, (0, $6A2DX.JiraServiceManagementLogo)), (0, $eRtiE.Products).BITBUCKET, (0, $6A2DX.BitbucketLogo));
var $9c6163ea9aae6457$var$ProductIcons = (0, $f53LC.default)((0, $f53LC.default)((0, $f53LC.default)((0, $f53LC.default)((0, $f53LC.default)({}, (0, $eRtiE.Products).JIRA, (0, $6A2DX.JiraIcon)), (0, $eRtiE.Products).CONFLUENCE, (0, $6A2DX.ConfluenceIcon)), (0, $eRtiE.Products).JIRA_PRODUCT_DISCOVERY, (0, $6A2DX.JiraProductDiscoveryIcon)), (0, $eRtiE.Products).JIRA_SERVICE_MANAGEMENT, (0, $6A2DX.JiraServiceManagementIcon)), (0, $eRtiE.Products).BITBUCKET, (0, $6A2DX.BitbucketIcon));
var $9c6163ea9aae6457$export$41d0d88a6b0e456f = function TopNav(_ref) {
    var product = _ref.product;
    var Logo = $9c6163ea9aae6457$var$ProductLogos[product];
    var Icon = $9c6163ea9aae6457$var$ProductIcons[product];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eIrG8.default), {
        xcss: $9c6163ea9aae6457$var$styles.wrapper,
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eIrG8.default), {
        alignBlock: "center",
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cHzJP))), {
        label: "Sidebar collapse",
        color: "var(--ds-icon-subtle, #505258)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmHYY))), {
        label: "App switcher",
        color: "var(--ds-icon-subtle, #505258)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $80D8g.AboveMediumScreen), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Logo, {
        appearance: "brand",
        size: "small",
        shouldUseNewLogoDesign: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $80D8g.BelowMediumScreen), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Icon, {
        appearance: "brand",
        size: "small",
        shouldUseNewLogoDesign: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eIrG8.default), {
        xcss: $9c6163ea9aae6457$var$styles.search,
        alignInline: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eIrG8.default), {
        xcss: $9c6163ea9aae6457$var$styles.searchBar,
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hRvtK))), {
        label: "Search",
        color: "var(--ds-icon-subtle, #505258)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eIrG8.default), {
        xcss: $9c6163ea9aae6457$var$styles.createButton,
        alignBlock: "center",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $iPbQS.default), {
        xcss: $9c6163ea9aae6457$var$styles.createButtonText,
        backgroundColor: "color.background.accent.blue.subtler.hovered"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eIrG8.default), {
        alignBlock: "center",
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eIrG8.default), {
        xcss: $9c6163ea9aae6457$var$styles.chatButton,
        alignBlock: "center",
        alignInline: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $6A2DX.RovoIcon), {
        size: "xxsmall",
        appearance: "neutral"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $iPbQS.default), {
        xcss: $9c6163ea9aae6457$var$styles.chatButtonText,
        backgroundColor: "color.background.accent.gray.subtlest.hovered"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1KdrI))), {
        label: "Notifications",
        color: "var(--ds-icon-subtle, #505258)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($26Uhh))), {
        label: "Help",
        color: "var(--ds-icon-subtle, #505258)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dAHaV))), {
        label: "Settings",
        color: "var(--ds-icon-subtle, #505258)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3Qdh0))), {
        label: "User",
        color: "var(--ds-icon-subtle, #505258)"
    })));
};

});
parcelRegister("hmHYY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::55422f7c50559ad266d0694af3ada2f4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ca469bbda1b42c97$var$_react = $ca469bbda1b42c97$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $ca469bbda1b42c97$var$_baseNew = $ca469bbda1b42c97$var$_interopRequireDefault((parcelRequire("9yezp")));
function $ca469bbda1b42c97$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AppSwitcher".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for app switcher in global app navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ca469bbda1b42c97$var$AppSwitcherIcon = (props)=>/*#__PURE__*/ $ca469bbda1b42c97$var$_react.default.createElement($ca469bbda1b42c97$var$_baseNew.default, Object.assign({
        name: "AppSwitcherIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.5 11a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm8 0a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm-8-8a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm8 0a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zM7 13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zm8 0a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zM7 5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zm8 0a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2z"/>`
    }, props));
$ca469bbda1b42c97$var$AppSwitcherIcon.displayName = 'AppSwitcherIcon';
var $ca469bbda1b42c97$var$_default = module.exports.default = $ca469bbda1b42c97$var$AppSwitcherIcon;

});
parcelRegister("9yezp", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", function () { return (parcelRequire("j7zxQ")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("j7zxQ")).Icon; });

var $j7zxQ = parcelRequire("j7zxQ");

});
parcelRegister("j7zxQ", function(module, exports) {
$parcel$export(module.exports, "Icon", function () { return $deba3e37271a50bf$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $deba3e37271a50bf$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $5kYca = parcelRequire("5kYca");
/**
 * We are hiding this props from consumers as it's reserved for use by Icon Tile.
 */ var $deba3e37271a50bf$var$svgStyles = null;
var $deba3e37271a50bf$var$iconStyles = null;
var $deba3e37271a50bf$var$smallIconStyles = null;
var $deba3e37271a50bf$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $deba3e37271a50bf$var$baseHcmStyles = null;
var $deba3e37271a50bf$var$scaleSize = null;
var $deba3e37271a50bf$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $deba3e37271a50bf$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $deba3e37271a50bf$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $deba3e37271a50bf$export$f04a61298a47a40f = /*#__PURE__*/ (0, $1oC0p.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $deba3e37271a50bf$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $5kYca.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $1oC0p.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $5kYca.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $deba3e37271a50bf$var$coreSizeSmall[spacing] : $deba3e37271a50bf$var$coreSizeMedium[spacing]
        ])
    }));
});
var $deba3e37271a50bf$export$2e2bcd8739ae039 = $deba3e37271a50bf$export$f04a61298a47a40f;

});



parcelRegister("1KdrI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::45233a62a3f56b9e4911deb2a2339447>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $145484716b5b6934$var$_react = $145484716b5b6934$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $145484716b5b6934$var$_baseNew = $145484716b5b6934$var$_interopRequireDefault((parcelRequire("9yezp")));
function $145484716b5b6934$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Notification".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for notifications within global app navigation and within app screens.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $145484716b5b6934$var$NotificationIcon = (props)=>/*#__PURE__*/ $145484716b5b6934$var$_react.default.createElement($145484716b5b6934$var$_baseNew.default, Object.assign({
        name: "NotificationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M6.42 13.5a1.748 1.748 0 0 0 3.16 0zM4.5 8.636c0 .215-.06.426-.175.608L2.603 12h10.795l-1.723-2.756a1.15 1.15 0 0 1-.175-.608V5a3.5 3.5 0 0 0-7 0zm8.5-.1 1.788 2.86a1.375 1.375 0 0 1-1.166 2.104h-2.46a3.25 3.25 0 0 1-6.324 0h-2.46a1.375 1.375 0 0 1-1.166-2.104L3 8.537V5a5 5 0 0 1 10 0z"/>`
    }, props));
$145484716b5b6934$var$NotificationIcon.displayName = 'NotificationIcon';
var $145484716b5b6934$var$_default = module.exports.default = $145484716b5b6934$var$NotificationIcon;

});

parcelRegister("3Qdh0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e5a2b32fe863ac429d199dc8b174e3b3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2cc0863587cf71d7$var$_react = $2cc0863587cf71d7$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $2cc0863587cf71d7$var$_baseNew = $2cc0863587cf71d7$var$_interopRequireDefault((parcelRequire("9yezp")));
function $2cc0863587cf71d7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAvatar".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for user avatar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2cc0863587cf71d7$var$PersonAvatarIcon = (props)=>/*#__PURE__*/ $2cc0863587cf71d7$var$_react.default.createElement($2cc0863587cf71d7$var$_baseNew.default, Object.assign({
        name: "PersonAvatarIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 0 0-4.148 11.505A2.75 2.75 0 0 1 6.5 11h3c1.26 0 2.323.848 2.648 2.005A6.5 6.5 0 0 0 8 1.5m2.75 12.392v-.142c0-.69-.56-1.25-1.25-1.25h-3c-.69 0-1.25.56-1.25 1.25v.142l.06.027c.82.373 1.73.581 2.69.581s1.87-.208 2.69-.58q.03-.016.06-.028M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-3.5 2a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" clip-rule="evenodd"/>`
    }, props));
$2cc0863587cf71d7$var$PersonAvatarIcon.displayName = 'PersonAvatarIcon';
var $2cc0863587cf71d7$var$_default = module.exports.default = $2cc0863587cf71d7$var$PersonAvatarIcon;

});

parcelRegister("26Uhh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8bb31d7b8eb39bae440b5a0002b7aa63>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1897cbe8755eba17$var$_react = $1897cbe8755eba17$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $1897cbe8755eba17$var$_baseNew = $1897cbe8755eba17$var$_interopRequireDefault((parcelRequire("9yezp")));
function $1897cbe8755eba17$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuestionCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1897cbe8755eba17$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $1897cbe8755eba17$var$_react.default.createElement($1897cbe8755eba17$var$_baseNew.default, Object.assign({
        name: "QuestionCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3c-.586 0-1 .414-1 1H5.5c0-1.414 1.086-2.5 2.5-2.5s2.5 1.086 2.5 2.5c0 1.133-.713 1.706-1.162 2.058-.511.402-.588.494-.588.692v.75h-1.5v-.75c0-.977.689-1.507 1.078-1.806l.084-.065C8.838 6.544 9 6.367 9 6c0-.586-.414-1-1-1" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$1897cbe8755eba17$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
var $1897cbe8755eba17$var$_default = module.exports.default = $1897cbe8755eba17$var$QuestionCircleIcon;

});

parcelRegister("hRvtK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0ed30ba2fe598b1c691c4159780db191>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d00fcdf693601b27$var$_react = $d00fcdf693601b27$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $d00fcdf693601b27$var$_baseNew = $d00fcdf693601b27$var$_interopRequireDefault((parcelRequire("9yezp")));
function $d00fcdf693601b27$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Search".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d00fcdf693601b27$var$SearchIcon = (props)=>/*#__PURE__*/ $d00fcdf693601b27$var$_react.default.createElement($d00fcdf693601b27$var$_baseNew.default, Object.assign({
        name: "SearchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7 2.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9M1 7a6 6 0 1 1 10.74 3.68l3.29 3.29-1.06 1.06-3.29-3.29A6 6 0 0 1 1 7" clip-rule="evenodd"/>`
    }, props));
$d00fcdf693601b27$var$SearchIcon.displayName = 'SearchIcon';
var $d00fcdf693601b27$var$_default = module.exports.default = $d00fcdf693601b27$var$SearchIcon;

});

parcelRegister("dAHaV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e6207a690a69d1b6395dc313a9a74c2f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9e5020dae9cc7775$var$_react = $9e5020dae9cc7775$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $9e5020dae9cc7775$var$_baseNew = $9e5020dae9cc7775$var$_interopRequireDefault((parcelRequire("9yezp")));
function $9e5020dae9cc7775$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Settings".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for any object or user settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9e5020dae9cc7775$var$SettingsIcon = (props)=>/*#__PURE__*/ $9e5020dae9cc7775$var$_react.default.createElement($9e5020dae9cc7775$var$_baseNew.default, Object.assign({
        name: "SettingsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.058.462A.75.75 0 0 1 6.75 0h2.5a.75.75 0 0 1 .692.462l1.026 2.462 2.578-.374a.75.75 0 0 1 .757.367l1.25 2.166a.75.75 0 0 1-.049.824L13.937 8l1.567 2.093c.18.24.2.565.05.825l-1.25 2.165a.75.75 0 0 1-.758.367l-2.578-.374-1.026 2.463A.75.75 0 0 1 9.25 16h-2.5a.75.75 0 0 1-.692-.461l-1.026-2.463-2.578.374a.75.75 0 0 1-.757-.367l-1.25-2.165a.75.75 0 0 1 .049-.825L2.063 8 .496 5.907a.75.75 0 0 1-.05-.824l1.25-2.166a.75.75 0 0 1 .758-.367l2.578.374zM7.25 1.5l-.871 2.09c-.242.58-.845.923-1.467.833l-2.17-.315-.749 1.296L3.32 7.176c.366.488.366 1.16 0 1.648l-1.327 1.772.749 1.296 2.17-.315a1.375 1.375 0 0 1 1.467.832L7.25 14.5h1.5l.871-2.09c.242-.58.845-.923 1.467-.833l2.17.315.749-1.296-1.327-1.772a1.375 1.375 0 0 1 0-1.648l1.327-1.772-.749-1.296-2.17.315A1.375 1.375 0 0 1 9.62 3.59L8.75 1.5zm.75 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$9e5020dae9cc7775$var$SettingsIcon.displayName = 'SettingsIcon';
var $9e5020dae9cc7775$var$_default = module.exports.default = $9e5020dae9cc7775$var$SettingsIcon;

});

parcelRegister("cHzJP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b7c03d2728886be26240ae9af453c127>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $93f5390a517abf9c$var$_react = $93f5390a517abf9c$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $93f5390a517abf9c$var$_baseNew = $93f5390a517abf9c$var$_interopRequireDefault((parcelRequire("9yezp")));
function $93f5390a517abf9c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SidebarCollapse".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for collapsing the navigation sidebar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $93f5390a517abf9c$var$SidebarCollapseIcon = (props)=>/*#__PURE__*/ $93f5390a517abf9c$var$_react.default.createElement($93f5390a517abf9c$var$_baseNew.default, Object.assign({
        name: "SidebarCollapseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h2v-11zm3.5 0v11H14a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM0 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm7.97 4.47 2.5-2.5 1.06 1.06L9.56 8l1.97 1.97-1.06 1.06-2.5-2.5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$93f5390a517abf9c$var$SidebarCollapseIcon.displayName = 'SidebarCollapseIcon';
var $93f5390a517abf9c$var$_default = module.exports.default = $93f5390a517abf9c$var$SidebarCollapseIcon;

});

parcelRegister("iPbQS", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $db462ef5f83013f8$export$2e2bcd8739ae039; });
/* box.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $5kYca = parcelRequire("5kYca");

var $iZsL8 = parcelRequire("iZsL8");
var $db462ef5f83013f8$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $db462ef5f83013f8$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $db462ef5f83013f8$var$baseStyles = null;
var $db462ef5f83013f8$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhkkuup",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1gf0",
    'color.background.accent.lime.subtler.pressed': "_bfhk2kxc",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhk1jbd",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhkh0j0",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhknbir",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkaffd",
    'color.background.accent.red.subtler.pressed': "_bfhk1j5a",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1fnn",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhk1cl6",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtlest.hovered': "_bfhk19yr",
    'color.background.accent.orange.subtlest.pressed': "_bfhkf90x",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtler.hovered': "_bfhk1ei0",
    'color.background.accent.orange.subtler.pressed': "_bfhkdpo3",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.subtle.hovered': "_bfhk9mfs",
    'color.background.accent.orange.subtle.pressed': "_bfhkaxpp",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.orange.bolder.hovered': "_bfhk12qo",
    'color.background.accent.orange.bolder.pressed': "_bfhk1fyq",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtlest.hovered': "_bfhkaetg",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk1o1l",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtler.hovered': "_bfhk1uw7",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1r9w",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.subtle.hovered': "_bfhk819w",
    'color.background.accent.yellow.subtle.pressed': "_bfhk1jx0",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk1okt",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkyfny",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhk1e2h",
    'color.background.accent.green.subtler.pressed': "_bfhkybhx",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk1g86",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1j68",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1cxp",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkkwwr",
    'color.background.accent.teal.subtler.pressed': "_bfhk1jb0",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk16zl",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhktor0",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtlest.hovered': "_bfhkdaj9",
    'color.background.accent.blue.subtlest.pressed': "_bfhkxm0g",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtler.hovered': "_bfhk815t",
    'color.background.accent.blue.subtler.pressed': "_bfhkrwxf",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.subtle.hovered': "_bfhk9pr4",
    'color.background.accent.blue.subtle.pressed': "_bfhknpx7",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.blue.bolder.hovered': "_bfhk1vbm",
    'color.background.accent.blue.bolder.pressed': "_bfhk1xwi",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtlest.hovered': "_bfhkkca2",
    'color.background.accent.purple.subtlest.pressed': "_bfhk1jbm",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtler.hovered': "_bfhkattl",
    'color.background.accent.purple.subtler.pressed': "_bfhk3nfk",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.subtle.hovered': "_bfhk8bp1",
    'color.background.accent.purple.subtle.pressed': "_bfhk1cd2",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.purple.bolder.hovered': "_bfhk1af5",
    'color.background.accent.purple.bolder.pressed': "_bfhk6cze",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1ckf",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1axx",
    'color.background.accent.magenta.subtler.pressed': "_bfhk42ri",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk6c15",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkeawv",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtlest.hovered': "_bfhkwejn",
    'color.background.accent.gray.subtlest.pressed': "_bfhk18ut",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtler.hovered': "_bfhk10ef",
    'color.background.accent.gray.subtler.pressed': "_bfhk1rk9",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.subtle.hovered': "_bfhk1nv3",
    'color.background.accent.gray.subtle.pressed': "_bfhkq9tj",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.accent.gray.bolder.hovered': "_bfhkbyip",
    'color.background.accent.gray.bolder.pressed': "_bfhk1van",
    'color.background.disabled': "_bfhkby5v",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhkl4ek",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.hovered': "_bfhkplhp",
    'color.background.neutral.pressed': "_bfhk1gdz",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk1dpa",
    'color.background.neutral.subtle.pressed': "_bfhkfcek",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.neutral.bold.hovered': "_bfhk1ibz",
    'color.background.neutral.bold.pressed': "_bfhkof27",
    'color.background.selected': "_bfhk15s3",
    'color.background.selected.hovered': "_bfhkufnl",
    'color.background.selected.pressed': "_bfhknozp",
    'color.background.selected.bold': "_bfhkjmqp",
    'color.background.selected.bold.hovered': "_bfhk1q28",
    'color.background.selected.bold.pressed': "_bfhk12kk",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.subtlest.hovered': "_bfhk3v15",
    'color.background.brand.subtlest.pressed': "_bfhku02c",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.bold.hovered': "_bfhkhf2y",
    'color.background.brand.bold.pressed': "_bfhkg6ey",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.brand.boldest.hovered': "_bfhklefx",
    'color.background.brand.boldest.pressed': "_bfhk16k6",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1r4b",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk13a9",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.hovered': "_bfhk19zu",
    'color.background.warning.pressed': "_bfhkzr32",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.warning.bold.hovered': "_bfhk1spp",
    'color.background.warning.bold.pressed': "_bfhk4m4m",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.hovered': "_bfhk1vfx",
    'color.background.success.pressed': "_bfhk1wl5",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.success.bold.hovered': "_bfhky7x8",
    'color.background.success.bold.pressed': "_bfhkwcbh",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.hovered': "_bfhk12eq",
    'color.background.discovery.pressed': "_bfhk18vq",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.discovery.bold.hovered': "_bfhkfqeg",
    'color.background.discovery.bold.pressed': "_bfhk1f1m",
    'color.background.information': "_bfhk19ip",
    'color.background.information.hovered': "_bfhk86z5",
    'color.background.information.pressed': "_bfhk1c1j",
    'color.background.information.bold': "_bfhkx4w0",
    'color.background.information.bold.hovered': "_bfhkq2ii",
    'color.background.information.bold.pressed': "_bfhkf89v",
    'color.blanket': "_bfhk1i5c",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkizff",
    'color.skeleton.subtle': "_bfhkvkf5",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk19i6",
    'elevation.surface.pressed': "_bfhk13ro",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk6o2t",
    'elevation.surface.overlay.pressed': "_bfhkm8nx",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk116u",
    'elevation.surface.raised.pressed': "_bfhk14aj",
    'elevation.surface.sunken': "_bfhkhfxm",
    'utility.elevation.surface.current': "_bfhkchd4"
};
var $db462ef5f83013f8$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $db462ef5f83013f8$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l19i6",
    'elevation.surface.pressed': "_1q1l13ro",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l6o2t",
    'elevation.surface.overlay.pressed': "_1q1lm8nx",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l116u",
    'elevation.surface.raised.pressed': "_1q1l14aj",
    'elevation.surface.sunken': "_1q1lhfxm"
};
var $db462ef5f83013f8$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
var $db462ef5f83013f8$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
var $db462ef5f83013f8$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
var $db462ef5f83013f8$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $db462ef5f83013f8$var$Box = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $gnQ3X.default)(_ref, $db462ef5f83013f8$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $gnQ3X.default)(htmlAttributes, $db462ef5f83013f8$var$_excluded2);
    var node = /*#__PURE__*/ $1oC0p.createElement(Component, (0, $c9bqK.default)({
        style: style,
        ref: ref,
        className: (0, $5kYca.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $db462ef5f83013f8$var$backgroundColorMap[backgroundColor],
            backgroundColor && $db462ef5f83013f8$var$isSurfaceToken(backgroundColor) && $db462ef5f83013f8$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $db462ef5f83013f8$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $db462ef5f83013f8$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $db462ef5f83013f8$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $db462ef5f83013f8$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $1oC0p.createElement((0, $iZsL8.SurfaceContext).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $db462ef5f83013f8$export$2e2bcd8739ae039 = $db462ef5f83013f8$var$Box;
function $db462ef5f83013f8$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $db462ef5f83013f8$var$setSurfaceTokenMap;
}

});
parcelRegister("iZsL8", function(module, exports) {
$parcel$export(module.exports, "SurfaceContext", function () { return $dd343b81ba8fdc4c$export$1ca2a26fecb070ae; });

var $1oC0p = parcelRequire("1oC0p");
var $dd343b81ba8fdc4c$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $1oC0p.createContext)('elevation.surface');
var $dd343b81ba8fdc4c$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $1oC0p.useContext)($dd343b81ba8fdc4c$export$1ca2a26fecb070ae);
};
$dd343b81ba8fdc4c$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});


parcelRegister("80D8g", function(module, exports) {
$parcel$export(module.exports, "AboveMediumScreen", function () { return $5d4cadac2387f190$export$1bc531f284926080; });
$parcel$export(module.exports, "AboveSmallScreen", function () { return $5d4cadac2387f190$export$f238340b7c0c9a5b; });
$parcel$export(module.exports, "BelowMediumScreen", function () { return $5d4cadac2387f190$export$7dc4de1155708460; });
/* css-media-queries.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $1oC0p = parcelRequire("1oC0p");

var $iPbQS = parcelRequire("iPbQS");
// note: can't use imported values in a cssMap (otherwise would use media.above.sm/md here)
var $5d4cadac2387f190$var$styles = {
    aboveMediumScreen: "_4t3i1osq _dm251txw _1mjbglyw",
    aboveSmallScreen: "_4t3i1osq _181n1ule _sugaglyw",
    belowMediumScreen: "_4t3i1osq _dm25glyw _1mjb1txw",
    belowSmallScreen: "_4t3i1osq _181nglyw _suga1ule"
};
var $5d4cadac2387f190$export$1bc531f284926080 = function AboveMediumScreen(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $iPbQS.default), {
        xcss: $5d4cadac2387f190$var$styles.aboveMediumScreen,
        testId: "above-medium-screen",
        "aria-hidden": true,
        tabIndex: -1
    }, children);
};
var $5d4cadac2387f190$export$f238340b7c0c9a5b = function AboveSmallScreen(_ref2) {
    var children = _ref2.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $iPbQS.default), {
        xcss: $5d4cadac2387f190$var$styles.aboveSmallScreen,
        testId: "above-small-screen",
        "aria-hidden": true,
        tabIndex: -1
    }, children);
};
var $5d4cadac2387f190$export$7dc4de1155708460 = function BelowMediumScreen(_ref3) {
    var children = _ref3.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $iPbQS.default), {
        xcss: $5d4cadac2387f190$var$styles.belowMediumScreen,
        testId: "below-medium-screen",
        "aria-hidden": true,
        tabIndex: -1
    }, children);
};
var $5d4cadac2387f190$export$683c905d63c7331e = function BelowSmallScreen(_ref4) {
    var children = _ref4.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $iPbQS.default), {
        xcss: $5d4cadac2387f190$var$styles.belowSmallScreen,
        testId: "below-small-screen",
        "aria-hidden": true,
        tabIndex: -1
    }, children);
};

});


parcelRegister("bj9nT", function(module, exports) {
$parcel$export(module.exports, "DesktopOnlyBackground", function () { return $83b8bf9cc78e6a9a$export$5e40b6732fa22ace; });

var $1oC0p = parcelRequire("1oC0p");

var $80D8g = parcelRequire("80D8g");

var $879oo = parcelRequire("879oo");
var $83b8bf9cc78e6a9a$export$5e40b6732fa22ace = function DesktopOnlyBackground(_ref) {
    var Background = _ref.background, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $80D8g.AboveSmallScreen), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Background, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $879oo.DesktopOnlyBlanket), null, children));
};

});
parcelRegister("879oo", function(module, exports) {
$parcel$export(module.exports, "DesktopOnlyBlanket", function () { return $5e86434ced190c55$export$a2dbb796fb00a8aa; });
/* desktop-only-blanket.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5kYca = parcelRequire("5kYca");

var $1oC0p = parcelRequire("1oC0p");

var $b3BH6 = parcelRequire("b3BH6");

var $Vy11d = parcelRequire("Vy11d");

var $iPbQS = parcelRequire("iPbQS");
var $5e86434ced190c55$var$styles = {
    blanket: "_e7o8idpf _1rqi1n9t _1gw0bfng _1jb31i5c _1bv01wug _1nwk1wug",
    hideAtlaskitBlanketOnSmallScreen: "_i2nb1j28"
};
var $5e86434ced190c55$export$a2dbb796fb00a8aa = function DesktopOnlyBlanket(_ref) {
    var children = _ref.children;
    if ((0, $Vy11d.fg)('cfind_4831_product_overlay_modal_visual_updates')) // Hide blanket using CSS so it can render in SSR
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", {
        className: (0, $5kYca.default)([
            $5e86434ced190c55$var$styles.hideAtlaskitBlanketOnSmallScreen
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $b3BH6.default), {
        isTinted: true
    }, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $iPbQS.default), {
        role: "presentation",
        xcss: $5e86434ced190c55$var$styles.blanket
    }, children);
};

});
parcelRegister("Vy11d", function(module, exports) {
$parcel$export(module.exports, "fg", function () { return $0acfb5bdbd8bb176$export$b40ec24ac8275656; });

var $HwxsW = parcelRequire("HwxsW");
function $0acfb5bdbd8bb176$export$ba05d765b8392e5e(flagResolver) {
    (0, $HwxsW.setBooleanResolver)(flagResolver);
}
function $0acfb5bdbd8bb176$export$470e5c2be1411c89(name) {
    return (0, $HwxsW.resolveBooleanFlag)(name);
}
function $0acfb5bdbd8bb176$export$b40ec24ac8275656(name) {
    return (0, $HwxsW.resolveBooleanFlag)(name);
}

});
parcelRegister("HwxsW", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", function () { return $082d41ca0b092157$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $082d41ca0b092157$export$6333b6aff9fc6275; });

var $idwZC = parcelRequire("idwZC");

var $laxCH = parcelRequire("laxCH");

var $7t0tI = parcelRequire("7t0tI");
var $082d41ca0b092157$var$pkgName = '@atlaskit/platform-feature-flags';
var $082d41ca0b092157$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $082d41ca0b092157$var$hasProcessEnv = typeof $7t0tI !== 'undefined' && typeof $7t0tI.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $082d41ca0b092157$var$ENV_ENABLE_PLATFORM_FF = $082d41ca0b092157$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $082d41ca0b092157$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $082d41ca0b092157$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $082d41ca0b092157$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $082d41ca0b092157$var$ENV_ENABLE_PLATFORM_FF || $082d41ca0b092157$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $082d41ca0b092157$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $082d41ca0b092157$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$082d41ca0b092157$var$globalVar[$082d41ca0b092157$export$7e41b1b2bdee3f98] = $082d41ca0b092157$var$globalVar[$082d41ca0b092157$export$7e41b1b2bdee3f98] || $082d41ca0b092157$var$DEFAULT_PFF_GLOBAL;
function $082d41ca0b092157$export$f2b591175b3e424c(resolver) {
    $082d41ca0b092157$var$globalVar[$082d41ca0b092157$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $082d41ca0b092157$export$6333b6aff9fc6275(flagKey) {
    if ($082d41ca0b092157$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $laxCH.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $082d41ca0b092157$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $082d41ca0b092157$var$globalVar[$082d41ca0b092157$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $082d41ca0b092157$var$globalVar[$082d41ca0b092157$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $idwZC.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $082d41ca0b092157$var$globalVar[$082d41ca0b092157$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("idwZC", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d433089501365a90$export$2e2bcd8739ae039; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");

var $gE24N = parcelRequire("gE24N");

var $7p1Mn = parcelRequire("7p1Mn");



var $d433089501365a90$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $d433089501365a90$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, $cTewU.default)(this, FeatureGates);
    }
    return (0, $avOEA.default)(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$d433089501365a90$var$_FeatureGates = $d433089501365a90$var$FeatureGates;
(0, $f53LC.default)($d433089501365a90$var$FeatureGates, "client", new (0, $gE24N.Client)());
(0, $f53LC.default)($d433089501365a90$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, $f53LC.default)($d433089501365a90$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, $f53LC.default)($d433089501365a90$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$d433089501365a90$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $d433089501365a90$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $d433089501365a90$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, $f53LC.default)($d433089501365a90$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$d433089501365a90$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $d433089501365a90$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $d433089501365a90$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, $f53LC.default)($d433089501365a90$var$FeatureGates, "initializeCalled", $d433089501365a90$var$_FeatureGates.client.initializeCalled.bind($d433089501365a90$var$_FeatureGates.client));
(0, $f53LC.default)($d433089501365a90$var$FeatureGates, "initializeCompleted", $d433089501365a90$var$_FeatureGates.client.initializeCompleted.bind($d433089501365a90$var$_FeatureGates.client));
(0, $f53LC.default)($d433089501365a90$var$FeatureGates, "waitUntilInitializeCompleted", $d433089501365a90$var$_FeatureGates.client.waitUntilInitializeCompleted.bind($d433089501365a90$var$_FeatureGates.client));
(0, $f53LC.default)($d433089501365a90$var$FeatureGates, "initialize", $d433089501365a90$var$_FeatureGates.client.initialize.bind($d433089501365a90$var$_FeatureGates.client));
(0, $f53LC.default)($d433089501365a90$var$FeatureGates, "initializeWithProvider", $d433089501365a90$var$_FeatureGates.client.initializeWithProvider.bind($d433089501365a90$var$_FeatureGates.client));
(0, $f53LC.default)($d433089501365a90$var$FeatureGates, "initializeFromValues", $d433089501365a90$var$_FeatureGates.client.initializeFromValues.bind($d433089501365a90$var$_FeatureGates.client));
(0, $f53LC.default)($d433089501365a90$var$FeatureGates, "manuallyLogGateExposure", $d433089501365a90$var$_FeatureGates.client.manuallyLogGateExposure.bind($d433089501365a90$var$_FeatureGates.client));
(0, $f53LC.default)($d433089501365a90$var$FeatureGates, "getExperiment", $d433089501365a90$var$_FeatureGates.client.getExperiment.bind($d433089501365a90$var$_FeatureGates.client));
(0, $f53LC.default)($d433089501365a90$var$FeatureGates, "manuallyLogExperimentExposure", $d433089501365a90$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($d433089501365a90$var$_FeatureGates.client));
(0, $f53LC.default)($d433089501365a90$var$FeatureGates, "manuallyLogLayerExposure", $d433089501365a90$var$_FeatureGates.client.manuallyLogLayerExposure.bind($d433089501365a90$var$_FeatureGates.client));
(0, $f53LC.default)($d433089501365a90$var$FeatureGates, "shutdownStatsig", $d433089501365a90$var$_FeatureGates.client.shutdownStatsig.bind($d433089501365a90$var$_FeatureGates.client));
(0, $f53LC.default)($d433089501365a90$var$FeatureGates, "overrideGate", $d433089501365a90$var$_FeatureGates.client.overrideGate.bind($d433089501365a90$var$_FeatureGates.client));
(0, $f53LC.default)($d433089501365a90$var$FeatureGates, "clearGateOverride", $d433089501365a90$var$_FeatureGates.client.clearGateOverride.bind($d433089501365a90$var$_FeatureGates.client));
(0, $f53LC.default)($d433089501365a90$var$FeatureGates, "overrideConfig", $d433089501365a90$var$_FeatureGates.client.overrideConfig.bind($d433089501365a90$var$_FeatureGates.client));
(0, $f53LC.default)($d433089501365a90$var$FeatureGates, "clearConfigOverride", $d433089501365a90$var$_FeatureGates.client.clearConfigOverride.bind($d433089501365a90$var$_FeatureGates.client));
(0, $f53LC.default)($d433089501365a90$var$FeatureGates, "setOverrides", $d433089501365a90$var$_FeatureGates.client.setOverrides.bind($d433089501365a90$var$_FeatureGates.client));
(0, $f53LC.default)($d433089501365a90$var$FeatureGates, "getOverrides", $d433089501365a90$var$_FeatureGates.client.getOverrides.bind($d433089501365a90$var$_FeatureGates.client));
(0, $f53LC.default)($d433089501365a90$var$FeatureGates, "clearAllOverrides", $d433089501365a90$var$_FeatureGates.client.clearAllOverrides.bind($d433089501365a90$var$_FeatureGates.client));
(0, $f53LC.default)($d433089501365a90$var$FeatureGates, "isCurrentUser", $d433089501365a90$var$_FeatureGates.client.isCurrentUser.bind($d433089501365a90$var$_FeatureGates.client));
(0, $f53LC.default)($d433089501365a90$var$FeatureGates, "onGateUpdated", $d433089501365a90$var$_FeatureGates.client.onGateUpdated.bind($d433089501365a90$var$_FeatureGates.client));
(0, $f53LC.default)($d433089501365a90$var$FeatureGates, "onExperimentValueUpdated", $d433089501365a90$var$_FeatureGates.client.onExperimentValueUpdated.bind($d433089501365a90$var$_FeatureGates.client));
(0, $f53LC.default)($d433089501365a90$var$FeatureGates, "onAnyUpdated", $d433089501365a90$var$_FeatureGates.client.onAnyUpdated.bind($d433089501365a90$var$_FeatureGates.client));
(0, $f53LC.default)($d433089501365a90$var$FeatureGates, "updateUser", $d433089501365a90$var$_FeatureGates.client.updateUser.bind($d433089501365a90$var$_FeatureGates.client));
(0, $f53LC.default)($d433089501365a90$var$FeatureGates, "updateUserWithProvider", $d433089501365a90$var$_FeatureGates.client.updateUserWithProvider.bind($d433089501365a90$var$_FeatureGates.client));
(0, $f53LC.default)($d433089501365a90$var$FeatureGates, "updateUserWithValues", $d433089501365a90$var$_FeatureGates.client.updateUserWithValues.bind($d433089501365a90$var$_FeatureGates.client));
(0, $f53LC.default)($d433089501365a90$var$FeatureGates, "getPackageVersion", $d433089501365a90$var$_FeatureGates.client.getPackageVersion.bind($d433089501365a90$var$_FeatureGates.client));
(0, $f53LC.default)($d433089501365a90$var$FeatureGates, "getLayer", $d433089501365a90$var$_FeatureGates.client.getLayer.bind($d433089501365a90$var$_FeatureGates.client));
(0, $f53LC.default)($d433089501365a90$var$FeatureGates, "getLayerValue", $d433089501365a90$var$_FeatureGates.client.getLayerValue.bind($d433089501365a90$var$_FeatureGates.client));
var $d433089501365a90$var$boundFGJS = $d433089501365a90$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $d433089501365a90$var$FeatureGates;
    else {
        var $d433089501365a90$var$_boundFGJS, $d433089501365a90$var$_boundFGJS$getPackage;
        $d433089501365a90$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $d433089501365a90$var$boundVersion = (($d433089501365a90$var$_boundFGJS = $d433089501365a90$var$boundFGJS) === null || $d433089501365a90$var$_boundFGJS === void 0 || ($d433089501365a90$var$_boundFGJS$getPackage = $d433089501365a90$var$_boundFGJS.getPackageVersion) === null || $d433089501365a90$var$_boundFGJS$getPackage === void 0 ? void 0 : $d433089501365a90$var$_boundFGJS$getPackage.call($d433089501365a90$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($d433089501365a90$var$boundVersion !== (0, $7p1Mn.CLIENT_VERSION)) {
            var $d433089501365a90$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($d433089501365a90$var$boundVersion, " when module version ").concat((0, $7p1Mn.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($d433089501365a90$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $d433089501365a90$export$2e2bcd8739ae039 = $d433089501365a90$var$boundFGJS;

});
parcelRegister("gE24N", function(module, exports) {
$parcel$export(module.exports, "Client", function () { return $c1e1fe12ba693ff1$export$1f2bb630327ac4b6; });

var $gnQ3X = parcelRequire("gnQ3X");

var $2qaZZ = parcelRequire("2qaZZ");

var $cn8ql = parcelRequire("cn8ql");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");

var $5Cxn4 = parcelRequire("5Cxn4");

var $ec1qE = parcelRequire("ec1qE");

var $dGwvV = parcelRequire("dGwvV");

var $3MVGl = parcelRequire("3MVGl");

var $gGpni = parcelRequire("gGpni");

var $f5I8u = parcelRequire("f5I8u");

var $kiqz9 = parcelRequire("kiqz9");

var $1TiHs = parcelRequire("1TiHs");

var $cOWeo = parcelRequire("cOWeo");

var $7QZPq = parcelRequire("7QZPq");

var $4Xym1 = parcelRequire("4Xym1");

var $7p1Mn = parcelRequire("7p1Mn");
var $c1e1fe12ba693ff1$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $c1e1fe12ba693ff1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c1e1fe12ba693ff1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c1e1fe12ba693ff1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c1e1fe12ba693ff1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c1e1fe12ba693ff1$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $c1e1fe12ba693ff1$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $c1e1fe12ba693ff1$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $cOWeo.LOCAL_STORAGE_KEY) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, $cTewU.default)(this, Client);
        (0, $f53LC.default)(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, $f53LC.default)(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, $f53LC.default)(this, "initWithDefaults", false);
        (0, $f53LC.default)(this, "hasCheckGateErrorOccurred", false);
        (0, $f53LC.default)(this, "hasGetExperimentErrorOccurred", false);
        (0, $f53LC.default)(this, "hasGetExperimentValueErrorOccurred", false);
        (0, $f53LC.default)(this, "hasGetLayerErrorOccurred", false);
        (0, $f53LC.default)(this, "hasGetLayerValueErrorOccurred", false);
        (0, $f53LC.default)(this, "subscriptions", new (0, $dGwvV.default)());
        (0, $f53LC.default)(this, "dataAdapter", new (0, $1TiHs.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, $f53LC.default)(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $cOWeo.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, $avOEA.default)(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $4Xym1.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 4;
                                    break;
                                }
                                if (!(0, $4Xym1.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $4Xym1.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 4;
                                    break;
                                }
                                if (!(0, $4Xym1.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $7p1Mn.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 11:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $c1e1fe12ba693ff1$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $7p1Mn.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $7QZPq.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $4Xym1.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 5;
                                    break;
                                }
                                if (!(0, $4Xym1.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 5:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 10:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $4Xym1.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $kiqz9.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 3;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 3:
                                _context5.next = 5;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 5:
                                _context5.next = 7;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 7:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "waitUntilInitializeCompleted",
            value: function() {
                var _waitUntilInitializeCompleted = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                if (this.initPromise) {
                                    _context7.next = 2;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can wait until initialized.');
                            case 2:
                                if (!this.initCompleted) {
                                    _context7.next = 4;
                                    break;
                                }
                                return _context7.abrupt("return");
                            case 4:
                                _context7.next = 6;
                                return this.initPromise;
                            case 6:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function waitUntilInitializeCompleted() {
                    return _waitUntilInitializeCompleted.apply(this, arguments);
                }
                return waitUntilInitializeCompleted;
            }()
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $3MVGl.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $3MVGl.DynamicConfig)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $f5I8u.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $4Xym1.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $4Xym1.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee8(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $c1e1fe12ba693ff1$var$_objectSpread({}, clientOptions);
                                _context8.prev = 1;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $kiqz9.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $kiqz9.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 6;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 6:
                                _yield$Promise$all = _context8.sent;
                                _yield$Promise$all2 = (0, $2qaZZ.default)(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context8.next = 20;
                                break;
                            case 13:
                                _context8.prev = 13;
                                _context8.t0 = _context8["catch"](1);
                                if (_context8.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context8.t0 === null || _context8.t0 === void 0 ? void 0 : _context8.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 19;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 19:
                                throw _context8.t0;
                            case 20:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 21:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            1,
                            13
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee9(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                fromValuesClientOptions = $c1e1fe12ba693ff1$var$_objectSpread($c1e1fe12ba693ff1$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context9.prev = 1;
                                _context9.next = 4;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 4:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context9.next = 8;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 8:
                                _yield$Promise$all3 = _context9.sent;
                                _yield$Promise$all4 = (0, $2qaZZ.default)(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context9.next = 22;
                                break;
                            case 15:
                                _context9.prev = 15;
                                _context9.t0 = _context9["catch"](1);
                                if (_context9.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context9.t0 === null || _context9.t0 === void 0 ? void 0 : _context9.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context9.next = 21;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 21:
                                throw _context9.t0;
                            case 22:
                                return _context9.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 23:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            1,
                            15
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee0(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, statsigOptions, _args0 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee0$(_context0) {
                        while(true)switch(_context0.prev = _context0.next){
                            case 0:
                                initializeValues = _args0.length > 3 && _args0[3] !== undefined ? _args0[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $4Xym1.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $c1e1fe12ba693ff1$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $c1e1fe12ba693ff1$var$_objectSpread($c1e1fe12ba693ff1$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $c1e1fe12ba693ff1$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $7QZPq.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, $gnQ3X.default)(newClientOptions, $c1e1fe12ba693ff1$var$_excluded);
                                this.user = (0, $4Xym1.toStatsigUser)(identifiers, customAttributes);
                                statsigOptions = $c1e1fe12ba693ff1$var$_objectSpread($c1e1fe12ba693ff1$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $ec1qE.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $ec1qE.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context0.prev = 12;
                                this.statsigClient = new (0, $ec1qE.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context0.next = 17;
                                return this.statsigClient.initializeAsync();
                            case 17:
                                _context0.next = 29;
                                break;
                            case 19:
                                _context0.prev = 19;
                                _context0.t0 = _context0["catch"](12);
                                if (_context0.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_context0.t0 === null || _context0.t0 === void 0 ? void 0 : _context0.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $ec1qE.StatsigClient)($c1e1fe12ba693ff1$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context0.next = 27;
                                return this.statsigClient.initializeAsync();
                            case 27:
                                this.initWithDefaults = true;
                                throw _context0.t0;
                            case 29:
                            case "end":
                                return _context0.stop();
                        }
                    }, _callee0, this, [
                        [
                            12,
                            19
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee10(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee10$(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context10.next = 3;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 3:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context10.next = 5;
                                    break;
                                }
                                return _context10.abrupt("return", this.initPromise);
                            case 5:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context10.prev = 6;
                                _context10.next = 9;
                                return this.initPromise;
                            case 9:
                                _context10.next = 13;
                                break;
                            case 11:
                                _context10.prev = 11;
                                _context10.t0 = _context10["catch"](6);
                            case 13:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee1() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee1$(_context1) {
                                        while(true)switch(_context1.prev = _context1.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context1.next = 4;
                                                    break;
                                                }
                                                _context1.next = 4;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 4:
                                            case "end":
                                                return _context1.stop();
                                        }
                                    }, _callee1);
                                })));
                                return _context10.abrupt("return", updateUserPromise);
                            case 17:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            6,
                            11
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee11(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, _updateUserCompletion, _ref4, errMsg, success, errorMessage;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee11$(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context11.prev = 1;
                                _context11.next = 4;
                                return initializeValuesPromise;
                            case 4:
                                initializeValues = _context11.sent;
                                user = (0, $4Xym1.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
                                _context11.next = 13;
                                break;
                            case 8:
                                _context11.prev = 8;
                                _context11.t0 = _context11["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _context11.t0 instanceof Error ? _context11.t0.message : JSON.stringify(_context11.t0);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _context11.t0;
                            case 13:
                                success = true;
                                errorMessage = null;
                                _context11.prev = 15;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context11.next = 21;
                                    break;
                                }
                                _context11.next = 21;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 21:
                                _context11.next = 27;
                                break;
                            case 23:
                                _context11.prev = 23;
                                _context11.t1 = _context11["catch"](15);
                                success = false;
                                errorMessage = String(_context11.t1);
                            case 27:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context11.next = 34;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context11.next = 35;
                                break;
                            case 34:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 35:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            1,
                            8
                        ],
                        [
                            15,
                            23
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $7p1Mn.CLIENT_VERSION;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $gGpni.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $gGpni.Layer).fromLayer((0, $ec1qE._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("dGwvV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9f686b2fc9612df8$export$2e2bcd8739ae039; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");

var $f72YL = parcelRequire("f72YL");
function $9f686b2fc9612df8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9f686b2fc9612df8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9f686b2fc9612df8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9f686b2fc9612df8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9f686b2fc9612df8$export$a66cbd9b2289cd78 = '@all-features';
var $9f686b2fc9612df8$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, $cTewU.default)(this, Subscriptions);
        (0, $f53LC.default)(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($f72YL)))();
    }
    return (0, $avOEA.default)(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $9f686b2fc9612df8$var$_objectSpread($9f686b2fc9612df8$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $9f686b2fc9612df8$var$_objectSpread($9f686b2fc9612df8$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $9f686b2fc9612df8$var$_objectSpread($9f686b2fc9612df8$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $9f686b2fc9612df8$var$_objectSpread($9f686b2fc9612df8$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($9f686b2fc9612df8$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($9f686b2fc9612df8$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($9f686b2fc9612df8$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $9f686b2fc9612df8$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});

parcelRegister("3MVGl", function(module, exports) {
$parcel$export(module.exports, "DynamicConfig", function () { return $2c229941d4fa7649$export$6dc24881a3d96325; });

var $2zYm4 = parcelRequire("2zYm4");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $4Xym1 = parcelRequire("4Xym1");
var $2c229941d4fa7649$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, $cTewU.default)(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, $avOEA.default)(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, $2zYm4.default)(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, $2zYm4.default)(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $4Xym1.migrateEvaluationDetails)(experiment.details), (0, $4Xym1.migrateSecondaryExposures)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("4Xym1", function(module, exports) {
$parcel$export(module.exports, "getOptionsWithDefaults", function () { return $39c752299a718194$export$d119b37e5f788b43; });
$parcel$export(module.exports, "shallowEquals", function () { return $39c752299a718194$export$fa1c2bbf4100b8bc; });
$parcel$export(module.exports, "toStatsigUser", function () { return $39c752299a718194$export$3dad1db244472f32; });
$parcel$export(module.exports, "migrateInitializationOptions", function () { return $39c752299a718194$export$202946b690d26d22; });
$parcel$export(module.exports, "migrateEvaluationDetails", function () { return $39c752299a718194$export$18ad168d3dbac899; });
$parcel$export(module.exports, "migrateSecondaryExposures", function () { return $39c752299a718194$export$55fd683752d01e67; });

var $gnQ3X = parcelRequire("gnQ3X");

var $2qaZZ = parcelRequire("2qaZZ");

var $f53LC = parcelRequire("f53LC");

var $hMUFv = parcelRequire("hMUFv");

var $f5I8u = parcelRequire("f5I8u");

var $7QZPq = parcelRequire("7QZPq");
var $39c752299a718194$var$_excluded = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $39c752299a718194$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $39c752299a718194$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $39c752299a718194$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $39c752299a718194$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $39c752299a718194$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $39c752299a718194$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $hMUFv.isFedRamp)() ? (0, $7QZPq.PerimeterType).FEDRAMP_MODERATE : (0, $7QZPq.PerimeterType).COMMERCIAL
    }, options);
};
var $39c752299a718194$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, $2qaZZ.default)(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, $2qaZZ.default)(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, $2qaZZ.default)(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, $2qaZZ.default)(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $39c752299a718194$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    var user = {
        customIDs: identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
var $39c752299a718194$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, $gnQ3X.default)(options, $39c752299a718194$var$_excluded);
    return $39c752299a718194$var$_objectSpread($39c752299a718194$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var $39c752299a718194$var$evaluationReasonMappings = Object.entries((0, $f5I8u.EvaluationReason)).map(function(_ref5) {
    var _ref6 = (0, $2qaZZ.default)(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $39c752299a718194$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $39c752299a718194$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, $2qaZZ.default)(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $f5I8u.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};
var $39c752299a718194$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});
parcelRegister("f5I8u", function(module, exports) {
$parcel$export(module.exports, "EvaluationReason", function () { return $afc98f20b469440d$export$c62558b199e46828; });
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $afc98f20b469440d$export$c62558b199e46828 = /*#__PURE__*/ function(EvaluationReason) {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    EvaluationReason["Error"] = "Error";
    EvaluationReason["LocalOverride"] = "LocalOverride";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["Network"] = "Network";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["Cache"] = "Cache";
    // For when we could not migrate the reason from the new client
    EvaluationReason["Unknown"] = "Unknown";
    return EvaluationReason;
}({}); // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});

parcelRegister("7QZPq", function(module, exports) {
$parcel$export(module.exports, "FeatureGateEnvironment", function () { return $5b7d59966ef11285$export$479e7351a733299; });
$parcel$export(module.exports, "PerimeterType", function () { return $5b7d59966ef11285$export$c42b7bbc5e7ba555; });
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $5b7d59966ef11285$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
var $5b7d59966ef11285$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});
var $5b7d59966ef11285$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});



parcelRegister("gGpni", function(module, exports) {
$parcel$export(module.exports, "Layer", function () { return $c2544080c3852690$export$936d0764594b6eb3; });

var $2zYm4 = parcelRequire("2zYm4");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $4Xym1 = parcelRequire("4Xym1");
var $c2544080c3852690$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, $cTewU.default)(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, $avOEA.default)(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, $2zYm4.default)(val) === (0, $2zYm4.default)(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $4Xym1.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $4Xym1.migrateSecondaryExposures)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $4Xym1.migrateSecondaryExposures)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("kiqz9", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ec6a18895443f7fd$export$2e2bcd8739ae039; });

var $f53LC = parcelRequire("f53LC");

var $cn8ql = parcelRequire("cn8ql");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $5Cxn4 = parcelRequire("5Cxn4");

var $7QZPq = parcelRequire("7QZPq");

var $7p1Mn = parcelRequire("7p1Mn");

var $lC24I = parcelRequire("lC24I");
function $ec6a18895443f7fd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ec6a18895443f7fd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ec6a18895443f7fd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ec6a18895443f7fd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ec6a18895443f7fd$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $ec6a18895443f7fd$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $ec6a18895443f7fd$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $ec6a18895443f7fd$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $ec6a18895443f7fd$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $ec6a18895443f7fd$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $ec6a18895443f7fd$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
var $ec6a18895443f7fd$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
var $ec6a18895443f7fd$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
var $ec6a18895443f7fd$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $ec6a18895443f7fd$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, $cTewU.default)(this, Fetcher);
    }
    return (0, $avOEA.default)(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(fetcherOptions) {
                    var targetApp, url;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 2;
                                _context.next = 5;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 5:
                                return _context.abrupt("return", _context.sent);
                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](2);
                                if (!(_context.t0 instanceof Error)) {
                                    _context.next = 12;
                                    break;
                                }
                                throw _context.t0;
                            case 12:
                                throw Error('Failed to retrieve client sdk key');
                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            8
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 4;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 4:
                                return _context2.abrupt("return", _context2.sent);
                            case 7:
                                _context2.prev = 7;
                                _context2.t0 = _context2["catch"](1);
                                if (!(_context2.t0 instanceof Error)) {
                                    _context2.next = 11;
                                    break;
                                }
                                throw _context2.t0;
                            case 11:
                                throw Error('Failed to retrieve experiment values');
                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            7
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 5;
                                    break;
                                }
                                _context3.next = 3;
                                return response.text();
                            case 3:
                                body = _context3.sent;
                                throw new (0, $lC24I.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 5:
                                if (!(response.status === 204)) {
                                    _context3.next = 7;
                                    break;
                                }
                                throw new (0, $lC24I.ResponseError)('Unexpected 204 response');
                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 2;
                                return response.text();
                            case 2:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $ec6a18895443f7fd$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $7QZPq.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $7QZPq.FeatureGateEnvironment).Production:
                        return $ec6a18895443f7fd$export$18c93900db9358a4;
                    case (0, $7QZPq.FeatureGateEnvironment).Staging:
                        return $ec6a18895443f7fd$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $7QZPq.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $7QZPq.FeatureGateEnvironment).Development:
                        return $ec6a18895443f7fd$export$f058dbf75c3bc647;
                    case (0, $7QZPq.FeatureGateEnvironment).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $ec6a18895443f7fd$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $ec6a18895443f7fd$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $ec6a18895443f7fd$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 5;
                                return fetch("".concat(baseUrl).concat(path), $ec6a18895443f7fd$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $7p1Mn.CLIENT_VERSION),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 5:
                                response = _context5.sent;
                                _context5.next = 8;
                                return this.handleResponseError(response);
                            case 8:
                                _context5.next = 10;
                                return this.extractResponseBody(response);
                            case 10:
                                return _context5.abrupt("return", _context5.sent);
                            case 11:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $ec6a18895443f7fd$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($ec6a18895443f7fd$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($ec6a18895443f7fd$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== 'undefined' && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();

});
parcelRegister("7p1Mn", function(module, exports) {
$parcel$export(module.exports, "CLIENT_VERSION", function () { return $563c3f8d891f220b$export$a59f8d67326bd1cb; });
/// <reference types="node" />
var $563c3f8d891f220b$export$a59f8d67326bd1cb = "0.0.0-development";

});

parcelRegister("lC24I", function(module, exports) {
$parcel$export(module.exports, "ResponseError", function () { return $fbbec1a98930f56f$export$286baf652d0b1206; });

var $avOEA = parcelRequire("avOEA");

var $cTewU = parcelRequire("cTewU");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $i7dvh = parcelRequire("i7dvh");

var $4GELH = parcelRequire("4GELH");
function $fbbec1a98930f56f$var$_callSuper(t, o, e) {
    return o = (0, $jlBwm.default)(o), (0, $i3Ugd.default)(t, $fbbec1a98930f56f$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $jlBwm.default)(t).constructor) : o.apply(t, e));
}
function $fbbec1a98930f56f$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($fbbec1a98930f56f$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $fbbec1a98930f56f$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, $cTewU.default)(this, ResponseError);
        return $fbbec1a98930f56f$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, $i7dvh.default)(ResponseError, _Error);
    return (0, $avOEA.default)(ResponseError);
}(/*#__PURE__*/ (0, $4GELH.default)(Error));

});


parcelRegister("1TiHs", function(module, exports) {
$parcel$export(module.exports, "NoFetchDataAdapter", function () { return $16096ee80119a992$export$55fffef3474104af; });

var $cn8ql = parcelRequire("cn8ql");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $7SQOE = parcelRequire("7SQOE");

var $i7dvh = parcelRequire("i7dvh");

var $f53LC = parcelRequire("f53LC");

var $5Cxn4 = parcelRequire("5Cxn4");

var $ec1qE = parcelRequire("ec1qE");
function $16096ee80119a992$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $16096ee80119a992$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $16096ee80119a992$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $16096ee80119a992$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $16096ee80119a992$var$_callSuper(t, o, e) {
    return o = (0, $jlBwm.default)(o), (0, $i3Ugd.default)(t, $16096ee80119a992$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $jlBwm.default)(t).constructor) : o.apply(t, e));
}
function $16096ee80119a992$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($16096ee80119a992$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $16096ee80119a992$var$_superPropGet(t, o, e, r) {
    var p = (0, $7SQOE.default)((0, $jlBwm.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $16096ee80119a992$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, $cTewU.default)(this, NoFetchDataAdapter);
        _this = $16096ee80119a992$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, $f53LC.default)(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, $i7dvh.default)(NoFetchDataAdapter, _DataAdapterCore);
    return (0, $avOEA.default)(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $ec1qE.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $16096ee80119a992$var$_objectSpread($16096ee80119a992$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $ec1qE._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $16096ee80119a992$var$_objectSpread($16096ee80119a992$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $ec1qE._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $ec1qE._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $ec1qE.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $16096ee80119a992$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $16096ee80119a992$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $ec1qE.DataAdapterCore));

});

parcelRegister("cOWeo", function(module, exports) {
$parcel$export(module.exports, "LOCAL_STORAGE_KEY", function () { return $95575305288188a8$export$d8474cff104280f3; });
$parcel$export(module.exports, "PersistentOverrideAdapter", function () { return $95575305288188a8$export$bcb28fbac1def494; });

var $f53LC = parcelRequire("f53LC");

var $2qaZZ = parcelRequire("2qaZZ");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $3wfvf = parcelRequire("3wfvf");
function $95575305288188a8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $95575305288188a8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $95575305288188a8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $95575305288188a8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $95575305288188a8$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $95575305288188a8$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $95575305288188a8$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $95575305288188a8$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $95575305288188a8$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $95575305288188a8$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $95575305288188a8$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $95575305288188a8$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $95575305288188a8$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $95575305288188a8$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $95575305288188a8$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $95575305288188a8$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, $cTewU.default)(this, PersistentOverrideAdapter);
        this._overrides = $95575305288188a8$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, $avOEA.default)(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $95575305288188a8$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $95575305288188a8$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $95575305288188a8$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, $2qaZZ.default)(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, $2qaZZ.default)(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, $2qaZZ.default)(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($95575305288188a8$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem($95575305288188a8$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $95575305288188a8$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $3wfvf._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $95575305288188a8$var$_objectSpread($95575305288188a8$var$_objectSpread({}, $95575305288188a8$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, $2qaZZ.default)(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, $2qaZZ.default)(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($95575305288188a8$var$djb2MapKey((0, $3wfvf._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($95575305288188a8$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($95575305288188a8$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($95575305288188a8$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $95575305288188a8$var$_objectSpread($95575305288188a8$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $95575305288188a8$var$_objectSpread($95575305288188a8$var$_objectSpread({}, current.details), {}, {
                        reason: $95575305288188a8$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($95575305288188a8$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($95575305288188a8$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($95575305288188a8$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($95575305288188a8$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($95575305288188a8$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($95575305288188a8$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $95575305288188a8$var$makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($95575305288188a8$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $95575305288188a8$var$_objectSpread($95575305288188a8$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $3wfvf._makeTypedGet)(current.name, overridden),
                    details: $95575305288188a8$var$_objectSpread($95575305288188a8$var$_objectSpread({}, current.details), {}, {
                        reason: $95575305288188a8$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($95575305288188a8$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $95575305288188a8$var$_objectSpread($95575305288188a8$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $3wfvf._makeTypedGet)(current.name, overridden),
                    details: $95575305288188a8$var$_objectSpread($95575305288188a8$var$_objectSpread({}, current.details), {}, {
                        reason: $95575305288188a8$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});



parcelRegister("laxCH", function(module, exports) {
$parcel$export(module.exports, "debug", function () { return $f6949cffc38fe5d4$export$1c9f709888824e05; });
var $f6949cffc38fe5d4$var$_process, $f6949cffc38fe5d4$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $f6949cffc38fe5d4$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($f6949cffc38fe5d4$var$_process = globalThis.process) === null || $f6949cffc38fe5d4$var$_process === void 0 || ($f6949cffc38fe5d4$var$_process = $f6949cffc38fe5d4$var$_process.env) === null || $f6949cffc38fe5d4$var$_process === void 0 ? void 0 : $f6949cffc38fe5d4$var$_process.JEST_WORKER_ID) !== undefined;
var $f6949cffc38fe5d4$var$DEBUG_MODE = !$f6949cffc38fe5d4$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($f6949cffc38fe5d4$var$_process2 = globalThis.process) === null || $f6949cffc38fe5d4$var$_process2 === void 0 || ($f6949cffc38fe5d4$var$_process2 = $f6949cffc38fe5d4$var$_process2.env) === null || $f6949cffc38fe5d4$var$_process2 === void 0 ? void 0 : $f6949cffc38fe5d4$var$_process2.NODE_ENV) !== 'production';
var $f6949cffc38fe5d4$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$f6949cffc38fe5d4$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});





parcelRegister("kvjl7", function(module, exports) {
$parcel$export(module.exports, "JiraBackground", function () { return $eed5b45babf39b06$export$2ccb200c5de09b24; });

var $1oC0p = parcelRequire("1oC0p");

var $b1LyM = parcelRequire("b1LyM");

var $bC8Wn = parcelRequire("bC8Wn");

var $jL79O = parcelRequire("jL79O");

var $bj9nT = parcelRequire("bj9nT");
var $eed5b45babf39b06$export$2ccb200c5de09b24 = function JiraBackground(_ref) {
    var children = _ref.children;
    var isDarkMode = (0, $b1LyM.default)().colorMode === 'dark';
    var Background = isDarkMode ? (0, $bC8Wn.JiraDarkTheme) : (0, $jL79O.JiraLightTheme);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $bj9nT.DesktopOnlyBackground), {
        background: Background
    }, children);
};

});
parcelRegister("bC8Wn", function(module, exports) {
$parcel$export(module.exports, "JiraDarkTheme", function () { return $874a2dbc5295ff88$export$24eb0206407d5744; });
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $1oC0p = parcelRequire("1oC0p");

var $Vy11d = parcelRequire("Vy11d");

var $eIrG8 = parcelRequire("eIrG8");
var $8LHZg = parcelRequire("8LHZg");

var $eRtiE = parcelRequire("eRtiE");

var $8wHjQ = parcelRequire("8wHjQ");

var $3ohI9 = parcelRequire("3ohI9");

var $dqpnA = parcelRequire("dqpnA");

var $kFfcm = parcelRequire("kFfcm");

var $4u2aO = parcelRequire("4u2aO");

var $6r7Re = parcelRequire("6r7Re");

var $cF3kO = parcelRequire("cF3kO");

var $59WEZ = parcelRequire("59WEZ");
var $874a2dbc5295ff88$var$styles = {
    actions: "_ca0qxy5q _u5f3xy5q _n3tdxy5q _19bvxy5q",
    content: "_19bvxy5q"
};
var $874a2dbc5295ff88$export$24eb0206407d5744 = function JiraDarkTheme() {
    if ((0, $Vy11d.fg)('cfind_4831_product_overlay_modal_visual_updates')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $8wHjQ.Background), {
        testId: "testId-jira-wireframe"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $3ohI9.TopNav), {
        product: (0, $eRtiE.Products).JIRA
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eIrG8.default), {
        alignBlock: "stretch",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $59WEZ.SideNav), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $8LHZg.default), {
        grow: "fill",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eIrG8.default), {
        xcss: $874a2dbc5295ff88$var$styles.actions,
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4u2aO.Breadcrumbs), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kFfcm.Actions), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eIrG8.default), {
        xcss: $874a2dbc5295ff88$var$styles.content,
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $6r7Re.Content), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cF3kO.DetailsPanel), null)))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $8wHjQ.Background), {
        testId: "testId-jira-wireframe"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $dqpnA.TopNav), {
        product: (0, $eRtiE.Products).JIRA
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eIrG8.default), {
        alignBlock: "stretch",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $59WEZ.SideNav), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $8LHZg.default), {
        grow: "fill",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eIrG8.default), {
        xcss: $874a2dbc5295ff88$var$styles.actions,
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4u2aO.Breadcrumbs), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kFfcm.Actions), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eIrG8.default), {
        xcss: $874a2dbc5295ff88$var$styles.content,
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $6r7Re.Content), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cF3kO.DetailsPanel), null)))));
};

});
parcelRegister("3ohI9", function(module, exports) {
$parcel$export(module.exports, "TopNav", function () { return $27815a06ed64dac6$export$41d0d88a6b0e456f; });
/* top-nav.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $f53LC = parcelRequire("f53LC");


var $1oC0p = parcelRequire("1oC0p");

var $6A2DX = parcelRequire("6A2DX");

var $eIrG8 = parcelRequire("eIrG8");

var $eRtiE = parcelRequire("eRtiE");

var $80D8g = parcelRequire("80D8g");
var $27815a06ed64dac6$var$leftMenuSvg = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
    width: "71",
    height: "30",
    viewBox: "0 0 71 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
    x: "0.5",
    y: "0.5",
    width: "29",
    height: "29",
    rx: "4.5",
    stroke: "black",
    strokeOpacity: "0.2"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
    x: "41.5",
    y: "0.5",
    width: "29",
    height: "29",
    rx: "4.5",
    stroke: "black",
    strokeOpacity: "0.2"
}));
var $27815a06ed64dac6$var$jiraLogoTextSvg = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
    width: "35",
    height: "25",
    viewBox: "0 0 35 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
    d: "M4.77661 19.1709C3.49487 19.1709 2.47803 18.8291 1.72607 18.1455C0.974121 17.4562 0.598145 16.4736 0.598145 15.1975V14.4456H3.03345V15.2317C3.03345 15.8583 3.1901 16.3368 3.50342 16.6672C3.81673 16.9919 4.24113 17.1543 4.77661 17.1543C5.3064 17.1543 5.7251 16.9919 6.03271 16.6672C6.34603 16.3368 6.50269 15.8555 6.50269 15.2231V6.26807H8.93799V15.2061C8.93799 16.4764 8.56486 17.4562 7.8186 18.1455C7.07804 18.8291 6.06405 19.1709 4.77661 19.1709ZM11.2109 19V9.54932H13.6035V19H11.2109ZM11.1682 8.16504V5.96899H13.6377V8.16504H11.1682ZM15.791 19V9.54932H18.1067V11.1643H18.1921C18.363 10.5946 18.6507 10.1646 19.0552 9.87402C19.4653 9.5778 19.9438 9.42969 20.4907 9.42969C20.6274 9.42969 20.767 9.43538 20.9094 9.44678C21.0575 9.45817 21.1857 9.47526 21.2939 9.49805V11.6428C21.1971 11.6143 21.0433 11.5887 20.8325 11.5659C20.6217 11.5431 20.4195 11.5317 20.2258 11.5317C19.8328 11.5317 19.4796 11.6172 19.1663 11.7881C18.8586 11.959 18.6165 12.1982 18.4399 12.5059C18.269 12.8078 18.1836 13.1667 18.1836 13.5825V19H15.791ZM25.2075 19.1794C24.6037 19.1794 24.0625 19.0741 23.584 18.8633C23.1055 18.6525 22.7266 18.3363 22.4475 17.9148C22.1741 17.4932 22.0374 16.9692 22.0374 16.3425C22.0374 15.8127 22.1342 15.3741 22.3279 15.0266C22.5273 14.6734 22.795 14.3914 23.1311 14.1807C23.4729 13.9642 23.8574 13.8018 24.2847 13.6936C24.7176 13.5854 25.1676 13.5056 25.6348 13.4543C26.193 13.3974 26.6402 13.3461 26.9763 13.3005C27.3181 13.2493 27.5659 13.1724 27.7197 13.0698C27.8792 12.9673 27.959 12.8135 27.959 12.6084V12.5571C27.959 12.278 27.8963 12.0387 27.771 11.8394C27.6514 11.64 27.4748 11.489 27.2412 11.3865C27.0076 11.2782 26.7228 11.2241 26.3867 11.2241C26.0392 11.2241 25.7373 11.2782 25.481 11.3865C25.2303 11.489 25.0224 11.6286 24.8572 11.8052C24.6977 11.9761 24.5866 12.1698 24.5239 12.3862L22.3108 12.0615C22.4589 11.4919 22.7209 11.0105 23.0969 10.6174C23.4729 10.2244 23.94 9.92814 24.4983 9.72876C25.0623 9.52368 25.6946 9.42114 26.3953 9.42114C26.9023 9.42114 27.3922 9.48096 27.865 9.60059C28.3378 9.72021 28.7594 9.9082 29.1296 10.1646C29.5056 10.4209 29.8018 10.7542 30.0183 11.1643C30.2348 11.5688 30.343 12.0615 30.343 12.6426V19H28.053V17.6841H27.9761C27.828 17.9689 27.6286 18.2253 27.3779 18.4531C27.133 18.6753 26.8311 18.8519 26.4722 18.9829C26.1133 19.1139 25.6917 19.1794 25.2075 19.1794ZM25.8569 17.4619C26.2842 17.4619 26.6545 17.3793 26.9678 17.2141C27.2868 17.0432 27.5346 16.8182 27.7112 16.5391C27.8878 16.2542 27.9761 15.9409 27.9761 15.5991V14.5481C27.902 14.5994 27.7852 14.6478 27.6257 14.6934C27.4719 14.7389 27.2982 14.7817 27.1045 14.8215C26.9108 14.8557 26.7171 14.887 26.5234 14.9155C26.3298 14.944 26.1532 14.9696 25.9937 14.9924C25.6746 15.038 25.3898 15.1121 25.1392 15.2146C24.8885 15.3171 24.692 15.4567 24.5496 15.6333C24.4071 15.8042 24.3359 16.0264 24.3359 16.2998C24.3359 16.5505 24.4014 16.7641 24.5325 16.9407C24.6635 17.1116 24.8429 17.2426 25.0708 17.3337C25.2987 17.4192 25.5607 17.4619 25.8569 17.4619Z",
    fill: "#292A2E"
}));
// TODO
var $27815a06ed64dac6$var$confluenceLogoTextSvg = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", null);
var $27815a06ed64dac6$var$searchSvg = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
    width: "455",
    height: "30",
    viewBox: "0 0 455 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
    x: "0.5",
    y: "0.5",
    width: "364",
    height: "29",
    rx: "4.5",
    stroke: "black",
    strokeOpacity: "0.2"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
    x: "374",
    width: "81",
    height: "30",
    rx: "5",
    fill: "#1868DB"
}));
var $27815a06ed64dac6$var$rightMenuSvg = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
    width: "204",
    height: "30",
    viewBox: "0 0 204 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
    x: "92.5",
    y: "0.5",
    width: "29",
    height: "29",
    rx: "4.5",
    stroke: "black",
    strokeOpacity: "0.2"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
    x: "133.5",
    y: "0.5",
    width: "29",
    height: "29",
    rx: "4.5",
    stroke: "black",
    strokeOpacity: "0.2"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
    x: "174.5",
    y: "0.5",
    width: "29",
    height: "29",
    rx: "4.5",
    stroke: "black",
    strokeOpacity: "0.2"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
    x: "0.5",
    y: "0.5",
    width: "80",
    height: "29",
    rx: "4.5",
    stroke: "black",
    strokeOpacity: "0.2"
})), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
    width: "36",
    height: "36",
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
    x: "1",
    y: "1",
    width: "34",
    height: "34",
    rx: "17",
    fill: "#DDDEE1"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
    x: "1",
    y: "1",
    width: "34",
    height: "34",
    rx: "17",
    stroke: "white",
    strokeWidth: "2"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
    d: "M11.0001 27.5L11 25.0001C10.9999 22.7909 12.7908 21 15 21H21C23.2091 21 24.9999 22.7908 25 24.9999L25.0001 27.5M22.4999 13C22.4999 15.4853 20.4852 17.5 17.9999 17.5C15.5146 17.5 13.4999 15.4853 13.4999 13C13.4999 10.5147 15.5146 8.5 17.9999 8.5C20.4852 8.5 22.4999 10.5147 22.4999 13Z",
    stroke: "#505258",
    strokeWidth: "2"
})));
var $27815a06ed64dac6$var$styles = {
    wrapper: "_18zrv47k _n7zlia51 _1tkeymf6 _1bsb1osq",
    search: "_195goahv _1bsb1osq",
    searchBar: "_2rko12b0 _19itia51 _4t3izwfg _1bsb1osq _p12fcv93 _1ul91178",
    createButton: "_2rko12b0 _4t3izwfg _1bsbys9h _bfhk1dy8",
    createButtonText: "_2rko12b0 _4t3ii2wt _1bsb1ady",
    chatButton: "_2rko12b0 _19itia51 _4t3izwfg _1bsbcae7",
    chatButtonText: "_2rko12b0 _4t3ii2wt _1bsbzwfg",
    logoText: "_195g12x7"
};
var $27815a06ed64dac6$var$ProductIcons = (0, $f53LC.default)((0, $f53LC.default)({}, (0, $eRtiE.Products).JIRA, (0, $6A2DX.JiraIcon)), (0, $eRtiE.Products).CONFLUENCE, (0, $6A2DX.ConfluenceIcon));
var $27815a06ed64dac6$var$productLogoTextSvgs = (0, $f53LC.default)((0, $f53LC.default)({}, (0, $eRtiE.Products).JIRA, $27815a06ed64dac6$var$jiraLogoTextSvg), (0, $eRtiE.Products).CONFLUENCE, $27815a06ed64dac6$var$confluenceLogoTextSvg);
var $27815a06ed64dac6$export$41d0d88a6b0e456f = function TopNav(_ref) {
    var product = _ref.product;
    var logoTextSvg = $27815a06ed64dac6$var$productLogoTextSvgs[product];
    var Icon = $27815a06ed64dac6$var$ProductIcons[product];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eIrG8.default), {
        xcss: $27815a06ed64dac6$var$styles.wrapper,
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eIrG8.default), {
        alignBlock: "center",
        space: "space.200"
    }, $27815a06ed64dac6$var$leftMenuSvg, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $80D8g.AboveMediumScreen), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Icon, {
        appearance: "brand",
        size: "small",
        shouldUseNewLogoDesign: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eIrG8.default), {
        xcss: $27815a06ed64dac6$var$styles.logoText
    }, logoTextSvg)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $80D8g.BelowMediumScreen), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Icon, {
        appearance: "brand",
        size: "small",
        shouldUseNewLogoDesign: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eIrG8.default), {
        xcss: $27815a06ed64dac6$var$styles.search,
        alignInline: "center",
        space: "space.100"
    }, $27815a06ed64dac6$var$searchSvg), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eIrG8.default), {
        alignBlock: "center",
        space: "space.200"
    }, $27815a06ed64dac6$var$rightMenuSvg));
};

});

parcelRegister("kFfcm", function(module, exports) {
$parcel$export(module.exports, "Actions", function () { return $f0b36d149c794fb0$export$b52183d5cfb26dc9; });

var $1oC0p = parcelRequire("1oC0p");

var $60c8E = parcelRequire("60c8E");

var $bi4Ds = parcelRequire("bi4Ds");

var $jyCmm = parcelRequire("jyCmm");

var $8zVcV = parcelRequire("8zVcV");

var $kBu6O = parcelRequire("kBu6O");

var $eIrG8 = parcelRequire("eIrG8");
var $f0b36d149c794fb0$export$b52183d5cfb26dc9 = function Actions() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eIrG8.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bi4Ds))), {
        label: "Lock Unlocked",
        color: "var(--ds-icon-subtle, #505258)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($60c8E))), {
        label: "Eye Open",
        color: "var(--ds-icon-subtle, #505258)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kBu6O))), {
        label: "Thumbs Up",
        color: "var(--ds-icon-subtle, #505258)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jyCmm))), {
        label: "Share",
        color: "var(--ds-icon-subtle, #505258)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8zVcV))), {
        label: "Show More Horizontal",
        color: "var(--ds-icon-subtle, #505258)"
    }));
};

});
parcelRegister("60c8E", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7d4381d46d56f0396feef6421a091c8f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $45ec28a125d3ec39$var$_react = $45ec28a125d3ec39$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $45ec28a125d3ec39$var$_baseNew = $45ec28a125d3ec39$var$_interopRequireDefault((parcelRequire("9yezp")));
function $45ec28a125d3ec39$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: watch page in Confluence, show password in text field, and following in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $45ec28a125d3ec39$var$EyeOpenIcon = (props)=>/*#__PURE__*/ $45ec28a125d3ec39$var$_react.default.createElement($45ec28a125d3ec39$var$_baseNew.default, Object.assign({
        name: "EyeOpenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3.5c-2.943 0-5.49 1.845-6.424 4.396a.3.3 0 0 0 0 .208C2.509 10.655 5.057 12.5 8 12.5s5.49-1.845 6.424-4.396a.3.3 0 0 0 0-.208C13.491 5.345 10.943 3.5 8 3.5M.167 7.38C1.32 4.232 4.433 2 8 2c3.566 0 6.681 2.232 7.833 5.38.146.4.146.84 0 1.24C14.68 11.768 11.566 14 8 14 4.433 14 1.319 11.768.167 8.62a1.8 1.8 0 0 1 0-1.24M8 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$45ec28a125d3ec39$var$EyeOpenIcon.displayName = 'EyeOpenIcon';
var $45ec28a125d3ec39$var$_default = module.exports.default = $45ec28a125d3ec39$var$EyeOpenIcon;

});

parcelRegister("bi4Ds", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5c5d989acf678b87189f6f5a97917ee9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8384f8ab272dc0bf$var$_react = $8384f8ab272dc0bf$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $8384f8ab272dc0bf$var$_baseNew = $8384f8ab272dc0bf$var$_interopRequireDefault((parcelRequire("9yezp")));
function $8384f8ab272dc0bf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockUnlocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: unlocked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8384f8ab272dc0bf$var$LockUnlockedIcon = (props)=>/*#__PURE__*/ $8384f8ab272dc0bf$var$_react.default.createElement($8384f8ab272dc0bf$var$_baseNew.default, Object.assign({
        name: "LockUnlockedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3H12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2V4a4 4 0 1 1 8 0h-1.5A2.5 2.5 0 0 0 8 1.5m-4 7a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$8384f8ab272dc0bf$var$LockUnlockedIcon.displayName = 'LockUnlockedIcon';
var $8384f8ab272dc0bf$var$_default = module.exports.default = $8384f8ab272dc0bf$var$LockUnlockedIcon;

});

parcelRegister("jyCmm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ed0eee459540e5ec28215a3b80df0172>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e3cef2bc56636643$var$_react = $e3cef2bc56636643$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $e3cef2bc56636643$var$_baseNew = $e3cef2bc56636643$var$_interopRequireDefault((parcelRequire("9yezp")));
function $e3cef2bc56636643$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Share".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e3cef2bc56636643$var$ShareIcon = (props)=>/*#__PURE__*/ $e3cef2bc56636643$var$_react.default.createElement($e3cef2bc56636643$var$_baseNew.default, Object.assign({
        name: "ShareIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12 2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2.5 1a2.5 2.5 0 1 1 .73 1.765L6.212 7.567a2.5 2.5 0 0 1 0 .866l4.016 2.302a2.5 2.5 0 1 1-.692 1.332L5.521 9.766a2.5 2.5 0 1 1 0-3.53l4.016-2.302A2.5 2.5 0 0 1 9.5 3.5M3.75 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2M12 11.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$e3cef2bc56636643$var$ShareIcon.displayName = 'ShareIcon';
var $e3cef2bc56636643$var$_default = module.exports.default = $e3cef2bc56636643$var$ShareIcon;

});

parcelRegister("8zVcV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2a789640350a4d3b29556a43626f35de>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $63edf7d46731896e$var$_react = $63edf7d46731896e$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $63edf7d46731896e$var$_baseNew = $63edf7d46731896e$var$_interopRequireDefault((parcelRequire("9yezp")));
function $63edf7d46731896e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShowMoreHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $63edf7d46731896e$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $63edf7d46731896e$var$_react.default.createElement($63edf7d46731896e$var$_baseNew.default, Object.assign({
        name: "ShowMoreHorizontalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m6.5 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M13 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" clip-rule="evenodd"/>`
    }, props));
$63edf7d46731896e$var$ShowMoreHorizontalIcon.displayName = 'ShowMoreHorizontalIcon';
var $63edf7d46731896e$var$_default = module.exports.default = $63edf7d46731896e$var$ShowMoreHorizontalIcon;

});

parcelRegister("kBu6O", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0bf82c15bca1a56d27012abd5cecbc7a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $effe9e5e22e17031$var$_react = $effe9e5e22e17031$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $effe9e5e22e17031$var$_baseNew = $effe9e5e22e17031$var$_interopRequireDefault((parcelRequire("9yezp")));
function $effe9e5e22e17031$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ThumbsUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: voting options in Jira, like.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $effe9e5e22e17031$var$ThumbsUpIcon = (props)=>/*#__PURE__*/ $effe9e5e22e17031$var$_react.default.createElement($effe9e5e22e17031$var$_baseNew.default, Object.assign({
        name: "ThumbsUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.708 2.594a.5.5 0 0 0-.77.15L5.5 7.433V13.5h6.371c.493 0 .928-.32 1.074-.79l1.328-4.25A1.125 1.125 0 0 0 13.2 7H9.75A.75.75 0 0 1 9 6.25V3.075a.5.5 0 0 0-.175-.38zM4 13.5V8H2a.5.5 0 0 0-.5.5V13a.5.5 0 0 0 .5.5zm.295-7 2.313-4.45a2 2 0 0 1 3.076-.596l.118.101a2 2 0 0 1 .698 1.519V5.5h2.7a2.625 2.625 0 0 1 2.505 3.408l-1.328 4.25A2.625 2.625 0 0 1 11.871 15H2a2 2 0 0 1-2-2V8.5a2 2 0 0 1 2-2z" clip-rule="evenodd"/>`
    }, props));
$effe9e5e22e17031$var$ThumbsUpIcon.displayName = 'ThumbsUpIcon';
var $effe9e5e22e17031$var$_default = module.exports.default = $effe9e5e22e17031$var$ThumbsUpIcon;

});


parcelRegister("4u2aO", function(module, exports) {
$parcel$export(module.exports, "Breadcrumbs", function () { return $343ba660e7781063$export$2dc68d50d56fbbd; });

var $1oC0p = parcelRequire("1oC0p");

var $iPbQS = parcelRequire("iPbQS");
var $343ba660e7781063$export$2dc68d50d56fbbd = function Breadcrumbs() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $iPbQS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($343ba660e7781063$var$Illustration, null));
};
var $343ba660e7781063$var$Illustration = function Illustration() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 167,
        height: 20,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 100,
        height: 6,
        y: 7,
        fill: "#454F59",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 54,
        height: 6,
        x: 113,
        y: 7,
        fill: "#454F59",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#738496",
        d: "m108.701 4.664-3.014 12.81h-1.395l3.015-12.81h1.394Z"
    }));
};

});

parcelRegister("6r7Re", function(module, exports) {
$parcel$export(module.exports, "Content", function () { return $4afb5c04fa41734e$export$7c6e2c02157bb7d2; });

var $1oC0p = parcelRequire("1oC0p");

var $iPbQS = parcelRequire("iPbQS");
var $4afb5c04fa41734e$export$7c6e2c02157bb7d2 = function Content() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $iPbQS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($4afb5c04fa41734e$var$Illustration, null));
};
var $4afb5c04fa41734e$var$Illustration = function Illustration() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: 640,
        height: 427,
        viewBox: "0 0 640 427",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 640,
        height: 20,
        rx: 6,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        y: 40,
        width: 60,
        height: 32,
        rx: 6,
        fill: "#2C333A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 8,
        y: 53,
        width: 44,
        height: 6,
        rx: 6,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 68,
        y: 40,
        width: 99,
        height: 32,
        rx: 6,
        fill: "#2C333A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 76,
        y: 53,
        width: 59,
        height: 6,
        rx: 6,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 24,
        height: 24,
        transform: "translate(138 44)",
        fill: "white",
        fillOpacity: 0.01
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M146.292 54.2929C146.105 54.4818 146 54.7368 146 55.0024C146 55.2681 146.105 55.523 146.292 55.7119L149.231 58.6769C149.449 58.8919 149.731 58.9989 150.01 58.9989C150.289 58.9989 150.566 58.8919 150.779 58.6769L153.709 55.7219C153.895 55.5329 154 55.278 154 55.0124C154 54.7469 153.895 54.492 153.709 54.3029C153.617 54.2098 153.507 54.1358 153.387 54.0853C153.266 54.0347 153.136 54.0087 153.006 54.0087C152.875 54.0087 152.745 54.0347 152.625 54.0853C152.504 54.1358 152.394 54.2098 152.303 54.3029L150.005 56.6199L147.698 54.2929C147.606 54.2001 147.496 54.1264 147.375 54.0762C147.255 54.0259 147.125 54 146.995 54C146.864 54 146.734 54.0259 146.614 54.0762C146.493 54.1264 146.384 54.2001 146.292 54.2929Z",
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        y: 92,
        width: 640,
        height: 12,
        rx: 6,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        y: 120,
        width: 640,
        height: 12,
        rx: 6,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        y: 148,
        width: 640,
        height: 12,
        rx: 6,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        y: 200,
        width: 180,
        height: 12,
        rx: 6,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        y: 232,
        width: 52,
        height: 20,
        rx: 6,
        fill: "#2C333A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 4,
        y: 239,
        width: 44,
        height: 6,
        rx: 6,
        fill: "#091E42",
        fillOpacity: 0.13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 60,
        y: 232,
        width: 85,
        height: 20,
        rx: 6,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 64,
        y: 239,
        width: 77,
        height: 6,
        rx: 6,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 153,
        y: 232,
        width: 52,
        height: 20,
        rx: 6,
        fill: "#2C333A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 157,
        y: 239,
        width: 44,
        height: 6,
        rx: 6,
        fill: "#091E42",
        fillOpacity: 0.13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 213,
        y: 232,
        width: 52,
        height: 20,
        rx: 6,
        fill: "#2C333A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 217,
        y: 239,
        width: 44,
        height: 6,
        rx: 6,
        fill: "#091E42",
        fillOpacity: 0.13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 14,
        y: 282,
        width: 26,
        height: 26,
        rx: 13,
        stroke: "#282E33",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("circle", {
        cx: 27,
        cy: 295,
        r: 12,
        fill: "url(#pattern0_233_7702)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 46,
        y: 279,
        width: 591,
        height: 40,
        rx: 6,
        fill: "#2C333A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 54,
        y: 295,
        width: 71,
        height: 6,
        rx: 6,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 44.2764,
        y: 385,
        width: 425.66,
        height: 6,
        rx: 6,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 44.2764,
        y: 403,
        width: 267.673,
        height: 6,
        rx: 6,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 44.2764,
        y: 421,
        width: 267.673,
        height: 6,
        rx: 6,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 44,
        y: 356,
        width: 119,
        height: 6,
        rx: 6,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 10,
        y: 346,
        width: 26,
        height: 26,
        rx: 13,
        stroke: "#282E33",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("circle", {
        cx: 23,
        cy: 359,
        r: 12,
        fill: "url(#pattern1_233_7702)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("pattern", {
        id: "pattern0_233_7702",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("use", {
        xlinkHref: "#image0_233_7702",
        transform: "scale(0.0025)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("pattern", {
        id: "pattern1_233_7702",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("use", {
        xlinkHref: "#image1_233_7702",
        transform: "scale(0.0025)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("image", {
        id: "image0_233_7702",
        width: 400,
        height: 400,
        preserveAspectRatio: "none",
        xlinkHref: "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAwADADASIAAhEBAxEB/8QAGwAAAgMBAQEAAAAAAAAAAAAAAwYCBAUACAf/xAAuEAACAQMCBAQGAgMAAAAAAAABAgMABAUGERITITEHQVFhFCJCcYGRMuFiobH/xAAXAQEBAQEAAAAAAAAAAAAAAAAGBwUE/8QAKREAAQMDAgQGAwAAAAAAAAAAAgEDEQAEEgVBBiExURMUInGB8JGx0f/aAAwDAQACEQMRAD8ASqjI6xozuwVFG5J7AVKlzWN0UghtkO3MPE32HYfv/lWK9uUtWCeXb91PrZlX3EbTeoXmqArlbOEMo+uQ7b/ioW2qX4wLq3Xg9Yz1H4NYWNsbrJ5C3sbCB57u4cRxRIN2ZjVrUuEvdOZy7xOUi5d3bPwsPJh5Mp81I6g0IXW7xTnP4hIpMmmW+EY/NO9tcRXUCywOHjbsRRaT9IXTR3z2xPySqSB/kP6pwplp155xhHYhei+9HLy38u6obbV1A0Tp4as8UbS0vbZp8VDKi3Q3IUJwkhSR1HEw26Uesu3z2R0dqqHK4925EskUk0X0y8tgeE/72+5rN4lBwrP0bL/a7NFIBufX2r1tpvR2ndNMz4LD2dlKw2aSNN3I9OI7nb80bUGl8HqJUGcxNnfFBsjTRAso9A3cfurGn8zY6gw1rlMVMJrO5QOjDuPVT6EHoR6irl1cQ2ltLcXUqQwRKXkkc7Kigbkk+QqVqpZSvWqCgjjy6V5R8btI22kddY+4wdktriZ0iAWMnhWXdgy9Tv1A3/dUfOh651bca913PNA8gwlvMHt4yNhwoOEOfdup28t6JVN4VbcG2JT3WgmvGBPogdq6g3VrFewmCZONW8vPf296MASQB1Jp1xOKhso1dlDXBHVj9J9BW/cuAAQaTO1ZDQkpSKxFNfgBgMlp7Tt/zpX+FurkSwROOoAXZiR7nb9VreNmFympdES2ljMUCTJNNGvTmRrvuO/XqQdj6VgYrMX2LLfBTlFbqyEBlP4NFyueyOUj5d3PvF35aKFU/fbvU+c0NwrzxhjCZjn07fVpeGsNpa+EqLlETy/P1K+N2eOjxkZt442Rgfn4v5E+9WKe8jjoL+MiRQJNvlcdx/VIsiFHZG6MpIP3p/aOAQYAkRtRF4SyyJZmv//Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("image", {
        id: "image1_233_7702",
        width: 400,
        height: 400,
        preserveAspectRatio: "none",
        xlinkHref: "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAwADADASIAAhEBAxEB/8QAGwAAAQUBAQAAAAAAAAAAAAAABAADBQYHAQL/xAApEAABAwMDAwQCAwAAAAAAAAABAgMEAAUREiFBBlFxBzFCYROBkdHh/8QAFwEBAQEBAAAAAAAAAAAAAAAABgcEBf/EACkRAAEDAwIFAwUAAAAAAAAAAAECAxEABCEFEgYxUXGRIjLRQaHB4fD/2gAMAwEAAhEDEQA/AH6VKirXCXcJzUds4KjursOTTRa0tpK1GAKizTS3lpbbEqJgdzQoBJwASfquqSUnCgQfsVp9ut0a3tBEZoA8rIypXk07LiMTGi3JaS4k9xuPB4o2eJUb4DZ29Zz4/dO08BulqVPAL6RjzP4rKqVSV/thtc4tglTSxqbUe3Y/YqNpGy6l5AcQZBoPc2zlq6pl0QpJg0qs3QjeZ8hzAwlvT/J/yqzRMCfJt7inIa0pWRjChkHyKz6gwt+3W03zNbdFumrO+bfe9qT9O3zWp0qpULrV+54j2qzuv3FIy60t1KUIA98H3O/1XuR1m9anvxdQ2h6GtadTQacS7qHY+2Kn5tHQdsZ6SJ8VbhdNEbgcdcx5ojr1GY8RzHspSc+QP6qm0dc7vKuykrkANoGShofAHgnk/dA070q3Xb2qW3OfzmozxFeNXuoOPM8sDvAie2KVMyX0x2itW/AA5p6oqfAdWsuNrLmfio7jxW9ZIGK47SUqV6jFWprpJi8QIlwizFRZimxqWydSc/ogg42O9e4/RsS3OG4Xq5KfLe4U5skHjJJJOO1A+mocavT6XVuNthknQThKjkDcc131LbccvEb8LjjqFM50A5SggkbDjNFF2dyq5LZUdpzMfaqa1rVo3p6XEoG9MJiegif7zUew8h9GtB2zinaioEB1Cw44st4+KTufNStK0EkZqZupSFek1//Z"
    })));
};

});

parcelRegister("cF3kO", function(module, exports) {
$parcel$export(module.exports, "DetailsPanel", function () { return $937be68ea7596954$export$e54a7f2505304e20; });
/* details-panel.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $1oC0p = parcelRequire("1oC0p");

var $iPbQS = parcelRequire("iPbQS");
var $937be68ea7596954$var$styles = {
    wrapper: "_kqsw1n9t _1xi2ze3t _19bvutpp _u5f3xy5q"
};
var $937be68ea7596954$export$e54a7f2505304e20 = function DetailsPanel() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $iPbQS.default), {
        xcss: $937be68ea7596954$var$styles.wrapper,
        backgroundColor: "elevation.surface"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($937be68ea7596954$var$Illustration, null));
};
var $937be68ea7596954$var$Illustration = function Illustration() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: 328,
        height: 597,
        viewBox: "0 0 328 597",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 80,
        height: 32,
        rx: 6,
        fill: "#09326C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 17,
        y: 13,
        width: 44,
        height: 6,
        rx: 6,
        fill: "#0055CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M0 52C0 47.5817 3.58172 44 8 44H320C324.418 44 328 47.5817 328 52V597H0V52Z",
        fill: "#1D2125"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M0.5 52C0.5 47.8579 3.85786 44.5 8 44.5H320C324.142 44.5 327.5 47.8579 327.5 52V596.5H0.5V52Z",
        stroke: "#A1BDD9",
        strokeOpacity: 0.08
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 24,
        y: 77,
        width: 253,
        height: 6,
        rx: 6,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 24,
        height: 24,
        transform: "translate(280 68)",
        fill: "white",
        fillOpacity: 0.01
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M288.292 78.2929C288.105 78.4818 288 78.7368 288 79.0024C288 79.2681 288.105 79.523 288.292 79.7119L291.231 82.6769C291.449 82.8919 291.731 82.9989 292.01 82.9989C292.289 82.9989 292.566 82.8919 292.779 82.6769L295.709 79.7219C295.895 79.5329 296 79.278 296 79.0124C296 78.7469 295.895 78.492 295.709 78.3029C295.617 78.2098 295.507 78.1358 295.387 78.0853C295.266 78.0347 295.136 78.0087 295.006 78.0087C294.875 78.0087 294.745 78.0347 294.625 78.0853C294.504 78.1358 294.394 78.2098 294.303 78.3029L292.005 80.6199L289.698 78.2929C289.606 78.2001 289.496 78.1264 289.375 78.0762C289.255 78.0259 289.125 78 288.995 78C288.864 78 288.734 78.0259 288.614 78.0762C288.493 78.1264 288.384 78.2001 288.292 78.2929Z",
        fill: "#BFDBF8",
        fillOpacity: 0.28
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 24,
        y: 121,
        width: 79,
        height: 6,
        rx: 6,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 24,
        y: 159,
        width: 114,
        height: 6,
        rx: 6,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 24,
        y: 197,
        width: 44,
        height: 6,
        rx: 6,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 24,
        y: 235,
        width: 71,
        height: 6,
        rx: 6,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 24,
        y: 273,
        width: 114,
        height: 6,
        rx: 6,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 24,
        y: 311,
        width: 110,
        height: 6,
        rx: 6,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 24,
        y: 349,
        width: 100,
        height: 6,
        rx: 6,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 24,
        y: 387,
        width: 114,
        height: 6,
        rx: 6,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 24,
        y: 425,
        width: 114,
        height: 6,
        rx: 6,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 24,
        y: 463,
        width: 95,
        height: 6,
        rx: 6,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 24,
        height: 24,
        transform: "translate(178 112)",
        fill: "white",
        fillOpacity: 0.01
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M190.522 131.853L190.625 131.781L195.625 127.781C196.056 127.436 196.126 126.807 195.781 126.375C195.462 125.977 194.902 125.887 194.478 126.147L194.375 126.219L190 129.72L185.625 126.219C185.227 125.901 184.66 125.936 184.304 126.282L184.219 126.375C183.901 126.773 183.936 127.34 184.282 127.696L184.375 127.781L189.375 131.781C189.707 132.046 190.166 132.071 190.522 131.853Z",
        fill: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M190.522 126.853L190.625 126.781L195.625 122.781C196.056 122.436 196.126 121.807 195.781 121.375C195.462 120.977 194.902 120.887 194.478 121.147L194.375 121.219L190 124.72L185.625 121.219C185.227 120.901 184.66 120.936 184.304 121.282L184.219 121.375C183.901 121.773 183.936 122.34 184.282 122.696L184.375 122.781L189.375 126.781C189.707 127.046 190.166 127.071 190.522 126.853Z",
        fill: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M190.522 121.853L190.625 121.781L195.625 117.781C196.056 117.436 196.126 116.807 195.781 116.375C195.462 115.977 194.902 115.887 194.478 116.147L194.375 116.219L190 119.72L185.625 116.219C185.227 115.901 184.66 115.936 184.304 116.282L184.219 116.375C183.901 116.773 183.936 117.34 184.282 117.696L184.375 117.781L189.375 121.781C189.707 122.046 190.166 122.071 190.522 121.853Z",
        fill: "#4C9AFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 210,
        y: 121,
        width: 66,
        height: 6,
        rx: 6,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 178,
        y: 159,
        width: 98,
        height: 6,
        rx: 6,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 178,
        y: 188,
        width: 52,
        height: 20,
        rx: 6,
        fill: "#2C333A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 182,
        y: 195,
        width: 44,
        height: 6,
        rx: 6,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("g", {
        opacity: 0.8
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 177,
        y: 230,
        width: 18,
        height: 18,
        rx: 9,
        stroke: "#282E33",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("circle", {
        cx: 186,
        cy: 239,
        r: 8,
        fill: "url(#pattern0_233_7667)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 202,
        y: 236,
        width: 71,
        height: 6,
        rx: 6,
        fill: "#454F59"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 178,
        y: 273,
        width: 126,
        height: 6,
        rx: 6,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 178,
        y: 311,
        width: 126,
        height: 6,
        rx: 6,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 178,
        y: 349,
        width: 126,
        height: 6,
        rx: 6,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 178,
        y: 387,
        width: 126,
        height: 6,
        rx: 6,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 178,
        y: 425,
        width: 126,
        height: 6,
        rx: 6,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 178,
        y: 463,
        width: 126,
        height: 6,
        rx: 6,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("pattern", {
        id: "pattern0_233_7667",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("use", {
        xlinkHref: "#image0_233_7667",
        transform: "scale(0.0025)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("image", {
        id: "image0_233_7667",
        width: 400,
        height: 400,
        preserveAspectRatio: "none",
        xlinkHref: "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAwADADASIAAhEBAxEB/8QAGwAAAgIDAQAAAAAAAAAAAAAAAAcDBgQFCAH/xAAsEAABAwMCBQMDBQAAAAAAAAABAgMEAAURBiESEzFBUQeBkSJhcRQVMjOh/8QAFwEBAQEBAAAAAAAAAAAAAAAABwYEBf/EACkRAAEEAQIFBAIDAAAAAAAAAAECAwQRAAVREyExYYEGEnGhB0GisfD/2gAMAwEAAhEDEQA/AKVRRWXa4S7hObjt7FR3PgdzTLIkNxmlPvGkpBJOwHXDtllb7iWmxalGgO5zFSCo4SCT4FCkKQcKSUn7jFOpnRMqzx0CLDS4CASto8Sj+e9TtaQm3VBblREIaPeQMfA60YufktYlcJuEoo3ujW9VX8vOXSPRCSxxFyUhW1cvi7v68YjaK3GqLOqz3JbIyWiTw57YOCPatPSTAnM6hHRKjm0KFj/bg8j3yJlxXIbymHhSk9cKYXo9ZjOvBlvI4oqFBk468WOLf7fT/tL2rHorVc3S9wDkdQVFcUnntKGeJIO+PBxnesevQXJ8ByM11VXX9gEEjyBWatIlIiS0POdBf9EA+M6foqKLIalRmpEdYcZdQFoUOikkZBqU0QkEGjiMCCLGJj1ss/JImR0HlBaVOE9ApeRt7ppSVd/U3WMjUF1fhsOj9qju4aSkf2EbcZPffOPtVIpV9M6e5p0BLLnKyVVt7jdfeH+uzETJZcRsBe9csK9QlS1hKElSj0AGSakiR1ypTTDQytxQSKY9stsa3NBMdAC8fU4f5K9660mUlgVVk5zmWC78YxPTX9XC0Xa2ZjauMIKglWykpKiQPgitzfHJEu0TY8RPA86wtCFZ34ikgVW7Xq3ltJbuDKnCnbmN4yfyKnnawZ5ZEGMsuHop3AA9h1otf0+Y5KU57OZUT25m8v2Z0REcI93QV36VnO8iO9GcLchpbTg2KVpII+ajpqXdhF35huA5q1nJX3B8jxSzuEVUKa9HXuW1Yz5HY/FKESXxxShSsgZDHCNg2M//2Q=="
    })));
};

});

parcelRegister("59WEZ", function(module, exports) {
$parcel$export(module.exports, "SideNav", function () { return $3c1b4bb4bcdc3a87$export$1a35787d6353cf6a; });
/* side-nav.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $1oC0p = parcelRequire("1oC0p");

var $iPbQS = parcelRequire("iPbQS");

var $80D8g = parcelRequire("80D8g");
var $3c1b4bb4bcdc3a87$var$styles = {
    background: "_1s7zia51 _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"
};
var $3c1b4bb4bcdc3a87$export$1a35787d6353cf6a = function SideNav() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $80D8g.AboveMediumScreen), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $iPbQS.default), {
        xcss: $3c1b4bb4bcdc3a87$var$styles.background
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($3c1b4bb4bcdc3a87$var$Illustration, null)));
};
var $3c1b4bb4bcdc3a87$var$Illustration = function Illustration() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 296,
        height: 473,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("g", {
        clipPath: "url(#a)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 5.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 9,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 17.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 48.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 52.96,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 60.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "m283.939 64.5-3.969-3.97 1.06-1.06 4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 91.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 95.96,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 103.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "m283.939 107.5-3.969-3.97 1.06-1.06 4.5 4.5a.749.749 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 134.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 138.96,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 146.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "M265.25 151.25v4.25h1.5v-4.25H271v-1.5h-4.25v-4.25h-1.5v4.25H261v1.5h4.25ZM285.25 150.75a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        d: "M285.5 150.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM290.25 150.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM295 150.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 72,
        height: 9,
        x: 20,
        y: 189,
        fill: "#596773",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 278,
        height: 43,
        x: 18,
        y: 215,
        fill: "#1C2B41",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M22 220.5h32v32H22z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 24,
        height: 24,
        x: 26,
        y: 224,
        fill: "#05C",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#1868DB",
        d: "M18 229h2.66v15.96H18z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 112,
        height: 8,
        x: 66,
        y: 232.5,
        fill: "#05C",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "M259.25 237.25v4.25h1.5v-4.25H265v-1.5h-4.25v-4.25h-1.5v4.25H255v1.5h4.25ZM279.25 236.75a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        d: "M279.5 236.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM284.25 236.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM289 236.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M22 263.5h32v32H22z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 24,
        height: 24,
        x: 26,
        y: 267,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 112,
        height: 8,
        x: 66,
        y: 275.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M22 306.5h32v32H22z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 24,
        height: 24,
        x: 26,
        y: 310,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 112,
        height: 8,
        x: 66,
        y: 318.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M20 349.5h32v32H20z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "M39 360.5H25V359h14v1.5Zm0 5.25H25v-1.5h14v1.5ZM32 371h-7v-1.5h7v1.5Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 112,
        height: 8,
        x: 64,
        y: 361.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 392.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 396.96,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 404.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "m283.939 408.5-3.969-3.97 1.06-1.06 4.5 4.5a.749.749 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 435.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "M9.667 451.333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM8 451a1.667 1.667 0 1 1 3.333 0A1.667 1.667 0 0 1 8 451Zm8 .333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM14.333 451a1.667 1.667 0 1 1 3.334 0 1.667 1.667 0 0 1-3.334 0Zm8 .333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM20.667 451A1.667 1.667 0 1 1 24 451a1.667 1.667 0 0 1-3.333 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        d: "M10 451a.333.333 0 1 1-.666 0 .333.333 0 0 1 .666 0ZM16.333 451a.333.333 0 1 1-.666 0 .333.333 0 0 1 .666 0ZM22.667 451a.333.333 0 1 1-.667 0 .333.333 0 0 1 .667 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 60,
        height: 8,
        x: 44,
        y: 447.5,
        fill: "#454F59",
        rx: 3.99
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("clipPath", {
        id: "a"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#fff",
        d: "M0 0h296v473H0z"
    }))));
};

});


parcelRegister("jL79O", function(module, exports) {
$parcel$export(module.exports, "JiraLightTheme", function () { return $e627f55fcb70a632$export$8e2414c6a082747f; });
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $1oC0p = parcelRequire("1oC0p");

var $Vy11d = parcelRequire("Vy11d");

var $eIrG8 = parcelRequire("eIrG8");
var $8LHZg = parcelRequire("8LHZg");

var $eRtiE = parcelRequire("eRtiE");

var $8wHjQ = parcelRequire("8wHjQ");

var $3ohI9 = parcelRequire("3ohI9");

var $dqpnA = parcelRequire("dqpnA");

var $kFfcm = parcelRequire("kFfcm");

var $avWtL = parcelRequire("avWtL");

var $mEYC3 = parcelRequire("mEYC3");

var $8ZAf4 = parcelRequire("8ZAf4");

var $cZdDd = parcelRequire("cZdDd");

var $hx9Oi = parcelRequire("hx9Oi");

var $4N7fh = parcelRequire("4N7fh");

var $273CW = parcelRequire("273CW");
var $e627f55fcb70a632$var$styles = {
    actions: "_ca0qxy5q _u5f3xy5q _n3tdxy5q _19bvxy5q",
    content: "_19bvxy5q",
    container: "_1reo15vq"
};
var $e627f55fcb70a632$export$8e2414c6a082747f = function JiraLightTheme() {
    if ((0, $Vy11d.fg)('cfind_4831_product_overlay_modal_visual_updates')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $8wHjQ.Background), {
        testId: "testId-jira-wireframe"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $8LHZg.default), {
        xcss: $e627f55fcb70a632$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $3ohI9.TopNav), {
        product: (0, $eRtiE.Products).JIRA
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eIrG8.default), {
        alignBlock: "stretch",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $8ZAf4.SideNav), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $8LHZg.default), {
        grow: "fill",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $mEYC3.BodyNav), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $avWtL.Board), null)))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $8wHjQ.Background), {
        testId: "testId-jira-wireframe"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $dqpnA.TopNav), {
        product: (0, $eRtiE.Products).JIRA
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eIrG8.default), {
        alignBlock: "stretch",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $273CW.SideNav), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $8LHZg.default), {
        grow: "fill",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eIrG8.default), {
        xcss: $e627f55fcb70a632$var$styles.actions,
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cZdDd.Breadcrumbs), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kFfcm.Actions), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eIrG8.default), {
        xcss: $e627f55fcb70a632$var$styles.content,
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $hx9Oi.Content), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4N7fh.DetailsPanel), null)))));
};

});
parcelRegister("avWtL", function(module, exports) {
$parcel$export(module.exports, "Board", function () { return $7a7a29600519de0d$export$dc537a3a3893548e; });
/* board.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5kYca = parcelRequire("5kYca");

var $1oC0p = parcelRequire("1oC0p");

var $eIrG8 = parcelRequire("eIrG8");
var $7a7a29600519de0d$var$styles = {
    rowSpacing: "_ca0qxy5q _u5f3xy5q _19bvxy5q",
    boardImage: "_1reoewfl _18m9ewfl"
};
var $7a7a29600519de0d$export$dc537a3a3893548e = function Board() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eIrG8.default), {
        xcss: $7a7a29600519de0d$var$styles.rowSpacing,
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($7a7a29600519de0d$var$SearchAndAvatarsImage, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($7a7a29600519de0d$var$OptionsImage, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eIrG8.default), {
        xcss: $7a7a29600519de0d$var$styles.rowSpacing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($7a7a29600519de0d$var$BoardImage, null)));
};
var $7a7a29600519de0d$var$SearchAndAvatarsImage = function SearchAndAvatarsImage() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: "176",
        height: "34",
        viewBox: "0 0 176 34",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: "0.5",
        y: "2.5",
        width: "110",
        height: "29",
        rx: "4.5",
        stroke: "black",
        strokeOpacity: "0.2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: "146.625",
        y: "2.625",
        width: "28.75",
        height: "28.75",
        rx: "14.375",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "1.25"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M161.938 16.0625V9.5H160.062V16.0625H153.5V17.9375H160.062V24.5H161.937V17.9375H168.5V16.0625H161.938Z",
        fill: "#D2D2D2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: "118.5",
        y: "0.5",
        width: "33",
        height: "33",
        rx: "16.5",
        fill: "#DDDEE1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: "118.5",
        y: "0.5",
        width: "33",
        height: "33",
        rx: "16.5",
        stroke: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M128 26.5L128 24.0001C128 21.7909 129.791 20 132 20H138C140.209 20 142 21.7908 142 23.9999L142 26.5M139.5 12C139.5 14.4853 137.485 16.5 135 16.5C132.515 16.5 130.5 14.4853 130.5 12C130.5 9.51472 132.515 7.5 135 7.5C137.485 7.5 139.5 9.51472 139.5 12Z",
        stroke: "#505258",
        strokeWidth: "2"
    }));
};
var $7a7a29600519de0d$var$OptionsImage = function OptionsImage() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: "194",
        height: "30",
        viewBox: "0 0 194 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: "0.5",
        y: "0.5",
        width: "110",
        height: "29",
        rx: "4.5",
        stroke: "black",
        strokeOpacity: "0.2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: "124.5",
        y: "0.5",
        width: "29",
        height: "29",
        rx: "4.5",
        stroke: "black",
        strokeOpacity: "0.2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: "164.5",
        y: "0.5",
        width: "29",
        height: "29",
        rx: "4.5",
        stroke: "black",
        strokeOpacity: "0.2"
    }));
};
var $7a7a29600519de0d$var$BoardImage = function BoardImage() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: "1377",
        height: "494",
        viewBox: "0 0 1377 494",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, $5kYca.default)([
            $7a7a29600519de0d$var$styles.boardImage
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "260",
        height: "494",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "75",
        height: "12",
        x: "12",
        y: "13",
        fill: "#d2d2d2",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "14",
        height: "14",
        x: "189",
        y: "12",
        fill: "#d2d2d2",
        rx: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "14",
        height: "14",
        x: "210",
        y: "12",
        fill: "#d2d2d2",
        rx: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "252",
        height: "110",
        x: "4",
        y: "36",
        fill: "#fff",
        rx: "2.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#e2483d",
        d: "m212.597 126.756-4.889 3.111.806 1.266 4.486-2.855 4.486 2.855.805-1.266-4.889-3.111a.75.75 0 0 0-.805 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#357de8",
        d: "m22.655 130.28 3.938-3.937-1.06-1.061-3.408 3.407-1.22-1.219-1.06 1.06 1.75 1.75a.75.75 0 0 0 1.06 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#357de8",
        fillRule: "evenodd",
        d: "M16 123a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H18a2 2 0 0 1-2-2zm2-.5h10a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5H18a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "18",
        height: "18",
        x: "228",
        y: "119",
        fill: "url(#a)",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "17",
        height: "17",
        x: "228.5",
        y: "119.5",
        fill: "#dddee1",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "17",
        height: "17",
        x: "228.5",
        y: "119.5",
        stroke: "#fff",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        stroke: "#505258",
        d: "M233.5 132.75v-1.25a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1.25m-1.25-7.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "168",
        height: "12",
        x: "13",
        y: "48",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "141",
        height: "12",
        x: "13",
        y: "69",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "54",
        height: "8",
        x: "38",
        y: "124",
        fill: "#eee",
        rx: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "252",
        height: "110",
        x: "4",
        y: "150",
        fill: "#fff",
        rx: "2.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#357de8",
        d: "m207.708 239.078 4.889 3.111a.75.75 0 0 0 .805 0l4.889-3.111-.805-1.266-4.486 2.855-4.486-2.855z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#357de8",
        d: "m207.708 243.522 4.889 3.111c.246.156.56.156.806 0l4.888-3.111-.805-1.266-4.486 2.855-4.486-2.855zM22.655 244.28l3.938-3.937-1.06-1.061-3.408 3.407-1.22-1.219-1.06 1.06 1.75 1.75a.75.75 0 0 0 1.06 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#357de8",
        fillRule: "evenodd",
        d: "M16 237a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H18a2 2 0 0 1-2-2zm2-.5h10a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5H18a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "18",
        height: "18",
        x: "228",
        y: "233",
        fill: "url(#b)",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "17",
        height: "17",
        x: "228.5",
        y: "233.5",
        fill: "#dddee1",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "17",
        height: "17",
        x: "228.5",
        y: "233.5",
        stroke: "#fff",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        stroke: "#505258",
        d: "M233.5 246.75v-1.25a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1.25m-1.25-7.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "17",
        height: "17",
        x: "228.5",
        y: "233.5",
        fill: "#dddee1",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "17",
        height: "17",
        x: "228.5",
        y: "233.5",
        stroke: "#fff",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        stroke: "#505258",
        d: "M233.5 246.75v-1.25a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1.25m-1.25-7.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "168",
        height: "12",
        x: "13",
        y: "162",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "141",
        height: "12",
        x: "13",
        y: "183",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "54",
        height: "8",
        x: "38",
        y: "238",
        fill: "#eee",
        rx: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "252",
        height: "110",
        x: "4",
        y: "264",
        fill: "#fff",
        rx: "2.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#e2483d",
        d: "m212.597 354.756-4.889 3.111.806 1.266 4.486-2.855 4.486 2.855.805-1.266-4.889-3.111a.75.75 0 0 0-.805 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#357de8",
        d: "m22.655 358.28 3.938-3.937-1.06-1.061-3.408 3.407-1.22-1.219-1.06 1.06 1.75 1.75a.75.75 0 0 0 1.06 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#357de8",
        fillRule: "evenodd",
        d: "M16 351a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H18a2 2 0 0 1-2-2zm2-.5h10a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5H18a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "18",
        height: "18",
        x: "228",
        y: "347",
        fill: "url(#c)",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "17",
        height: "17",
        x: "228.5",
        y: "347.5",
        fill: "#dddee1",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "17",
        height: "17",
        x: "228.5",
        y: "347.5",
        stroke: "#fff",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        stroke: "#505258",
        d: "M233.5 360.75v-1.25a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1.25m-1.25-7.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "168",
        height: "12",
        x: "13",
        y: "276",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "141",
        height: "12",
        x: "13",
        y: "297",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "54",
        height: "8",
        x: "38",
        y: "352",
        fill: "#eee",
        rx: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "252",
        height: "110",
        x: "4",
        y: "378",
        fill: "#fff",
        rx: "2.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#e2483d",
        d: "m207.597 464.367-4.889 3.111.806 1.266 4.486-2.855 4.486 2.855.805-1.266-4.888-3.111a.75.75 0 0 0-.806 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#e2483d",
        d: "m207.597 468.812-4.889 3.111.806 1.266 4.486-2.855 4.486 2.855.805-1.266-4.888-3.111a.75.75 0 0 0-.806 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#e2483d",
        d: "m202.708 476.367 4.889-3.111a.75.75 0 0 1 .805 0l4.889 3.111-.805 1.266-4.486-2.855-4.486 2.855z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#357de8",
        d: "m22.655 472.28 3.938-3.937-1.06-1.061-3.408 3.407-1.22-1.219-1.06 1.06 1.75 1.75a.75.75 0 0 0 1.06 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#357de8",
        fillRule: "evenodd",
        d: "M16 465a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H18a2 2 0 0 1-2-2zm2-.5h10a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5H18a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "18",
        height: "18",
        x: "228",
        y: "461",
        fill: "url(#d)",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "17",
        height: "17",
        x: "228.5",
        y: "461.5",
        fill: "#dddee1",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "17",
        height: "17",
        x: "228.5",
        y: "461.5",
        stroke: "#fff",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        stroke: "#505258",
        d: "M233.5 474.75v-1.25a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1.25m-1.25-7.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "168",
        height: "12",
        x: "13",
        y: "390",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "141",
        height: "12",
        x: "13",
        y: "411",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "54",
        height: "8",
        x: "38",
        y: "466",
        fill: "#eee",
        rx: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "260",
        height: "494",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "75",
        height: "12",
        x: "12",
        y: "13",
        fill: "#d2d2d2",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "14",
        height: "14",
        x: "189",
        y: "12",
        fill: "#d2d2d2",
        rx: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "14",
        height: "14",
        x: "210",
        y: "12",
        fill: "#d2d2d2",
        rx: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "252",
        height: "110",
        x: "4",
        y: "36",
        fill: "#fff",
        rx: "2.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#e2483d",
        d: "m212.597 126.756-4.889 3.111.806 1.266 4.486-2.855 4.486 2.855.805-1.266-4.889-3.111a.75.75 0 0 0-.805 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#357de8",
        d: "m22.655 130.28 3.938-3.937-1.06-1.061-3.408 3.407-1.22-1.219-1.06 1.06 1.75 1.75a.75.75 0 0 0 1.06 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#357de8",
        fillRule: "evenodd",
        d: "M16 123a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H18a2 2 0 0 1-2-2zm2-.5h10a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5H18a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "18",
        height: "18",
        x: "228",
        y: "119",
        fill: "url(#e)",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "17",
        height: "17",
        x: "228.5",
        y: "119.5",
        fill: "#dddee1",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "17",
        height: "17",
        x: "228.5",
        y: "119.5",
        stroke: "#fff",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        stroke: "#505258",
        d: "M233.5 132.75v-1.25a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1.25m-1.25-7.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "168",
        height: "12",
        x: "13",
        y: "48",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "141",
        height: "12",
        x: "13",
        y: "69",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "54",
        height: "8",
        x: "38",
        y: "124",
        fill: "#eee",
        rx: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "252",
        height: "110",
        x: "4",
        y: "150",
        fill: "#fff",
        rx: "2.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#357de8",
        d: "m207.708 239.078 4.889 3.111a.75.75 0 0 0 .805 0l4.889-3.111-.805-1.266-4.486 2.855-4.486-2.855z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#357de8",
        d: "m207.708 243.522 4.889 3.111c.246.156.56.156.806 0l4.888-3.111-.805-1.266-4.486 2.855-4.486-2.855zM22.655 244.28l3.938-3.937-1.06-1.061-3.408 3.407-1.22-1.219-1.06 1.06 1.75 1.75a.75.75 0 0 0 1.06 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#357de8",
        fillRule: "evenodd",
        d: "M16 237a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H18a2 2 0 0 1-2-2zm2-.5h10a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5H18a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "18",
        height: "18",
        x: "228",
        y: "233",
        fill: "url(#f)",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "17",
        height: "17",
        x: "228.5",
        y: "233.5",
        fill: "#dddee1",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "17",
        height: "17",
        x: "228.5",
        y: "233.5",
        stroke: "#fff",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        stroke: "#505258",
        d: "M233.5 246.75v-1.25a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1.25m-1.25-7.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "17",
        height: "17",
        x: "228.5",
        y: "233.5",
        fill: "#dddee1",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "17",
        height: "17",
        x: "228.5",
        y: "233.5",
        stroke: "#fff",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        stroke: "#505258",
        d: "M233.5 246.75v-1.25a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1.25m-1.25-7.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "168",
        height: "12",
        x: "13",
        y: "162",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "141",
        height: "12",
        x: "13",
        y: "183",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "54",
        height: "8",
        x: "38",
        y: "238",
        fill: "#eee",
        rx: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "252",
        height: "110",
        x: "4",
        y: "264",
        fill: "#fff",
        rx: "2.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#e2483d",
        d: "m212.597 354.756-4.889 3.111.806 1.266 4.486-2.855 4.486 2.855.805-1.266-4.889-3.111a.75.75 0 0 0-.805 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#357de8",
        d: "m22.655 358.28 3.938-3.937-1.06-1.061-3.408 3.407-1.22-1.219-1.06 1.06 1.75 1.75a.75.75 0 0 0 1.06 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#357de8",
        fillRule: "evenodd",
        d: "M16 351a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H18a2 2 0 0 1-2-2zm2-.5h10a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5H18a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "18",
        height: "18",
        x: "228",
        y: "347",
        fill: "url(#g)",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "17",
        height: "17",
        x: "228.5",
        y: "347.5",
        fill: "#dddee1",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "17",
        height: "17",
        x: "228.5",
        y: "347.5",
        stroke: "#fff",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        stroke: "#505258",
        d: "M233.5 360.75v-1.25a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1.25m-1.25-7.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "168",
        height: "12",
        x: "13",
        y: "276",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "141",
        height: "12",
        x: "13",
        y: "297",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "54",
        height: "8",
        x: "38",
        y: "352",
        fill: "#eee",
        rx: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "252",
        height: "110",
        x: "4",
        y: "378",
        fill: "#fff",
        rx: "2.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#e2483d",
        d: "m207.597 464.367-4.889 3.111.806 1.266 4.486-2.855 4.486 2.855.805-1.266-4.888-3.111a.75.75 0 0 0-.806 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#e2483d",
        d: "m207.597 468.812-4.889 3.111.806 1.266 4.486-2.855 4.486 2.855.805-1.266-4.888-3.111a.75.75 0 0 0-.806 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#e2483d",
        d: "m202.708 476.367 4.889-3.111a.75.75 0 0 1 .805 0l4.889 3.111-.805 1.266-4.486-2.855-4.486 2.855z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#357de8",
        d: "m22.655 472.28 3.938-3.937-1.06-1.061-3.408 3.407-1.22-1.219-1.06 1.06 1.75 1.75a.75.75 0 0 0 1.06 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#357de8",
        fillRule: "evenodd",
        d: "M16 465a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H18a2 2 0 0 1-2-2zm2-.5h10a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5H18a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "18",
        height: "18",
        x: "228",
        y: "461",
        fill: "url(#h)",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "17",
        height: "17",
        x: "228.5",
        y: "461.5",
        fill: "#dddee1",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "17",
        height: "17",
        x: "228.5",
        y: "461.5",
        stroke: "#fff",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        stroke: "#505258",
        d: "M233.5 474.75v-1.25a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1.25m-1.25-7.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "168",
        height: "12",
        x: "13",
        y: "390",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "141",
        height: "12",
        x: "13",
        y: "411",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "54",
        height: "8",
        x: "38",
        y: "466",
        fill: "#eee",
        rx: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "260",
        height: "378",
        x: "1117",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "75",
        height: "12",
        x: "1129",
        y: "13",
        fill: "#d2d2d2",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "14",
        height: "14",
        x: "1306",
        y: "12",
        fill: "#d2d2d2",
        rx: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "14",
        height: "14",
        x: "1327",
        y: "12",
        fill: "#d2d2d2",
        rx: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "252",
        height: "110",
        x: "1121",
        y: "36",
        fill: "#fff",
        rx: "2.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#e2483d",
        d: "m1329.6 126.756-4.89 3.111.8 1.266 4.49-2.855 4.49 2.855.8-1.266-4.89-3.111a.74.74 0 0 0-.8 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#357de8",
        d: "m1139.66 130.28 3.93-3.937-1.06-1.061-3.41 3.407-1.21-1.219-1.07 1.06 1.75 1.75c.3.293.77.293 1.07 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#357de8",
        fillRule: "evenodd",
        d: "M1133 123c0-1.105.9-2 2-2h10c1.1 0 2 .895 2 2v10c0 1.105-.9 2-2 2h-10c-1.1 0-2-.895-2-2zm2-.5h10c.28 0 .5.224.5.5v10c0 .276-.22.5-.5.5h-10c-.28 0-.5-.224-.5-.5v-10c0-.276.22-.5.5-.5",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "18",
        height: "18",
        x: "1345",
        y: "119",
        fill: "url(#i)",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "17",
        height: "17",
        x: "1345.5",
        y: "119.5",
        fill: "#dddee1",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "17",
        height: "17",
        x: "1345.5",
        y: "119.5",
        stroke: "#fff",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        stroke: "#505258",
        d: "M1350.5 132.75v-1.25c0-1.105.9-2 2-2h3c1.1 0 2 .895 2 2v1.25m-1.25-7.25c0 1.243-1.01 2.25-2.25 2.25a2.25 2.25 0 0 1-2.25-2.25c0-1.243 1.01-2.25 2.25-2.25s2.25 1.007 2.25 2.25Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "168",
        height: "12",
        x: "1130",
        y: "48",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "141",
        height: "12",
        x: "1130",
        y: "69",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "54",
        height: "8",
        x: "1155",
        y: "124",
        fill: "#eee",
        rx: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "252",
        height: "110",
        x: "1121",
        y: "150",
        fill: "#fff",
        rx: "2.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#357de8",
        d: "m1324.71 239.078 4.89 3.111c.24.156.56.156.8 0l4.89-3.111-.8-1.266-4.49 2.855-4.49-2.855z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#357de8",
        d: "m1324.71 243.522 4.89 3.111c.24.156.56.156.8 0l4.89-3.111-.8-1.266-4.49 2.855-4.49-2.855zM1139.66 244.28l3.93-3.937-1.06-1.061-3.41 3.407-1.21-1.219-1.07 1.06 1.75 1.75c.3.293.77.293 1.07 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#357de8",
        fillRule: "evenodd",
        d: "M1133 237c0-1.105.9-2 2-2h10c1.1 0 2 .895 2 2v10c0 1.105-.9 2-2 2h-10c-1.1 0-2-.895-2-2zm2-.5h10c.28 0 .5.224.5.5v10c0 .276-.22.5-.5.5h-10c-.28 0-.5-.224-.5-.5v-10c0-.276.22-.5.5-.5",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "18",
        height: "18",
        x: "1345",
        y: "233",
        fill: "url(#j)",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "17",
        height: "17",
        x: "1345.5",
        y: "233.5",
        fill: "#dddee1",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "17",
        height: "17",
        x: "1345.5",
        y: "233.5",
        stroke: "#fff",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        stroke: "#505258",
        d: "M1350.5 246.75v-1.25c0-1.105.9-2 2-2h3c1.1 0 2 .895 2 2v1.25m-1.25-7.25c0 1.243-1.01 2.25-2.25 2.25a2.25 2.25 0 0 1-2.25-2.25c0-1.243 1.01-2.25 2.25-2.25s2.25 1.007 2.25 2.25Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "17",
        height: "17",
        x: "1345.5",
        y: "233.5",
        fill: "#dddee1",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "17",
        height: "17",
        x: "1345.5",
        y: "233.5",
        stroke: "#fff",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        stroke: "#505258",
        d: "M1350.5 246.75v-1.25c0-1.105.9-2 2-2h3c1.1 0 2 .895 2 2v1.25m-1.25-7.25c0 1.243-1.01 2.25-2.25 2.25a2.25 2.25 0 0 1-2.25-2.25c0-1.243 1.01-2.25 2.25-2.25s2.25 1.007 2.25 2.25Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "168",
        height: "12",
        x: "1130",
        y: "162",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "141",
        height: "12",
        x: "1130",
        y: "183",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "54",
        height: "8",
        x: "1155",
        y: "238",
        fill: "#eee",
        rx: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "252",
        height: "110",
        x: "1121",
        y: "264",
        fill: "#fff",
        rx: "2.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#e2483d",
        d: "m1329.6 354.756-4.89 3.111.8 1.266 4.49-2.855 4.49 2.855.8-1.266-4.89-3.111a.74.74 0 0 0-.8 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#357de8",
        d: "m1139.66 358.28 3.93-3.937-1.06-1.061-3.41 3.407-1.21-1.219-1.07 1.06 1.75 1.75c.3.293.77.293 1.07 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#357de8",
        fillRule: "evenodd",
        d: "M1133 351c0-1.105.9-2 2-2h10c1.1 0 2 .895 2 2v10c0 1.105-.9 2-2 2h-10c-1.1 0-2-.895-2-2zm2-.5h10c.28 0 .5.224.5.5v10c0 .276-.22.5-.5.5h-10c-.28 0-.5-.224-.5-.5v-10c0-.276.22-.5.5-.5",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "18",
        height: "18",
        x: "1345",
        y: "347",
        fill: "url(#k)",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "17",
        height: "17",
        x: "1345.5",
        y: "347.5",
        fill: "#dddee1",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "17",
        height: "17",
        x: "1345.5",
        y: "347.5",
        stroke: "#fff",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        stroke: "#505258",
        d: "M1350.5 360.75v-1.25c0-1.105.9-2 2-2h3c1.1 0 2 .895 2 2v1.25m-1.25-7.25c0 1.243-1.01 2.25-2.25 2.25a2.25 2.25 0 0 1-2.25-2.25c0-1.243 1.01-2.25 2.25-2.25s2.25 1.007 2.25 2.25Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "168",
        height: "12",
        x: "1130",
        y: "276",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "141",
        height: "12",
        x: "1130",
        y: "297",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "54",
        height: "8",
        x: "1155",
        y: "352",
        fill: "#eee",
        rx: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "260",
        height: "494",
        x: "280",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "103",
        height: "12",
        x: "292",
        y: "13",
        fill: "#d2d2d2",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "14",
        height: "14",
        x: "469",
        y: "12",
        fill: "#d2d2d2",
        rx: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "14",
        height: "14",
        x: "490",
        y: "12",
        fill: "#d2d2d2",
        rx: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "252",
        height: "110",
        x: "284",
        y: "36",
        fill: "#fff",
        rx: "2.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#e2483d",
        d: "m492.597 126.756-4.889 3.111.806 1.266 4.486-2.855 4.486 2.855.805-1.266-4.889-3.111a.75.75 0 0 0-.805 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#357de8",
        d: "m302.655 130.28 3.938-3.937-1.061-1.061-3.407 3.407-1.22-1.219-1.06 1.06 1.75 1.75a.75.75 0 0 0 1.06 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#357de8",
        fillRule: "evenodd",
        d: "M296 123a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2zm2-.5h10a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "18",
        height: "18",
        x: "508",
        y: "119",
        fill: "url(#l)",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "17",
        height: "17",
        x: "508.5",
        y: "119.5",
        fill: "#dddee1",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "17",
        height: "17",
        x: "508.5",
        y: "119.5",
        stroke: "#fff",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        stroke: "#505258",
        d: "M513.5 132.75v-1.25a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1.25m-1.25-7.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "168",
        height: "12",
        x: "293",
        y: "48",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "141",
        height: "12",
        x: "293",
        y: "69",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "54",
        height: "8",
        x: "318",
        y: "124",
        fill: "#eee",
        rx: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "252",
        height: "110",
        x: "284",
        y: "150",
        fill: "#fff",
        rx: "2.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#357de8",
        d: "m487.708 239.078 4.889 3.111a.75.75 0 0 0 .805 0l4.889-3.111-.805-1.266-4.486 2.855-4.486-2.855z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#357de8",
        d: "m487.708 243.522 4.889 3.111c.246.156.56.156.806 0l4.888-3.111-.805-1.266-4.486 2.855-4.486-2.855zM302.655 244.28l3.938-3.937-1.061-1.061-3.407 3.407-1.22-1.219-1.06 1.06 1.75 1.75a.75.75 0 0 0 1.06 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#357de8",
        fillRule: "evenodd",
        d: "M296 237a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2zm2-.5h10a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "18",
        height: "18",
        x: "508",
        y: "233",
        fill: "url(#m)",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "17",
        height: "17",
        x: "508.5",
        y: "233.5",
        fill: "#dddee1",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "17",
        height: "17",
        x: "508.5",
        y: "233.5",
        stroke: "#fff",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        stroke: "#505258",
        d: "M513.5 246.75v-1.25a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1.25m-1.25-7.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "168",
        height: "12",
        x: "293",
        y: "162",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "141",
        height: "12",
        x: "293",
        y: "183",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "54",
        height: "8",
        x: "318",
        y: "238",
        fill: "#eee",
        rx: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "252",
        height: "110",
        x: "284",
        y: "264",
        fill: "#fff",
        rx: "2.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#e2483d",
        d: "m492.597 354.756-4.889 3.111.806 1.266 4.486-2.855 4.486 2.855.805-1.266-4.889-3.111a.75.75 0 0 0-.805 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#357de8",
        d: "m302.655 358.28 3.938-3.937-1.061-1.061-3.407 3.407-1.22-1.219-1.06 1.06 1.75 1.75a.75.75 0 0 0 1.06 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#357de8",
        fillRule: "evenodd",
        d: "M296 351a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2zm2-.5h10a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "18",
        height: "18",
        x: "508",
        y: "347",
        fill: "url(#n)",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "17",
        height: "17",
        x: "508.5",
        y: "347.5",
        fill: "#dddee1",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "17",
        height: "17",
        x: "508.5",
        y: "347.5",
        stroke: "#fff",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        stroke: "#505258",
        d: "M513.5 360.75v-1.25a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1.25m-1.25-7.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "168",
        height: "12",
        x: "293",
        y: "276",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "141",
        height: "12",
        x: "293",
        y: "297",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "54",
        height: "8",
        x: "318",
        y: "352",
        fill: "#eee",
        rx: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "252",
        height: "110",
        x: "284",
        y: "378",
        fill: "#fff",
        rx: "2.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#e2483d",
        d: "m492.597 468.756-4.889 3.111.806 1.266 4.486-2.855 4.486 2.855.805-1.266-4.889-3.111a.75.75 0 0 0-.805 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#357de8",
        d: "m302.655 472.28 3.938-3.937-1.061-1.061-3.407 3.407-1.22-1.219-1.06 1.06 1.75 1.75a.75.75 0 0 0 1.06 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#357de8",
        fillRule: "evenodd",
        d: "M296 465a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2zm2-.5h10a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "18",
        height: "18",
        x: "508",
        y: "461",
        fill: "url(#o)",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "17",
        height: "17",
        x: "508.5",
        y: "461.5",
        fill: "#dddee1",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "17",
        height: "17",
        x: "508.5",
        y: "461.5",
        stroke: "#fff",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        stroke: "#505258",
        d: "M513.5 474.75v-1.25a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1.25m-1.25-7.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "168",
        height: "12",
        x: "293",
        y: "390",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "141",
        height: "12",
        x: "293",
        y: "411",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "54",
        height: "8",
        x: "318",
        y: "466",
        fill: "#eee",
        rx: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "260",
        height: "494",
        x: "559",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "75",
        height: "12",
        x: "571",
        y: "13",
        fill: "#d2d2d2",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "14",
        height: "14",
        x: "748",
        y: "12",
        fill: "#d2d2d2",
        rx: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "14",
        height: "14",
        x: "769",
        y: "12",
        fill: "#d2d2d2",
        rx: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "252",
        height: "110",
        x: "563",
        y: "36",
        fill: "#fff",
        rx: "2.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#e2483d",
        d: "m771.597 126.756-4.889 3.111.806 1.266 4.486-2.855 4.486 2.855.805-1.266-4.889-3.111a.75.75 0 0 0-.805 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#357de8",
        d: "m581.655 130.28 3.938-3.937-1.061-1.061-3.407 3.407-1.22-1.219-1.06 1.06 1.75 1.75a.75.75 0 0 0 1.06 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#357de8",
        fillRule: "evenodd",
        d: "M575 123a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2zm2-.5h10a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "18",
        height: "18",
        x: "787",
        y: "119",
        fill: "url(#p)",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "17",
        height: "17",
        x: "787.5",
        y: "119.5",
        fill: "#dddee1",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "17",
        height: "17",
        x: "787.5",
        y: "119.5",
        stroke: "#fff",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        stroke: "#505258",
        d: "M792.5 132.75v-1.25a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1.25m-1.25-7.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "168",
        height: "12",
        x: "572",
        y: "48",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "141",
        height: "12",
        x: "572",
        y: "69",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "54",
        height: "8",
        x: "597",
        y: "124",
        fill: "#eee",
        rx: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "252",
        height: "110",
        x: "563",
        y: "150",
        fill: "#fff",
        rx: "2.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#357de8",
        d: "m766.708 239.078 4.889 3.111a.75.75 0 0 0 .805 0l4.889-3.111-.805-1.266-4.486 2.855-4.486-2.855z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#357de8",
        d: "m766.708 243.522 4.889 3.111c.246.156.56.156.806 0l4.888-3.111-.805-1.266-4.486 2.855-4.486-2.855zM581.655 244.28l3.938-3.937-1.061-1.061-3.407 3.407-1.22-1.219-1.06 1.06 1.75 1.75a.75.75 0 0 0 1.06 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#357de8",
        fillRule: "evenodd",
        d: "M575 237a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2zm2-.5h10a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "18",
        height: "18",
        x: "787",
        y: "233",
        fill: "url(#q)",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "18",
        height: "18",
        x: "787",
        y: "233",
        fill: "#fff",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "18",
        height: "18",
        x: "787",
        y: "233",
        stroke: "#fff",
        strokeWidth: "2",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("circle", {
        cx: "796",
        cy: "242",
        r: "8",
        fill: "url(#r)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "17",
        height: "17",
        x: "787.5",
        y: "233.5",
        fill: "#dddee1",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "17",
        height: "17",
        x: "787.5",
        y: "233.5",
        stroke: "#fff",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        stroke: "#505258",
        d: "M792.5 246.75v-1.25a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1.25m-1.25-7.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "168",
        height: "12",
        x: "572",
        y: "162",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "141",
        height: "12",
        x: "572",
        y: "183",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "54",
        height: "8",
        x: "597",
        y: "238",
        fill: "#eee",
        rx: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "252",
        height: "110",
        x: "563",
        y: "264",
        fill: "#fff",
        rx: "2.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#e2483d",
        d: "m771.597 354.756-4.889 3.111.806 1.266 4.486-2.855 4.486 2.855.805-1.266-4.889-3.111a.75.75 0 0 0-.805 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#357de8",
        d: "m581.655 358.28 3.938-3.937-1.061-1.061-3.407 3.407-1.22-1.219-1.06 1.06 1.75 1.75a.75.75 0 0 0 1.06 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#357de8",
        fillRule: "evenodd",
        d: "M575 351a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2zm2-.5h10a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "18",
        height: "18",
        x: "787",
        y: "347",
        fill: "url(#s)",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "17",
        height: "17",
        x: "787.5",
        y: "347.5",
        fill: "#dddee1",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "17",
        height: "17",
        x: "787.5",
        y: "347.5",
        stroke: "#fff",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        stroke: "#505258",
        d: "M792.5 360.75v-1.25a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1.25m-1.25-7.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "168",
        height: "12",
        x: "572",
        y: "276",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "141",
        height: "12",
        x: "572",
        y: "297",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "54",
        height: "8",
        x: "597",
        y: "352",
        fill: "#eee",
        rx: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "252",
        height: "110",
        x: "563",
        y: "378",
        fill: "#fff",
        rx: "2.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#e2483d",
        d: "m766.597 464.367-4.889 3.111.806 1.266 4.486-2.855 4.486 2.855.805-1.266-4.888-3.111a.75.75 0 0 0-.806 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#e2483d",
        d: "m766.597 468.812-4.889 3.111.806 1.266 4.486-2.855 4.486 2.855.805-1.266-4.888-3.111a.75.75 0 0 0-.806 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#e2483d",
        d: "m761.708 476.367 4.889-3.111a.75.75 0 0 1 .805 0l4.889 3.111-.805 1.266-4.486-2.855-4.486 2.855z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#357de8",
        d: "m581.655 472.28 3.938-3.937-1.061-1.061-3.407 3.407-1.22-1.219-1.06 1.06 1.75 1.75a.75.75 0 0 0 1.06 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#357de8",
        fillRule: "evenodd",
        d: "M575 465a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2zm2-.5h10a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "18",
        height: "18",
        x: "787",
        y: "461",
        fill: "url(#t)",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "17",
        height: "17",
        x: "787.5",
        y: "461.5",
        fill: "#dddee1",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "17",
        height: "17",
        x: "787.5",
        y: "461.5",
        stroke: "#fff",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        stroke: "#505258",
        d: "M792.5 474.75v-1.25a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1.25m-1.25-7.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "168",
        height: "12",
        x: "572",
        y: "390",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "141",
        height: "12",
        x: "572",
        y: "411",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "54",
        height: "8",
        x: "597",
        y: "466",
        fill: "#eee",
        rx: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "260",
        height: "264",
        x: "837",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "41",
        height: "12",
        x: "849",
        y: "13",
        fill: "#d2d2d2",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#6a9a23",
        d: "m908.061 17.06-6.308 6.309a.75.75 0 0 1-1.061 0l-2.753-2.753 1.061-1.06 2.222 2.222L907 16z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "14",
        height: "14",
        x: "1026",
        y: "12",
        fill: "#d2d2d2",
        rx: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "14",
        height: "14",
        x: "1047",
        y: "12",
        fill: "#d2d2d2",
        rx: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "252",
        height: "110",
        x: "841",
        y: "36",
        fill: "#fff",
        rx: "2.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#e2483d",
        d: "m1049.6 126.756-4.89 3.111.8 1.266 4.49-2.855 4.49 2.855.8-1.266-4.89-3.111a.74.74 0 0 0-.8 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#357de8",
        d: "m859.655 130.28 3.938-3.937-1.061-1.061-3.407 3.407-1.22-1.219-1.06 1.06 1.75 1.75a.75.75 0 0 0 1.06 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#357de8",
        fillRule: "evenodd",
        d: "M853 123a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2zm2-.5h10a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "18",
        height: "18",
        x: "1065",
        y: "119",
        fill: "url(#u)",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "17",
        height: "17",
        x: "1065.5",
        y: "119.5",
        fill: "#dddee1",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "17",
        height: "17",
        x: "1065.5",
        y: "119.5",
        stroke: "#fff",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        stroke: "#505258",
        d: "M1070.5 132.75v-1.25c0-1.105.9-2 2-2h3c1.1 0 2 .895 2 2v1.25m-1.25-7.25c0 1.243-1.01 2.25-2.25 2.25a2.25 2.25 0 0 1-2.25-2.25c0-1.243 1.01-2.25 2.25-2.25s2.25 1.007 2.25 2.25Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "168",
        height: "12",
        x: "850",
        y: "48",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "141",
        height: "12",
        x: "850",
        y: "69",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "54",
        height: "8",
        x: "875",
        y: "124",
        fill: "#eee",
        rx: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "252",
        height: "110",
        x: "841",
        y: "150",
        fill: "#fff",
        rx: "2.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#357de8",
        d: "m1044.71 239.078 4.89 3.111c.24.156.56.156.8 0l4.89-3.111-.8-1.266-4.49 2.855-4.49-2.855z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#357de8",
        d: "m1044.71 243.522 4.89 3.111c.24.156.56.156.8 0l4.89-3.111-.8-1.266-4.49 2.855-4.49-2.855zM859.655 244.28l3.938-3.937-1.061-1.061-3.407 3.407-1.22-1.219-1.06 1.06 1.75 1.75a.75.75 0 0 0 1.06 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#357de8",
        fillRule: "evenodd",
        d: "M853 237a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2zm2-.5h10a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "18",
        height: "18",
        x: "1065",
        y: "233",
        fill: "url(#v)",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "18",
        height: "18",
        x: "1065",
        y: "233",
        fill: "#fff",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "18",
        height: "18",
        x: "1065",
        y: "233",
        stroke: "#fff",
        strokeWidth: "2",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("circle", {
        cx: "1074",
        cy: "242",
        r: "8",
        fill: "url(#w)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "17",
        height: "17",
        x: "1065.5",
        y: "233.5",
        fill: "#dddee1",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "17",
        height: "17",
        x: "1065.5",
        y: "233.5",
        stroke: "#fff",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        stroke: "#505258",
        d: "M1070.5 246.75v-1.25c0-1.105.9-2 2-2h3c1.1 0 2 .895 2 2v1.25m-1.25-7.25c0 1.243-1.01 2.25-2.25 2.25a2.25 2.25 0 0 1-2.25-2.25c0-1.243 1.01-2.25 2.25-2.25s2.25 1.007 2.25 2.25Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "168",
        height: "12",
        x: "850",
        y: "162",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "141",
        height: "12",
        x: "850",
        y: "183",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "54",
        height: "8",
        x: "875",
        y: "238",
        fill: "#eee",
        rx: "4"
    }));
};

});

parcelRegister("mEYC3", function(module, exports) {
$parcel$export(module.exports, "BodyNav", function () { return $0441d74b0f5d32a3$export$d62bc198d96fc76d; });
/* body-nav.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5kYca = parcelRequire("5kYca");

var $1oC0p = parcelRequire("1oC0p");

var $8erHf = parcelRequire("8erHf");

var $eIrG8 = parcelRequire("eIrG8");
var $0441d74b0f5d32a3$var$styles = {
    rowSpacing: "_ca0qxy5q _u5f3xy5q _19bvxy5q",
    lastRow: "_n3tdxy5q _1doce4h9 _1il9nqa1 _1o3i14ap",
    image4Wrapper: "_4t3i1ou6"
};
var $0441d74b0f5d32a3$export$d62bc198d96fc76d = function BodyNav() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eIrG8.default), {
        xcss: $0441d74b0f5d32a3$var$styles.rowSpacing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($0441d74b0f5d32a3$var$Image1, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eIrG8.default), {
        xcss: $0441d74b0f5d32a3$var$styles.rowSpacing,
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($0441d74b0f5d32a3$var$Image2, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($0441d74b0f5d32a3$var$Image3, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eIrG8.default), {
        xcss: (0, $8erHf.cx)($0441d74b0f5d32a3$var$styles.rowSpacing, $0441d74b0f5d32a3$var$styles.lastRow)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", {
        className: (0, $5kYca.default)([
            $0441d74b0f5d32a3$var$styles.image4Wrapper
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($0441d74b0f5d32a3$var$Image4, null))));
};
var $0441d74b0f5d32a3$var$Image1 = function Image1() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: "84",
        height: "12",
        viewBox: "0 0 84 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "84",
        height: "12",
        rx: "5",
        fill: "#EEEEEE"
    }));
};
var $0441d74b0f5d32a3$var$Image2 = function Image2() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: "179",
        height: "8",
        viewBox: "0 0 179 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M-0.000390768 3.57603C-0.000390768 2.88803 0.159609 2.28003 0.479609 1.75203C0.783609 1.20803 1.20761 0.784029 1.75161 0.480029C2.27961 0.160029 2.88761 2.86102e-05 3.57561 2.86102e-05H17.1116C17.7996 2.86102e-05 18.4076 0.160029 18.9356 0.480029C19.4796 0.784029 19.9036 1.20803 20.2076 1.75203C20.5276 2.28003 20.6876 2.88803 20.6876 3.57603V3.62403C20.6876 4.31203 20.5276 4.92803 20.2076 5.47203C19.9036 6.00003 19.4796 6.42403 18.9356 6.74403C18.4076 7.04803 17.7996 7.20003 17.1116 7.20003H3.57561C2.88761 7.20003 2.27961 7.04803 1.75161 6.74403C1.20761 6.42403 0.783609 6.00003 0.479609 5.47203C0.159609 4.92803 -0.000390768 4.31203 -0.000390768 3.62403V3.57603ZM14.1256 3.57603C14.1256 2.88803 14.2856 2.28003 14.6056 1.75203C14.9096 1.20803 15.3336 0.784029 15.8776 0.480029C16.4056 0.160029 17.0136 2.86102e-05 17.7016 2.86102e-05H31.2376C31.9256 2.86102e-05 32.5336 0.160029 33.0616 0.480029C33.6056 0.784029 34.0296 1.20803 34.3336 1.75203C34.6536 2.28003 34.8136 2.88803 34.8136 3.57603V3.62403C34.8136 4.31203 34.6536 4.92803 34.3336 5.47203C34.0296 6.00003 33.6056 6.42403 33.0616 6.74403C32.5336 7.04803 31.9256 7.20003 31.2376 7.20003H17.7016C17.0136 7.20003 16.4056 7.04803 15.8776 6.74403C15.3336 6.42403 14.9096 6.00003 14.6056 5.47203C14.2856 4.92803 14.1256 4.31203 14.1256 3.62403V3.57603ZM28.2516 3.57603C28.2516 2.88803 28.4116 2.28003 28.7316 1.75203C29.0356 1.20803 29.4596 0.784029 30.0036 0.480029C30.5316 0.160029 31.1396 2.86102e-05 31.8276 2.86102e-05H45.3636C46.0516 2.86102e-05 46.6596 0.160029 47.1876 0.480029C47.7316 0.784029 48.1556 1.20803 48.4596 1.75203C48.7796 2.28003 48.9396 2.88803 48.9396 3.57603V3.62403C48.9396 4.31203 48.7796 4.92803 48.4596 5.47203C48.1556 6.00003 47.7316 6.42403 47.1876 6.74403C46.6596 7.04803 46.0516 7.20003 45.3636 7.20003H31.8276C31.1396 7.20003 30.5316 7.04803 30.0036 6.74403C29.4596 6.42403 29.0356 6.00003 28.7316 5.47203C28.4116 4.92803 28.2516 4.31203 28.2516 3.62403V3.57603ZM42.3776 3.57603C42.3776 2.88803 42.5376 2.28003 42.8576 1.75203C43.1616 1.20803 43.5856 0.784029 44.1296 0.480029C44.6576 0.160029 45.2656 2.86102e-05 45.9536 2.86102e-05H59.4896C60.1776 2.86102e-05 60.7856 0.160029 61.3136 0.480029C61.8576 0.784029 62.2816 1.20803 62.5856 1.75203C62.9056 2.28003 63.0656 2.88803 63.0656 3.57603V3.62403C63.0656 4.31203 62.9056 4.92803 62.5856 5.47203C62.2816 6.00003 61.8576 6.42403 61.3136 6.74403C60.7856 7.04803 60.1776 7.20003 59.4896 7.20003H45.9536C45.2656 7.20003 44.6576 7.04803 44.1296 6.74403C43.5856 6.42403 43.1616 6.00003 42.8576 5.47203C42.5376 4.92803 42.3776 4.31203 42.3776 3.62403V3.57603ZM56.5036 3.57603C56.5036 2.88803 56.6636 2.28003 56.9836 1.75203C57.2876 1.20803 57.7116 0.784029 58.2556 0.480029C58.7836 0.160029 59.3916 2.86102e-05 60.0796 2.86102e-05H66.9916C67.6796 2.86102e-05 68.2876 0.160029 68.8156 0.480029C69.3596 0.784029 69.7836 1.20803 70.0876 1.75203C70.4076 2.28003 70.5676 2.88803 70.5676 3.57603V3.62403C70.5676 4.31203 70.4076 4.92803 70.0876 5.47203C69.7836 6.00003 69.3596 6.42403 68.8156 6.74403C68.2876 7.04803 67.6796 7.20003 66.9916 7.20003H60.0796C59.3916 7.20003 58.7836 7.04803 58.2556 6.74403C57.7116 6.42403 57.2876 6.00003 56.9836 5.47203C56.6636 4.92803 56.5036 4.31203 56.5036 3.62403V3.57603ZM64.0203 3.57603C64.0203 2.88803 64.1803 2.28003 64.5003 1.75203C64.8043 1.20803 65.2283 0.784029 65.7723 0.480029C66.3003 0.160029 66.9083 2.86102e-05 67.5963 2.86102e-05H81.1323C81.8203 2.86102e-05 82.4283 0.160029 82.9563 0.480029C83.5003 0.784029 83.9243 1.20803 84.2283 1.75203C84.5483 2.28003 84.7083 2.88803 84.7083 3.57603V3.62403C84.7083 4.31203 84.5483 4.92803 84.2283 5.47203C83.9243 6.00003 83.5003 6.42403 82.9563 6.74403C82.4283 7.04803 81.8203 7.20003 81.1323 7.20003H67.5963C66.9083 7.20003 66.3003 7.04803 65.7723 6.74403C65.2283 6.42403 64.8043 6.00003 64.5003 5.47203C64.1803 4.92803 64.0203 4.31203 64.0203 3.62403V3.57603ZM93.1864 3.57603C93.1864 2.88803 93.3464 2.28003 93.6664 1.75203C93.9704 1.20803 94.3944 0.784029 94.9384 0.480029C95.4664 0.160029 96.0744 2.86102e-05 96.7624 2.86102e-05H110.298C110.986 2.86102e-05 111.594 0.160029 112.122 0.480029C112.666 0.784029 113.09 1.20803 113.394 1.75203C113.714 2.28003 113.874 2.88803 113.874 3.57603V3.62403C113.874 4.31203 113.714 4.92803 113.394 5.47203C113.09 6.00003 112.666 6.42403 112.122 6.74403C111.594 7.04803 110.986 7.20003 110.298 7.20003H96.7624C96.0744 7.20003 95.4664 7.04803 94.9384 6.74403C94.3944 6.42403 93.9704 6.00003 93.6664 5.47203C93.3464 4.92803 93.1864 4.31203 93.1864 3.62403V3.57603ZM107.312 3.57603C107.312 2.88803 107.472 2.28003 107.792 1.75203C108.096 1.20803 108.52 0.784029 109.064 0.480029C109.592 0.160029 110.2 2.86102e-05 110.888 2.86102e-05H117.8C118.488 2.86102e-05 119.096 0.160029 119.624 0.480029C120.168 0.784029 120.592 1.20803 120.896 1.75203C121.216 2.28003 121.376 2.88803 121.376 3.57603V3.62403C121.376 4.31203 121.216 4.92803 120.896 5.47203C120.592 6.00003 120.168 6.42403 119.624 6.74403C119.096 7.04803 118.488 7.20003 117.8 7.20003H110.888C110.2 7.20003 109.592 7.04803 109.064 6.74403C108.52 6.42403 108.096 6.00003 107.792 5.47203C107.472 4.92803 107.312 4.31203 107.312 3.62403V3.57603ZM114.829 3.57603C114.829 2.88803 114.989 2.28003 115.309 1.75203C115.613 1.20803 116.037 0.784029 116.581 0.480029C117.109 0.160029 117.717 2.86102e-05 118.405 2.86102e-05H131.941C132.629 2.86102e-05 133.237 0.160029 133.765 0.480029C134.309 0.784029 134.733 1.20803 135.037 1.75203C135.357 2.28003 135.517 2.88803 135.517 3.57603V3.62403C135.517 4.31203 135.357 4.92803 135.037 5.47203C134.733 6.00003 134.309 6.42403 133.765 6.74403C133.237 7.04803 132.629 7.20003 131.941 7.20003H118.405C117.717 7.20003 117.109 7.04803 116.581 6.74403C116.037 6.42403 115.613 6.00003 115.309 5.47203C114.989 4.92803 114.829 4.31203 114.829 3.62403V3.57603ZM128.955 3.57603C128.955 2.88803 129.115 2.28003 129.435 1.75203C129.739 1.20803 130.163 0.784029 130.707 0.480029C131.235 0.160029 131.843 2.86102e-05 132.531 2.86102e-05H139.443C140.131 2.86102e-05 140.739 0.160029 141.267 0.480029C141.811 0.784029 142.235 1.20803 142.539 1.75203C142.859 2.28003 143.019 2.88803 143.019 3.57603V3.62403C143.019 4.31203 142.859 4.92803 142.539 5.47203C142.235 6.00003 141.811 6.42403 141.267 6.74403C140.739 7.04803 140.131 7.20003 139.443 7.20003H132.531C131.843 7.20003 131.235 7.04803 130.707 6.74403C130.163 6.42403 129.739 6.00003 129.435 5.47203C129.115 4.92803 128.955 4.31203 128.955 3.62403V3.57603ZM136.472 3.57603C136.472 2.88803 136.632 2.28003 136.952 1.75203C137.256 1.20803 137.68 0.784029 138.224 0.480029C138.752 0.160029 139.36 2.86102e-05 140.048 2.86102e-05H153.584C154.272 2.86102e-05 154.88 0.160029 155.408 0.480029C155.952 0.784029 156.376 1.20803 156.68 1.75203C157 2.28003 157.16 2.88803 157.16 3.57603V3.62403C157.16 4.31203 157 4.92803 156.68 5.47203C156.376 6.00003 155.952 6.42403 155.408 6.74403C154.88 7.04803 154.272 7.20003 153.584 7.20003H140.048C139.36 7.20003 138.752 7.04803 138.224 6.74403C137.68 6.42403 137.256 6.00003 136.952 5.47203C136.632 4.92803 136.472 4.31203 136.472 3.62403V3.57603ZM150.598 3.57603C150.598 2.88803 150.758 2.28003 151.078 1.75203C151.382 1.20803 151.806 0.784029 152.35 0.480029C152.878 0.160029 153.486 2.86102e-05 154.174 2.86102e-05H167.71C168.398 2.86102e-05 169.006 0.160029 169.534 0.480029C170.078 0.784029 170.502 1.20803 170.806 1.75203C171.126 2.28003 171.286 2.88803 171.286 3.57603V3.62403C171.286 4.31203 171.126 4.92803 170.806 5.47203C170.502 6.00003 170.078 6.42403 169.534 6.74403C169.006 7.04803 168.398 7.20003 167.71 7.20003H154.174C153.486 7.20003 152.878 7.04803 152.35 6.74403C151.806 6.42403 151.382 6.00003 151.078 5.47203C150.758 4.92803 150.598 4.31203 150.598 3.62403V3.57603ZM164.724 3.57603C164.724 2.88803 164.884 2.28003 165.204 1.75203C165.508 1.20803 165.932 0.784029 166.476 0.480029C167.004 0.160029 167.612 2.86102e-05 168.3 2.86102e-05H175.212C175.9 2.86102e-05 176.508 0.160029 177.036 0.480029C177.58 0.784029 178.004 1.20803 178.308 1.75203C178.628 2.28003 178.788 2.88803 178.788 3.57603V3.62403C178.788 4.31203 178.628 4.92803 178.308 5.47203C178.004 6.00003 177.58 6.42403 177.036 6.74403C176.508 7.04803 175.9 7.20003 175.212 7.20003H168.3C167.612 7.20003 167.004 7.04803 166.476 6.74403C165.932 6.42403 165.508 6.00003 165.204 5.47203C164.884 4.92803 164.724 4.31203 164.724 3.62403V3.57603Z",
        fill: "#EEEEEE"
    }));
};
var $0441d74b0f5d32a3$var$Image3 = function Image3() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: "70",
        height: "30",
        viewBox: "0 0 70 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: "0.5",
        y: "0.5",
        width: "29",
        height: "29",
        rx: "4.5",
        stroke: "black",
        strokeOpacity: "0.2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: "40.5",
        y: "0.5",
        width: "29",
        height: "29",
        rx: "4.5",
        stroke: "black",
        strokeOpacity: "0.2"
    }));
};
var $0441d74b0f5d32a3$var$Image4 = function Image4() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: "988",
        height: "26",
        viewBox: "0 0 988 26",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "26",
        height: "26",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: "150",
        width: "26",
        height: "26",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: "300",
        width: "26",
        height: "26",
        rx: "5",
        fill: "#669DF1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: "414",
        width: "26",
        height: "26",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: "564",
        width: "26",
        height: "26",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: "714",
        width: "26",
        height: "26",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: "864",
        width: "26",
        height: "26",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: "39",
        y: "7",
        width: "85",
        height: "12",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: "189",
        y: "7",
        width: "85",
        height: "12",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: "339",
        y: "7",
        width: "51",
        height: "12",
        rx: "5",
        fill: "#E9F2FE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: "453",
        y: "7",
        width: "85",
        height: "12",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: "603",
        y: "7",
        width: "85",
        height: "12",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: "753",
        y: "7",
        width: "85",
        height: "12",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: "903",
        y: "7",
        width: "85",
        height: "12",
        rx: "5",
        fill: "#EEEEEE"
    }));
};

});

parcelRegister("8ZAf4", function(module, exports) {
$parcel$export(module.exports, "SideNav", function () { return $68c0222541525dcd$export$1a35787d6353cf6a; });
/* side-nav.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $1oC0p = parcelRequire("1oC0p");

var $eIrG8 = parcelRequire("eIrG8");

var $80D8g = parcelRequire("80D8g");
var $68c0222541525dcd$var$styles = {
    borderRight: "_hr4je4h9 _1apgnqa1 _mowc14ap"
};
var $68c0222541525dcd$export$1a35787d6353cf6a = function SideNav() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $80D8g.AboveMediumScreen), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eIrG8.default), {
        xcss: $68c0222541525dcd$var$styles.borderRight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($68c0222541525dcd$var$Illustration, {
        alt: ""
    })));
};
var $68c0222541525dcd$var$Illustration = function Illustration(_) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: "262",
        height: "748",
        viewBox: "0 0 262 748",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: "27",
        y: "26",
        width: "26",
        height: "26",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: "27",
        y: "80",
        width: "26",
        height: "26",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: "27",
        y: "134",
        width: "26",
        height: "26",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: "27",
        y: "188",
        width: "26",
        height: "26",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: "27",
        y: "242",
        width: "26",
        height: "26",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: "27",
        y: "296",
        width: "26",
        height: "26",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: "27",
        y: "386",
        width: "26",
        height: "26",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: "27",
        y: "439",
        width: "26",
        height: "26",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: "27",
        y: "492",
        width: "26",
        height: "26",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: "27",
        y: "545",
        width: "26",
        height: "26",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: "66",
        y: "33",
        width: "168",
        height: "12",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: "66",
        y: "87",
        width: "168",
        height: "12",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: "66",
        y: "141",
        width: "168",
        height: "12",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: "66",
        y: "195",
        width: "168",
        height: "12",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: "66",
        y: "249",
        width: "168",
        height: "12",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: "66",
        y: "303",
        width: "168",
        height: "12",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: "66",
        y: "393",
        width: "168",
        height: "12",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: "66",
        y: "446",
        width: "168",
        height: "12",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: "66",
        y: "499",
        width: "168",
        height: "12",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: "66",
        y: "552",
        width: "168",
        height: "12",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: "63",
        y: "336",
        width: "176",
        height: "35",
        rx: "5",
        fill: "#E9F2FE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: "71",
        y: "344",
        width: "18",
        height: "18",
        rx: "5",
        fill: "#669DF1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M94.6 354.864C94.6 354.405 94.7067 354 94.92 353.648C95.1227 353.285 95.4053 353.003 95.768 352.8C96.12 352.587 96.5253 352.48 96.984 352.48H106.008C106.467 352.48 106.872 352.587 107.224 352.8C107.587 353.003 107.869 353.285 108.072 353.648C108.285 354 108.392 354.405 108.392 354.864V354.896C108.392 355.355 108.285 355.765 108.072 356.128C107.869 356.48 107.587 356.763 107.224 356.976C106.872 357.179 106.467 357.28 106.008 357.28H96.984C96.5253 357.28 96.12 357.179 95.768 356.976C95.4053 356.763 95.1227 356.48 94.92 356.128C94.7067 355.765 94.6 355.355 94.6 354.896V354.864ZM104.234 354.864C104.234 354.405 104.34 354 104.554 353.648C104.756 353.285 105.039 353.003 105.402 352.8C105.754 352.587 106.159 352.48 106.618 352.48H115.642C116.1 352.48 116.506 352.587 116.858 352.8C117.22 353.003 117.503 353.285 117.706 353.648C117.919 354 118.026 354.405 118.026 354.864V354.896C118.026 355.355 117.919 355.765 117.706 356.128C117.503 356.48 117.22 356.763 116.858 356.976C116.506 357.179 116.1 357.28 115.642 357.28H106.618C106.159 357.28 105.754 357.179 105.402 356.976C105.039 356.763 104.756 356.48 104.554 356.128C104.34 355.765 104.234 355.355 104.234 354.896V354.864ZM113.868 354.864C113.868 354.405 113.974 354 114.188 353.648C114.39 353.285 114.673 353.003 115.036 352.8C115.388 352.587 115.793 352.48 116.252 352.48H125.276C125.734 352.48 126.14 352.587 126.492 352.8C126.854 353.003 127.137 353.285 127.34 353.648C127.553 354 127.66 354.405 127.66 354.864V354.896C127.66 355.355 127.553 355.765 127.34 356.128C127.137 356.48 126.854 356.763 126.492 356.976C126.14 357.179 125.734 357.28 125.276 357.28H116.252C115.793 357.28 115.388 357.179 115.036 356.976C114.673 356.763 114.39 356.48 114.188 356.128C113.974 355.765 113.868 355.355 113.868 354.896V354.864ZM123.501 354.864C123.501 354.405 123.608 354 123.821 353.648C124.024 353.285 124.307 353.003 124.669 352.8C125.021 352.587 125.427 352.48 125.885 352.48H134.909C135.368 352.48 135.773 352.587 136.125 352.8C136.488 353.003 136.771 353.285 136.973 353.648C137.187 354 137.293 354.405 137.293 354.864V354.896C137.293 355.355 137.187 355.765 136.973 356.128C136.771 356.48 136.488 356.763 136.125 356.976C135.773 357.179 135.368 357.28 134.909 357.28H125.885C125.427 357.28 125.021 357.179 124.669 356.976C124.307 356.763 124.024 356.48 123.821 356.128C123.608 355.765 123.501 355.355 123.501 354.896V354.864ZM133.135 354.864C133.135 354.405 133.242 354 133.455 353.648C133.658 353.285 133.941 353.003 134.303 352.8C134.655 352.587 135.061 352.48 135.519 352.48H140.127C140.586 352.48 140.991 352.587 141.343 352.8C141.706 353.003 141.989 353.285 142.191 353.648C142.405 354 142.511 354.405 142.511 354.864V354.896C142.511 355.355 142.405 355.765 142.191 356.128C141.989 356.48 141.706 356.763 141.343 356.976C140.991 357.179 140.586 357.28 140.127 357.28H135.519C135.061 357.28 134.655 357.179 134.303 356.976C133.941 356.763 133.658 356.48 133.455 356.128C133.242 355.765 133.135 355.355 133.135 354.896V354.864ZM138.363 354.864C138.363 354.405 138.47 354 138.683 353.648C138.886 353.285 139.168 353.003 139.531 352.8C139.883 352.587 140.288 352.48 140.747 352.48H149.771C150.23 352.48 150.635 352.587 150.987 352.8C151.35 353.003 151.632 353.285 151.835 353.648C152.048 354 152.155 354.405 152.155 354.864V354.896C152.155 355.355 152.048 355.765 151.835 356.128C151.632 356.48 151.35 356.763 150.987 356.976C150.635 357.179 150.23 357.28 149.771 357.28H140.747C140.288 357.28 139.883 357.179 139.531 356.976C139.168 356.763 138.886 356.48 138.683 356.128C138.47 355.765 138.363 355.355 138.363 354.896V354.864ZM158.24 354.864C158.24 354.405 158.347 354 158.56 353.648C158.763 353.285 159.045 353.003 159.408 352.8C159.76 352.587 160.165 352.48 160.624 352.48H169.648C170.107 352.48 170.512 352.587 170.864 352.8C171.227 353.003 171.509 353.285 171.712 353.648C171.925 354 172.032 354.405 172.032 354.864V354.896C172.032 355.355 171.925 355.765 171.712 356.128C171.509 356.48 171.227 356.763 170.864 356.976C170.512 357.179 170.107 357.28 169.648 357.28H160.624C160.165 357.28 159.76 357.179 159.408 356.976C159.045 356.763 158.763 356.48 158.56 356.128C158.347 355.765 158.24 355.355 158.24 354.896V354.864ZM167.874 354.864C167.874 354.405 167.98 354 168.194 353.648C168.396 353.285 168.679 353.003 169.042 352.8C169.394 352.587 169.799 352.48 170.258 352.48H174.866C175.324 352.48 175.73 352.587 176.082 352.8C176.444 353.003 176.727 353.285 176.93 353.648C177.143 354 177.25 354.405 177.25 354.864V354.896C177.25 355.355 177.143 355.765 176.93 356.128C176.727 356.48 176.444 356.763 176.082 356.976C175.73 357.179 175.324 357.28 174.866 357.28H170.258C169.799 357.28 169.394 357.179 169.042 356.976C168.679 356.763 168.396 356.48 168.194 356.128C167.98 355.765 167.874 355.355 167.874 354.896V354.864ZM173.101 354.864C173.101 354.405 173.208 354 173.421 353.648C173.624 353.285 173.907 353.003 174.269 352.8C174.621 352.587 175.027 352.48 175.485 352.48H184.509C184.968 352.48 185.373 352.587 185.725 352.8C186.088 353.003 186.371 353.285 186.573 353.648C186.787 354 186.893 354.405 186.893 354.864V354.896C186.893 355.355 186.787 355.765 186.573 356.128C186.371 356.48 186.088 356.763 185.725 356.976C185.373 357.179 184.968 357.28 184.509 357.28H175.485C175.027 357.28 174.621 357.179 174.269 356.976C173.907 356.763 173.624 356.48 173.421 356.128C173.208 355.765 173.101 355.355 173.101 354.896V354.864ZM182.735 354.864C182.735 354.405 182.842 354 183.055 353.648C183.258 353.285 183.54 353.003 183.903 352.8C184.255 352.587 184.66 352.48 185.119 352.48H189.727C190.186 352.48 190.591 352.587 190.943 352.8C191.306 353.003 191.588 353.285 191.791 353.648C192.004 354 192.111 354.405 192.111 354.864V354.896C192.111 355.355 192.004 355.765 191.791 356.128C191.588 356.48 191.306 356.763 190.943 356.976C190.591 357.179 190.186 357.28 189.727 357.28H185.119C184.66 357.28 184.255 357.179 183.903 356.976C183.54 356.763 183.258 356.48 183.055 356.128C182.842 355.765 182.735 355.355 182.735 354.896V354.864ZM187.963 354.864C187.963 354.405 188.069 354 188.283 353.648C188.485 353.285 188.768 353.003 189.131 352.8C189.483 352.587 189.888 352.48 190.347 352.48H199.371C199.829 352.48 200.235 352.587 200.587 352.8C200.949 353.003 201.232 353.285 201.435 353.648C201.648 354 201.755 354.405 201.755 354.864V354.896C201.755 355.355 201.648 355.765 201.435 356.128C201.232 356.48 200.949 356.763 200.587 356.976C200.235 357.179 199.829 357.28 199.371 357.28H190.347C189.888 357.28 189.483 357.179 189.131 356.976C188.768 356.763 188.485 356.48 188.283 356.128C188.069 355.765 187.963 355.355 187.963 354.896V354.864ZM197.596 354.864C197.596 354.405 197.703 354 197.916 353.648C198.119 353.285 198.402 353.003 198.764 352.8C199.116 352.587 199.522 352.48 199.98 352.48H209.004C209.463 352.48 209.868 352.587 210.22 352.8C210.583 353.003 210.866 353.285 211.068 353.648C211.282 354 211.388 354.405 211.388 354.864V354.896C211.388 355.355 211.282 355.765 211.068 356.128C210.866 356.48 210.583 356.763 210.22 356.976C209.868 357.179 209.463 357.28 209.004 357.28H199.98C199.522 357.28 199.116 357.179 198.764 356.976C198.402 356.763 198.119 356.48 197.916 356.128C197.703 355.765 197.596 355.355 197.596 354.896V354.864ZM207.23 354.864C207.23 354.405 207.337 354 207.55 353.648C207.753 353.285 208.036 353.003 208.398 352.8C208.75 352.587 209.156 352.48 209.614 352.48H214.222C214.681 352.48 215.086 352.587 215.438 352.8C215.801 353.003 216.084 353.285 216.286 353.648C216.5 354 216.606 354.405 216.606 354.864V354.896C216.606 355.355 216.5 355.765 216.286 356.128C216.084 356.48 215.801 356.763 215.438 356.976C215.086 357.179 214.681 357.28 214.222 357.28H209.614C209.156 357.28 208.75 357.179 208.398 356.976C208.036 356.763 207.753 356.48 207.55 356.128C207.337 355.765 207.23 355.355 207.23 354.896V354.864Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("filter", {
        id: "filter0_d_8258_51034",
        x: "0",
        y: "0",
        width: "262",
        height: "828",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("feOffset", {
        dx: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("feComposite", {
        in2: "hardAlpha",
        operator: "out"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_8258_51034"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect1_dropShadow_8258_51034",
        result: "shape"
    }))));
};

});

parcelRegister("cZdDd", function(module, exports) {
$parcel$export(module.exports, "Breadcrumbs", function () { return $9745c1739166b7df$export$2dc68d50d56fbbd; });

var $1oC0p = parcelRequire("1oC0p");

var $iPbQS = parcelRequire("iPbQS");
var $9745c1739166b7df$export$2dc68d50d56fbbd = function Breadcrumbs() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $iPbQS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($9745c1739166b7df$var$Illustration, null));
};
var $9745c1739166b7df$var$Illustration = function Illustration() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 167,
        height: 20,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 100,
        height: 6,
        y: 7,
        fill: "#DCDFE4",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 54,
        height: 6,
        x: 113,
        y: 7,
        fill: "#DCDFE4",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#8590A2",
        d: "m108.701 4.664-3.014 12.81h-1.395l3.015-12.81h1.394Z"
    }));
};

});

parcelRegister("hx9Oi", function(module, exports) {
$parcel$export(module.exports, "Content", function () { return $cc3d20d67aac2b43$export$7c6e2c02157bb7d2; });

var $1oC0p = parcelRequire("1oC0p");

var $iPbQS = parcelRequire("iPbQS");
var $cc3d20d67aac2b43$export$7c6e2c02157bb7d2 = function Content() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $iPbQS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($cc3d20d67aac2b43$var$Illustration, null));
};
var $cc3d20d67aac2b43$var$Illustration = function Illustration() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: 640,
        height: 427,
        viewBox: "0 0 640 427",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 640,
        height: 20,
        rx: 6,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        y: 40,
        width: 60,
        height: 32,
        rx: 6,
        fill: "#F1F2F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 8,
        y: 53,
        width: 44,
        height: 6,
        rx: 6,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 68,
        y: 40,
        width: 99,
        height: 32,
        rx: 6,
        fill: "#F1F2F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 76,
        y: 53,
        width: 59,
        height: 6,
        rx: 6,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 24,
        height: 24,
        transform: "translate(138 44)",
        fill: "white",
        fillOpacity: 0.01
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M146.292 54.2929C146.105 54.4818 146 54.7368 146 55.0024C146 55.2681 146.105 55.523 146.292 55.7119L149.231 58.6769C149.449 58.8919 149.731 58.9989 150.01 58.9989C150.289 58.9989 150.566 58.8919 150.779 58.6769L153.709 55.7219C153.895 55.5329 154 55.278 154 55.0124C154 54.7469 153.895 54.492 153.709 54.3029C153.617 54.2098 153.507 54.1358 153.387 54.0853C153.266 54.0347 153.136 54.0087 153.006 54.0087C152.875 54.0087 152.745 54.0347 152.625 54.0853C152.504 54.1358 152.394 54.2098 152.303 54.3029L150.005 56.6199L147.698 54.2929C147.606 54.2001 147.496 54.1264 147.375 54.0762C147.255 54.0259 147.125 54 146.995 54C146.864 54 146.734 54.0259 146.614 54.0762C146.493 54.1264 146.384 54.2001 146.292 54.2929Z",
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        y: 92,
        width: 640,
        height: 12,
        rx: 6,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        y: 120,
        width: 640,
        height: 12,
        rx: 6,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        y: 148,
        width: 640,
        height: 12,
        rx: 6,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        y: 200,
        width: 180,
        height: 12,
        rx: 6,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        y: 232,
        width: 52,
        height: 20,
        rx: 6,
        fill: "#F1F2F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 4,
        y: 239,
        width: 44,
        height: 6,
        rx: 6,
        fill: "#091E42",
        fillOpacity: 0.13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 60,
        y: 232,
        width: 85,
        height: 20,
        rx: 6,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 64,
        y: 239,
        width: 77,
        height: 6,
        rx: 6,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 153,
        y: 232,
        width: 52,
        height: 20,
        rx: 6,
        fill: "#F1F2F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 157,
        y: 239,
        width: 44,
        height: 6,
        rx: 6,
        fill: "#091E42",
        fillOpacity: 0.13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 213,
        y: 232,
        width: 52,
        height: 20,
        rx: 6,
        fill: "#F1F2F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 217,
        y: 239,
        width: 44,
        height: 6,
        rx: 6,
        fill: "#091E42",
        fillOpacity: 0.13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 14,
        y: 282,
        width: 26,
        height: 26,
        rx: 13,
        stroke: "white",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("circle", {
        cx: 27,
        cy: 295,
        r: 12,
        fill: "url(#pattern0_233_6340)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 46,
        y: 279,
        width: 591,
        height: 40,
        rx: 6,
        fill: "#F1F2F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 54,
        y: 295,
        width: 71,
        height: 6,
        rx: 6,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 44.2764,
        y: 385,
        width: 425.66,
        height: 6,
        rx: 6,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 44.2764,
        y: 403,
        width: 267.673,
        height: 6,
        rx: 6,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 44.2764,
        y: 421,
        width: 267.673,
        height: 6,
        rx: 6,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 44,
        y: 356,
        width: 119,
        height: 6,
        rx: 6,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 10,
        y: 346,
        width: 26,
        height: 26,
        rx: 13,
        stroke: "white",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("circle", {
        cx: 23,
        cy: 359,
        r: 12,
        fill: "url(#pattern1_233_6340)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("pattern", {
        id: "pattern0_233_6340",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("use", {
        xlinkHref: "#image0_233_6340",
        transform: "scale(0.0025)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("pattern", {
        id: "pattern1_233_6340",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("use", {
        xlinkHref: "#image1_233_6340",
        transform: "scale(0.0025)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("image", {
        id: "image0_233_6340",
        width: 400,
        height: 400,
        preserveAspectRatio: "none",
        xlinkHref: "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAwADADASIAAhEBAxEB/8QAGwAAAgMBAQEAAAAAAAAAAAAAAwYCBAUACAf/xAAuEAACAQMCBAQGAgMAAAAAAAABAgMABAUGERITITEHQVFhFCJCcYGRMuFiobH/xAAXAQEBAQEAAAAAAAAAAAAAAAAGBwUE/8QAKREAAQMDAgQGAwAAAAAAAAAAAgEDEQAEEgVBBiExURMUInGB8JGx0f/aAAwDAQACEQMRAD8ASqjI6xozuwVFG5J7AVKlzWN0UghtkO3MPE32HYfv/lWK9uUtWCeXb91PrZlX3EbTeoXmqArlbOEMo+uQ7b/ioW2qX4wLq3Xg9Yz1H4NYWNsbrJ5C3sbCB57u4cRxRIN2ZjVrUuEvdOZy7xOUi5d3bPwsPJh5Mp81I6g0IXW7xTnP4hIpMmmW+EY/NO9tcRXUCywOHjbsRRaT9IXTR3z2xPySqSB/kP6pwplp155xhHYhei+9HLy38u6obbV1A0Tp4as8UbS0vbZp8VDKi3Q3IUJwkhSR1HEw26Uesu3z2R0dqqHK4925EskUk0X0y8tgeE/72+5rN4lBwrP0bL/a7NFIBufX2r1tpvR2ndNMz4LD2dlKw2aSNN3I9OI7nb80bUGl8HqJUGcxNnfFBsjTRAso9A3cfurGn8zY6gw1rlMVMJrO5QOjDuPVT6EHoR6irl1cQ2ltLcXUqQwRKXkkc7Kigbkk+QqVqpZSvWqCgjjy6V5R8btI22kddY+4wdktriZ0iAWMnhWXdgy9Tv1A3/dUfOh651bca913PNA8gwlvMHt4yNhwoOEOfdup28t6JVN4VbcG2JT3WgmvGBPogdq6g3VrFewmCZONW8vPf296MASQB1Jp1xOKhso1dlDXBHVj9J9BW/cuAAQaTO1ZDQkpSKxFNfgBgMlp7Tt/zpX+FurkSwROOoAXZiR7nb9VreNmFympdES2ljMUCTJNNGvTmRrvuO/XqQdj6VgYrMX2LLfBTlFbqyEBlP4NFyueyOUj5d3PvF35aKFU/fbvU+c0NwrzxhjCZjn07fVpeGsNpa+EqLlETy/P1K+N2eOjxkZt442Rgfn4v5E+9WKe8jjoL+MiRQJNvlcdx/VIsiFHZG6MpIP3p/aOAQYAkRtRF4SyyJZmv//Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("image", {
        id: "image1_233_6340",
        width: 400,
        height: 400,
        preserveAspectRatio: "none",
        xlinkHref: "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAwADADASIAAhEBAxEB/8QAGwAAAQUBAQAAAAAAAAAAAAAABAADBQYHAQL/xAApEAABAwMDAwQCAwAAAAAAAAABAgMEAAUREiFBBlFxBzFCYROBkdHh/8QAFwEBAQEBAAAAAAAAAAAAAAAABgcEBf/EACkRAAEDAwIFAwUAAAAAAAAAAAECAxEABCEFEgYxUXGRIjLRQaHB4fD/2gAMAwEAAhEDEQA/AH6VKirXCXcJzUds4KjursOTTRa0tpK1GAKizTS3lpbbEqJgdzQoBJwASfquqSUnCgQfsVp9ut0a3tBEZoA8rIypXk07LiMTGi3JaS4k9xuPB4o2eJUb4DZ29Zz4/dO08BulqVPAL6RjzP4rKqVSV/thtc4tglTSxqbUe3Y/YqNpGy6l5AcQZBoPc2zlq6pl0QpJg0qs3QjeZ8hzAwlvT/J/yqzRMCfJt7inIa0pWRjChkHyKz6gwt+3W03zNbdFumrO+bfe9qT9O3zWp0qpULrV+54j2qzuv3FIy60t1KUIA98H3O/1XuR1m9anvxdQ2h6GtadTQacS7qHY+2Kn5tHQdsZ6SJ8VbhdNEbgcdcx5ojr1GY8RzHspSc+QP6qm0dc7vKuykrkANoGShofAHgnk/dA070q3Xb2qW3OfzmozxFeNXuoOPM8sDvAie2KVMyX0x2itW/AA5p6oqfAdWsuNrLmfio7jxW9ZIGK47SUqV6jFWprpJi8QIlwizFRZimxqWydSc/ogg42O9e4/RsS3OG4Xq5KfLe4U5skHjJJJOO1A+mocavT6XVuNthknQThKjkDcc131LbccvEb8LjjqFM50A5SggkbDjNFF2dyq5LZUdpzMfaqa1rVo3p6XEoG9MJiegif7zUew8h9GtB2zinaioEB1Cw44st4+KTufNStK0EkZqZupSFek1//Z"
    })));
};

});

parcelRegister("4N7fh", function(module, exports) {
$parcel$export(module.exports, "DetailsPanel", function () { return $37d15bd8392705dd$export$e54a7f2505304e20; });
/* details-panel.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $1oC0p = parcelRequire("1oC0p");

var $iPbQS = parcelRequire("iPbQS");
var $37d15bd8392705dd$var$styles = {
    wrapper: "_kqsw1n9t _1xi2ze3t _19bvutpp _u5f3xy5q"
};
var $37d15bd8392705dd$export$e54a7f2505304e20 = function DetailsPanel() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $iPbQS.default), {
        xcss: $37d15bd8392705dd$var$styles.wrapper,
        backgroundColor: "elevation.surface"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($37d15bd8392705dd$var$Illustration, null));
};
var $37d15bd8392705dd$var$Illustration = function Illustration() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: 328,
        height: 597,
        viewBox: "0 0 328 597",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 80,
        height: 32,
        rx: 6,
        fill: "#CCE0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 17,
        y: 13,
        width: 44,
        height: 6,
        rx: 6,
        fill: "#85B8FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M0 52C0 47.5817 3.58172 44 8 44H320C324.418 44 328 47.5817 328 52V597H0V52Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M0.5 52C0.5 47.8579 3.85786 44.5 8 44.5H320C324.142 44.5 327.5 47.8579 327.5 52V596.5H0.5V52Z",
        stroke: "#091E42",
        strokeOpacity: 0.06
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 24,
        y: 77,
        width: 253,
        height: 6,
        rx: 6,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 24,
        height: 24,
        transform: "translate(280 68)",
        fill: "white",
        fillOpacity: 0.01
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M288.292 78.2929C288.105 78.4818 288 78.7368 288 79.0024C288 79.2681 288.105 79.523 288.292 79.7119L291.231 82.6769C291.449 82.8919 291.731 82.9989 292.01 82.9989C292.289 82.9989 292.566 82.8919 292.779 82.6769L295.709 79.7219C295.895 79.5329 296 79.278 296 79.0124C296 78.7469 295.895 78.492 295.709 78.3029C295.617 78.2098 295.507 78.1358 295.387 78.0853C295.266 78.0347 295.136 78.0087 295.006 78.0087C294.875 78.0087 294.745 78.0347 294.625 78.0853C294.504 78.1358 294.394 78.2098 294.303 78.3029L292.005 80.6199L289.698 78.2929C289.606 78.2001 289.496 78.1264 289.375 78.0762C289.255 78.0259 289.125 78 288.995 78C288.864 78 288.734 78.0259 288.614 78.0762C288.493 78.1264 288.384 78.2001 288.292 78.2929Z",
        fill: "#091E42",
        fillOpacity: 0.31
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 24,
        y: 121,
        width: 79,
        height: 6,
        rx: 6,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 24,
        y: 159,
        width: 114,
        height: 6,
        rx: 6,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 24,
        y: 197,
        width: 44,
        height: 6,
        rx: 6,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 24,
        y: 235,
        width: 71,
        height: 6,
        rx: 6,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 24,
        y: 273,
        width: 114,
        height: 6,
        rx: 6,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 24,
        y: 311,
        width: 110,
        height: 6,
        rx: 6,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 24,
        y: 349,
        width: 100,
        height: 6,
        rx: 6,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 24,
        y: 387,
        width: 114,
        height: 6,
        rx: 6,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 24,
        y: 425,
        width: 114,
        height: 6,
        rx: 6,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 24,
        y: 463,
        width: 95,
        height: 6,
        rx: 6,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 24,
        height: 24,
        transform: "translate(178 112)",
        fill: "white",
        fillOpacity: 0.01
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M190.522 131.853L190.625 131.781L195.625 127.781C196.056 127.436 196.126 126.807 195.781 126.375C195.462 125.977 194.902 125.887 194.478 126.147L194.375 126.219L190 129.72L185.625 126.219C185.227 125.901 184.66 125.936 184.304 126.282L184.219 126.375C183.901 126.773 183.936 127.34 184.282 127.696L184.375 127.781L189.375 131.781C189.707 132.046 190.166 132.071 190.522 131.853Z",
        fill: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M190.522 126.853L190.625 126.781L195.625 122.781C196.056 122.436 196.126 121.807 195.781 121.375C195.462 120.977 194.902 120.887 194.478 121.147L194.375 121.219L190 124.72L185.625 121.219C185.227 120.901 184.66 120.936 184.304 121.282L184.219 121.375C183.901 121.773 183.936 122.34 184.282 122.696L184.375 122.781L189.375 126.781C189.707 127.046 190.166 127.071 190.522 126.853Z",
        fill: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M190.522 121.853L190.625 121.781L195.625 117.781C196.056 117.436 196.126 116.807 195.781 116.375C195.462 115.977 194.902 115.887 194.478 116.147L194.375 116.219L190 119.72L185.625 116.219C185.227 115.901 184.66 115.936 184.304 116.282L184.219 116.375C183.901 116.773 183.936 117.34 184.282 117.696L184.375 117.781L189.375 121.781C189.707 122.046 190.166 122.071 190.522 121.853Z",
        fill: "#4C9AFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 210,
        y: 121,
        width: 66,
        height: 6,
        rx: 6,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 178,
        y: 159,
        width: 98,
        height: 6,
        rx: 6,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 178,
        y: 188,
        width: 52,
        height: 20,
        rx: 6,
        fill: "#F1F2F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 182,
        y: 195,
        width: 44,
        height: 6,
        rx: 6,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("g", {
        opacity: 0.8
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 177,
        y: 230,
        width: 18,
        height: 18,
        rx: 9,
        stroke: "white",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("circle", {
        cx: 186,
        cy: 239,
        r: 8,
        fill: "url(#pattern0_233_6342)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 202,
        y: 236,
        width: 71,
        height: 6,
        rx: 6,
        fill: "#DCDFE4"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 178,
        y: 273,
        width: 126,
        height: 6,
        rx: 6,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 178,
        y: 311,
        width: 126,
        height: 6,
        rx: 6,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 178,
        y: 349,
        width: 126,
        height: 6,
        rx: 6,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 178,
        y: 387,
        width: 126,
        height: 6,
        rx: 6,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 178,
        y: 425,
        width: 126,
        height: 6,
        rx: 6,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        x: 178,
        y: 463,
        width: 126,
        height: 6,
        rx: 6,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("pattern", {
        id: "pattern0_233_6342",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("use", {
        xlinkHref: "#image0_233_6342",
        transform: "scale(0.0025)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("image", {
        id: "image0_233_6342",
        width: 400,
        height: 400,
        preserveAspectRatio: "none",
        xlinkHref: "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAwADADASIAAhEBAxEB/8QAGwAAAgIDAQAAAAAAAAAAAAAAAAcDBgQFCAH/xAAsEAABAwMCBQMDBQAAAAAAAAABAgMEAAURBiESEzFBUQeBkSJhcRQVMjOh/8QAFwEBAQEBAAAAAAAAAAAAAAAABwYEBf/EACkRAAEEAQIFBAIDAAAAAAAAAAECAwQRAAVREyExYYEGEnGhB0GisfD/2gAMAwEAAhEDEQA/AKVRRWXa4S7hObjt7FR3PgdzTLIkNxmlPvGkpBJOwHXDtllb7iWmxalGgO5zFSCo4SCT4FCkKQcKSUn7jFOpnRMqzx0CLDS4CASto8Sj+e9TtaQm3VBblREIaPeQMfA60YufktYlcJuEoo3ujW9VX8vOXSPRCSxxFyUhW1cvi7v68YjaK3GqLOqz3JbIyWiTw57YOCPatPSTAnM6hHRKjm0KFj/bg8j3yJlxXIbymHhSk9cKYXo9ZjOvBlvI4oqFBk468WOLf7fT/tL2rHorVc3S9wDkdQVFcUnntKGeJIO+PBxnesevQXJ8ByM11VXX9gEEjyBWatIlIiS0POdBf9EA+M6foqKLIalRmpEdYcZdQFoUOikkZBqU0QkEGjiMCCLGJj1ss/JImR0HlBaVOE9ApeRt7ppSVd/U3WMjUF1fhsOj9qju4aSkf2EbcZPffOPtVIpV9M6e5p0BLLnKyVVt7jdfeH+uzETJZcRsBe9csK9QlS1hKElSj0AGSakiR1ypTTDQytxQSKY9stsa3NBMdAC8fU4f5K9660mUlgVVk5zmWC78YxPTX9XC0Xa2ZjauMIKglWykpKiQPgitzfHJEu0TY8RPA86wtCFZ34ikgVW7Xq3ltJbuDKnCnbmN4yfyKnnawZ5ZEGMsuHop3AA9h1otf0+Y5KU57OZUT25m8v2Z0REcI93QV36VnO8iO9GcLchpbTg2KVpII+ajpqXdhF35huA5q1nJX3B8jxSzuEVUKa9HXuW1Yz5HY/FKESXxxShSsgZDHCNg2M//2Q=="
    })));
};

});

parcelRegister("273CW", function(module, exports) {
$parcel$export(module.exports, "SideNav", function () { return $189f0c79163f6018$export$1a35787d6353cf6a; });
/* side-nav.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $1oC0p = parcelRequire("1oC0p");

var $iPbQS = parcelRequire("iPbQS");

var $80D8g = parcelRequire("80D8g");
var $189f0c79163f6018$var$styles = {
    background: "_1s7zia51 _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"
};
var $189f0c79163f6018$export$1a35787d6353cf6a = function SideNav() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $80D8g.AboveMediumScreen), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $iPbQS.default), {
        xcss: $189f0c79163f6018$var$styles.background
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($189f0c79163f6018$var$Illustration, null)));
};
var $189f0c79163f6018$var$Illustration = function Illustration() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 296,
        height: 473,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("g", {
        clipPath: "url(#a)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 5.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 9,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 17.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 48.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 52.96,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 60.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "m283.939 64.5-3.969-3.97 1.06-1.06 4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 91.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 95.96,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 103.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "m283.939 107.5-3.969-3.97 1.06-1.06 4.5 4.5a.749.749 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 134.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 138.96,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 146.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "M265.25 151.25v4.25h1.5v-4.25H271v-1.5h-4.25v-4.25h-1.5v4.25H261v1.5h4.25ZM285.25 150.75a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        d: "M285.5 150.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM290.25 150.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM295 150.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 72,
        height: 9,
        x: 20,
        y: 189,
        fill: "#B3B9C4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 278,
        height: 43,
        x: 18,
        y: 215,
        fill: "#E9F2FF",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M22 220.5h32v32H22z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 24,
        height: 24,
        x: 26,
        y: 224,
        fill: "#85B8FF",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#1868DB",
        d: "M18 229h2.66v15.96H18z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 112,
        height: 8,
        x: 66,
        y: 232.5,
        fill: "#85B8FF",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "M259.25 237.25v4.25h1.5v-4.25H265v-1.5h-4.25v-4.25h-1.5v4.25H255v1.5h4.25ZM279.25 236.75a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        d: "M279.5 236.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM284.25 236.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM289 236.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M22 263.5h32v32H22z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 24,
        height: 24,
        x: 26,
        y: 267,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 112,
        height: 8,
        x: 66,
        y: 275.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M22 306.5h32v32H22z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 24,
        height: 24,
        x: 26,
        y: 310,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 112,
        height: 8,
        x: 66,
        y: 318.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M20 349.5h32v32H20z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "M39 360.5H25V359h14v1.5Zm0 5.25H25v-1.5h14v1.5ZM32 371h-7v-1.5h7v1.5Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 112,
        height: 8,
        x: 64,
        y: 361.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 392.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 396.96,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 404.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "m283.939 408.5-3.969-3.97 1.06-1.06 4.5 4.5a.749.749 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 435.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "M9.667 451.333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM8 451a1.667 1.667 0 1 1 3.335 0A1.667 1.667 0 0 1 8 451Zm8 .333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM14.333 451a1.667 1.667 0 1 1 3.335 0 1.667 1.667 0 0 1-3.335 0Zm8 .333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM20.667 451A1.667 1.667 0 1 1 24 451a1.667 1.667 0 0 1-3.334 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        d: "M10 451a.333.333 0 1 1-.666 0 .333.333 0 0 1 .666 0ZM16.333 451a.333.333 0 1 1-.666 0 .333.333 0 0 1 .666 0ZM22.667 451a.333.333 0 1 1-.667 0 .333.333 0 0 1 .667 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: 60,
        height: 8,
        x: 44,
        y: 447.5,
        fill: "#DCDFE4",
        rx: 3.99
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("clipPath", {
        id: "a"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fill: "#fff",
        d: "M0 0h296v473H0z"
    }))));
};

});



parcelRegister("6hsym", function(module, exports) {
$parcel$export(module.exports, "Modal", function () { return $8664d6c5a5bd6fdd$export$2b77a92f1a5ad772; });
/* modal.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $5YGzb = parcelRequire("5YGzb");
const $8664d6c5a5bd6fdd$export$2b77a92f1a5ad772 = ({ children: children, showBrandFooter: showBrandFooter, showProductLogoOnLargeScreens: showProductLogoOnLargeScreens, size: size, productLogo: productLogo, moveLogoToModal: moveLogoToModal })=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const logoLabel = formatMessage({
        defaultMessage: 'Atlassian logo',
        id: 'signup.layouts.modal.atlassianLogoLabel'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "data-testid": "modal",
        className: (0, $2jatx.default)([
            "_4cvr1h6o _1e0c1txw _2lx21bp4 _ca0q1tcg _u5f31tcg _n3td1tcg _19bv1tcg _e8gh1y6m _15y11kxc _6ytt1epz _af4y1496",
            !moveLogoToModal && "_zulpxy5q",
            showProductLogoOnLargeScreens && "_1q511ejb _1waf1jfw"
        ]),
        children: [
            productLogo && moveLogoToModal && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1bah1h6o _18s8l2uw _l8n0u67f _kiyaze3t",
                    !showProductLogoOnLargeScreens && "_181nagmp"
                ]),
                children: productLogo
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1reo15vq _18m915vq _v5641xr4 _p12f1osq _1jb3vuon _1kkm1crf _nxbc130s _15y11kdj",
                    size === 'sm' && "_1bsbufrr",
                    size === 'md' && "_1bsb1ilo",
                    size === 'lg' && "_1bsb11bw"
                ]),
                children: children
            }),
            showBrandFooter && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    moveLogoToModal && "_1pfhxy5q"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        "aria-hidden": "true",
                        className: (0, $2jatx.default)([
                            "_181nagmp"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5YGzb.AtlassianLogo), {
                            appearance: "brand",
                            size: "small",
                            testId: "atlassian-logo-sm-screen",
                            label: logoLabel
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        "aria-hidden": "true",
                        className: (0, $2jatx.default)([
                            "_1e0cglyw _181ntcjq"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5YGzb.AtlassianLogo), {
                            appearance: "inverse",
                            size: "small",
                            testId: "atlassian-logo-lg-screen",
                            label: logoLabel
                        })
                    })
                ]
            })
        ]
    });
};
const $8664d6c5a5bd6fdd$var$hideAboveSmCss = null;
const $8664d6c5a5bd6fdd$var$lgVisibleCss = null;
const $8664d6c5a5bd6fdd$var$modalCss = null;
const $8664d6c5a5bd6fdd$var$smModalCss = null;
const $8664d6c5a5bd6fdd$var$mdModalCss = null;
const $8664d6c5a5bd6fdd$var$lgModalCss = null;
const $8664d6c5a5bd6fdd$var$positioningCss = null;
const $8664d6c5a5bd6fdd$var$footerCss = null;
const $8664d6c5a5bd6fdd$var$positioningCssWithGap = null;
const $8664d6c5a5bd6fdd$var$logoWrapper = null;
const $8664d6c5a5bd6fdd$var$noPositioningTopPaddingCss = null;

});


//# sourceMappingURL=confirmation-page.4a84ffdb.js.map
